import { useState, useEffect, useRef, useCallback } from "react";
import { createClient } from "@supabase/supabase-js";

const SURL = "https://ujctmfnryuddkaaueehp.supabase.co";
const SKEY = "sb_publishable_mVYtsm4iQZfFbwq7sKupmA_tYi1FrlQ";
const sb = createClient(SURL, SKEY);

const C = {
  teal1:"#6AAFAA",teal2:"#4A9090",blue1:"#4A7BAF",blue2:"#2D4F72",
  bg:"#F4F7FA",white:"#FFFFFF",text:"#1A2B3C",muted:"#6B8299",
  border:"#D1DCE8",red:"#C0392B",green2:"#27AE60",accentLight:"#EAF1FA",
  navBg:"#1E3448",
};
const SR="'Georgia','Times New Roman',serif";
const SN="'Inter',system-ui,sans-serif";
const EMOJIS=["😂","😅","🫠","😊","🤩","🤗","🫣","🤔","😎","🥳","😯","🙈","🙂","🤝🏻","👍🏻","👏","💪","🙏🏻","🙌🏻","💡","💪🏻","💃🏻","💃🏼","💙","💯"];
const DAILY_QUOTES=["Erfolg ist kein Zufall – er ist das Ergebnis täglicher Entscheidungen.","Große Dinge entstehen nicht durch Impulse allein, sondern durch eine Summe kleiner Dinge.","Wer aufhört, besser zu werden, hat aufgehört, gut zu sein.","Der beste Zeitpunkt war gestern. Der zweitbeste ist heute.","Qualität ist kein Akt, sondern eine Gewohnheit.","Vision ohne Umsetzung ist nur ein Tagtraum."];
const getDailyQuote=()=>DAILY_QUOTES[new Date().getDate()%DAILY_QUOTES.length];
const DAYS=["Mo","Di","Mi","Do","Fr","Sa","So"];
const MONTHS=["Jan","Feb","Mär","Apr","Mai","Jun","Jul","Aug","Sep","Okt","Nov","Dez"];
const MONTHSL=["Jänner","Februar","März","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember"];
const ROLE_L={admin:"Admin",employee:"Mitarbeiter",client:"Kunde"};
const BCOLS=[
  {n:"Weiß",v:"#ffffff"},{n:"Hellgrau",v:"#f0f0f0"},{n:"Mittelgrau",v:"#d8d8d8"},{n:"Dunkelgrau",v:"#b0b0b0"},
  {n:"Hellblau",v:"#EAF1FA"},{n:"Blau",v:"#c8ddf0"},{n:"Kräftig Blau",v:"#93c5fd"},{n:"Navy",v:"#dce8f5"},
  {n:"Teal",v:"#d0eeec"},{n:"Mintgrün",v:"#d1fae5"},{n:"Grün",v:"#a7f3d0"},{n:"Salbei",v:"#b7d5c8"},
  {n:"Hellgold",v:"#f5edd8"},{n:"Sandbeige",v:"#e8dcc8"},{n:"Taupe",v:"#d4c4b0"},{n:"Gold",v:"#fde68a"},
  {n:"Hellrosa",v:"#fce7f3"},{n:"Rosa",v:"#fbcfe8"},{n:"Lachs",v:"#fed7aa"},{n:"Hellgelb",v:"#fef9c3"},
  {n:"Lavendel",v:"#ede9fe"},{n:"Flieder",v:"#ddd6fe"},{n:"Hellgrün",v:"#dcfce7"},{n:"Cremeweiß",v:"#fafaf9"},
];
const TMPLS={linkedin:{name:"LinkedIn Pipeline",icon:"LI",columns:["Idee","In Arbeit","Zur Abnahme","Freigegeben","Veröffentlicht"]},internal:{name:"Internes Board",icon:"IN",columns:["Backlog","In Bearbeitung","Zur Abnahme","Erledigt"]},marketing:{name:"Marketing",icon:"MK",columns:["Ideen","Planung","Umsetzung","Review","Live"]},onboarding:{name:"Onboarding",icon:"OB",columns:["Vorbereitung","Woche 1","Woche 2","Abschluss"]},general:{name:"Allg. Projekt",icon:"AP",columns:["To Do","In Progress","Review","Done"]}};

const uid=()=>Math.random().toString(36).slice(2,9);
const nowT=()=>new Date().toLocaleTimeString("de-AT",{hour:"2-digit",minute:"2-digit"});
const today=()=>{const d=new Date();return d.getFullYear()+"-"+String(d.getMonth()+1).padStart(2,"0")+"-"+String(d.getDate()).padStart(2,"0");};
const readFile=f=>new Promise(res=>{const r=new FileReader();r.onload=e=>res({name:f.name,type:f.type,size:f.size,data:e.target.result});r.readAsDataURL(f);});
const isImg=f=>f&&f.type&&f.type.startsWith("image/");
const fmtSize=b=>b<1024?b+"B":b<1048576?(b/1024).toFixed(1)+"KB":(b/1048576).toFixed(1)+"MB";
const firstImg=files=>(files||[]).find(f=>isImg(f));
function toLocalDate(d){
  return d.getFullYear()+"-"+String(d.getMonth()+1).padStart(2,"0")+"-"+String(d.getDate()).padStart(2,"0");
}
function weekDays(off=0){const d=new Date();d.setHours(0,0,0,0);d.setDate(d.getDate()-(d.getDay()+6)%7+off*7);return Array.from({length:7},(_,i)=>{const x=new Date(d);x.setDate(d.getDate()+i);return toLocalDate(x);});}
function kw(d){const t=new Date(d);t.setHours(0,0,0,0);t.setDate(t.getDate()+3-(t.getDay()+6)%7);const w=new Date(t.getFullYear(),0,4);return 1+Math.round(((t-w)/86400000-3+(w.getDay()+6)%7)/7);}

// ── Atoms ──
function Av({name,color,size=30}){const t=(name||"?").split(" ").map(w=>w[0]).join("").slice(0,2).toUpperCase();return <span style={{width:size,height:size,borderRadius:"50%",background:color||C.blue2,color:"#fff",display:"inline-flex",alignItems:"center",justifyContent:"center",fontSize:size*.38,fontWeight:700,flexShrink:0}}>{t}</span>;}
function Btn({onClick,children,outline,sm,full,disabled,style={},color}){const bg=color||(outline?"transparent":C.blue2);const txt=outline?(color||C.blue2):"#fff";const bc=color||C.blue2;return <button onClick={onClick} disabled={disabled} style={{padding:sm?"6px 14px":"10px 24px",borderRadius:6,border:"1.5px solid "+bc,background:bg,color:txt,fontWeight:600,cursor:disabled?"default":"pointer",fontSize:sm?12:14,fontFamily:SN,width:full?"100%":"auto",opacity:disabled?0.5:1,...style}}>{children}</button>;}
function Inp({style={},...p}){return <input {...p} style={{padding:"9px 14px",borderRadius:6,border:"1.5px solid "+C.border,fontSize:14,outline:"none",background:"#fff",fontFamily:SN,boxSizing:"border-box",...style}}/>;}
function Panel({children,style={}}){return <div style={{background:C.white,borderRadius:10,padding:24,border:"1px solid "+C.border,boxShadow:"0 2px 8px rgba(45,79,114,0.06)",...style}}>{children}</div>;}
function H1({children}){return <h2 style={{fontFamily:SR,fontSize:28,fontWeight:400,color:C.text,margin:"0 0 24px"}}>{children}</h2>;}
function H2({children,style={}}){return <h3 style={{fontFamily:SR,fontSize:18,fontWeight:400,color:C.text,margin:"0 0 14px",...style}}>{children}</h3>;}
function Badge({n}){if(!n)return null;return <span style={{background:C.red,color:"#fff",borderRadius:99,fontSize:9,fontWeight:700,padding:"1px 5px",display:"inline-block",minWidth:14,textAlign:"center"}}>{n}</span>;}
function Tag({children,color}){return <span style={{display:"inline-block",padding:"2px 9px",borderRadius:99,background:color+"22",color,fontSize:11,fontWeight:700,border:"1px solid "+color+"44"}}>{children}</span>;}
function Spinner(){return <div style={{display:"flex",alignItems:"center",justifyContent:"center",height:"100vh",background:C.bg}}><div style={{fontFamily:SR,fontSize:20,color:C.blue2}}>Laden…</div></div>;}

function EmojiPicker({onPick}){
  const [open,setOpen]=useState(false);
  return(
    <div style={{position:"relative",display:"inline-block"}}>
      {open&&<div onClick={()=>setOpen(false)} style={{position:"fixed",inset:0,zIndex:48}}/>}
      <button type="button" onClick={()=>setOpen(p=>!p)} style={{background:"none",border:"1px solid "+C.border,borderRadius:6,padding:"6px 10px",cursor:"pointer",fontSize:16,color:C.muted}}>😊</button>
      {open&&<div style={{position:"fixed",bottom:80,right:20,background:C.white,border:"1px solid "+C.border,borderRadius:8,padding:8,boxShadow:"0 8px 24px rgba(0,0,0,0.12)",zIndex:499,display:"flex",flexWrap:"wrap",gap:4,width:220,maxHeight:200,overflowY:"auto"}}>
        {EMOJIS.map(e=><button key={e} onClick={()=>{onPick(e);setOpen(false);}} style={{background:"none",border:"none",cursor:"pointer",fontSize:20,padding:"3px",borderRadius:4}}>{e}</button>)}
      </div>}
    </div>
  );
}

function MsgBox({users,onSend,placeholder,minRows=3}){
  const [text,setText]=useState("");
  const ref=useRef();
  function addEmoji(e){setText(p=>p+e);if(ref.current)ref.current.focus();}
  function send(){if(!text.trim())return;onSend(text);setText("");}
  return(
    <div style={{border:"1.5px solid "+C.border,borderRadius:8,background:"#fff",overflow:"hidden"}}>
      <textarea ref={ref} value={text} onChange={e=>setText(e.target.value)} placeholder={placeholder||"Nachricht…"} onKeyDown={e=>{if(e.key==="Enter"&&e.ctrlKey)send();}}
        style={{width:"100%",minHeight:minRows*28,padding:"10px 14px",border:"none",outline:"none",fontSize:14,fontFamily:SN,resize:"vertical",boxSizing:"border-box",lineHeight:1.6}}/>
      <div style={{display:"flex",alignItems:"center",gap:8,padding:"8px 12px",borderTop:"1px solid "+C.border,background:"#fafbfc"}}>
        <EmojiPicker onPick={addEmoji}/>
        <span style={{fontSize:11,color:C.muted,flex:1}}>Strg+Enter zum Senden</span>
        <Btn sm onClick={send}>Senden</Btn>
      </div>
    </div>
  );
}

// ── Login ──
// ── Legal Modal ──
const IMPRESSUM_TEXT=`Andrea Winkler
Am Berg 23
6391 Fieberbrunn
Österreich

Unternehmensgegenstand: Werbeagentur
Berufsrecht: Gewerbeordnung (GewO)

E-Mail: kontakt@brvhkommunikation.at

Ich bin nicht bereit und nicht verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.`;

const DATENSCHUTZ_TEXT=`Stand: April 2026

1. Verantwortliche
Andrea Winkler, Am Berg 23, 6391 Fieberbrunn
E-Mail: kontakt@brvhkommunikation.at

2. Allgemeines
Der Schutz Ihrer persönlichen Daten ist mir ein besonderes Anliegen. Ich verarbeite Ihre Daten ausschließlich auf Grundlage der gesetzlichen Bestimmungen (DSGVO, TKG 2021).

3. Zugang zur Plattform
Der Zugang ist ausschließlich eingeladenen Personen vorbehalten. Eine öffentliche Registrierung ist nicht möglich.

4. Welche Daten ich verarbeite
• Zugangsdaten: E-Mail-Adresse und Passwort (verschlüsselt)
• Profildaten: Name, Rolle, Profilfarbe
• Inhalte: Nachrichten, To-Dos, Kommentare, hochgeladene Dateien
• Nutzungsdaten: Zeitpunkte der Anmeldung (technisch erforderlich)

5. Zweck der Verarbeitung
Ausschließlich für den Betrieb der internen Projektmanagement-Plattform.
Rechtsgrundlage: Art. 6 Abs. 1 lit. b und lit. f DSGVO

6. Datenweitergabe
Nur an technisch notwendige Dienstleister:
• Supabase Inc. (Datenbankhosting)
• Vercel Inc. (Hosting der Webanwendung)
Beide sind gemäß EU-US Data Privacy Framework zertifiziert.

7. Speicherdauer
Solange Ihr Zugang aktiv ist. Nach Beendigung der Zusammenarbeit Löschung innerhalb von 30 Tagen.

8. Ihre Rechte
Auskunft (Art. 15), Berichtigung (Art. 16), Löschung (Art. 17), Einschränkung (Art. 18), Datenübertragbarkeit (Art. 20), Widerspruch (Art. 21 DSGVO).
Kontakt: kontakt@brvhkommunikation.at

9. Beschwerderecht
Österreichische Datenschutzbehörde
Barichgasse 40–42, 1030 Wien
www.dsb.gv.at

10. Cookies
Nur technisch notwendige Cookies für die Anmeldesitzung. Kein Tracking.`;

function LegalModal({title,text,onClose}){
  return(
    <div onClick={onClose} style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",zIndex:999,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
      <div onClick={e=>e.stopPropagation()} style={{background:C.white,borderRadius:12,width:"100%",maxWidth:560,maxHeight:"80vh",display:"flex",flexDirection:"column",boxShadow:"0 30px 80px rgba(0,0,0,0.25)"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"18px 24px",borderBottom:"1px solid "+C.border,background:"linear-gradient(135deg,#1E3448,#2D4F72)",borderRadius:"12px 12px 0 0"}}>
          <span style={{fontFamily:SR,fontSize:17,color:"#fff"}}>{title}</span>
          <button onClick={onClose} style={{border:"none",background:"rgba(255,255,255,0.15)",color:"#fff",cursor:"pointer",fontSize:18,borderRadius:6,width:32,height:32,display:"flex",alignItems:"center",justifyContent:"center"}}>×</button>
        </div>
        <div style={{overflowY:"auto",padding:"20px 24px"}}>
          {text.split("\n").map((line,i)=>(
            <p key={i} style={{margin:"0 0 6px",fontSize:13,color:C.text,fontWeight:line.match(/^\d+\./)?"700":"400",lineHeight:1.7,whiteSpace:"pre-wrap"}}>{line||"\u00a0"}</p>
          ))}
        </div>
      </div>
    </div>
  );
}

function Login({onLogin}){
  const [email,setEmail]=useState("");
  const [pass,setPass]=useState("");
  const [err,setErr]=useState("");
  const [loading,setLoading]=useState(false);
  const [legal,setLegal]=useState(null);
  async function doLogin(){
    if(!email||!pass){setErr("Bitte E-Mail und Passwort eingeben");return;}
    setLoading(true);setErr("");
    const{error}=await sb.auth.signInWithPassword({email,password:pass});
    if(error){setErr("Ungültige Anmeldedaten");setLoading(false);return;}
    setLoading(false);
  }
  return(
    <div style={{minHeight:"100vh",background:"linear-gradient(135deg,#1E3448 0%,#2D4F72 50%,#4A7BAF 100%)",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",fontFamily:SN,padding:"20px"}}>
      {legal==="impressum"&&<LegalModal title="Impressum" text={IMPRESSUM_TEXT} onClose={()=>setLegal(null)}/>}
      {legal==="datenschutz"&&<LegalModal title="Datenschutzerklärung" text={DATENSCHUTZ_TEXT} onClose={()=>setLegal(null)}/>}
      <div style={{width:"100%",maxWidth:440,background:C.white,borderRadius:16,boxShadow:"0 24px 64px rgba(0,0,0,0.2)",overflow:"hidden"}}>
        <div style={{padding:"40px 44px 32px",textAlign:"center",background:"linear-gradient(135deg,#1E3448,#2D4F72)"}}>
          <div style={{display:"flex",justifyContent:"center",gap:6,marginBottom:14}}>
            {[["B","#6AAFAA"],["R","#4A9090"],["V","#4A7BAF"],["H","#2D4F72"]].map(([l,bg])=>(
              <div key={l} style={{width:44,height:44,background:bg,borderRadius:6,display:"flex",alignItems:"center",justifyContent:"center",fontSize:22,fontWeight:700,color:"#fff",fontFamily:SR}}>{l}</div>
            ))}
          </div>
          <div style={{fontFamily:SR,fontSize:13,color:"rgba(255,255,255,0.55)",letterSpacing:3,textTransform:"uppercase"}}>Strategieraum</div>
        </div>
        <div style={{padding:"32px 40px 36px"}}>
          <p style={{fontFamily:SR,fontSize:20,color:C.text,marginBottom:20}}>Anmelden</p>
          <Inp value={email} onChange={e=>setEmail(e.target.value)} placeholder="E-Mail" type="email" style={{width:"100%",marginBottom:12}}/>
          <Inp value={pass} onChange={e=>setPass(e.target.value)} type="password" placeholder="Passwort" style={{width:"100%",marginBottom:20}} onKeyDown={e=>{if(e.key==="Enter")doLogin();}}/>
          {err&&<p style={{color:C.red,fontSize:13,marginBottom:12}}>{err}</p>}
          <Btn onClick={doLogin} full disabled={loading}>{loading?"Laden…":"Anmelden"}</Btn>
        </div>
      </div>
      <div style={{marginTop:20,display:"flex",gap:16,alignItems:"center"}}>
        <button onClick={()=>setLegal("impressum")} style={{background:"none",border:"none",color:"rgba(255,255,255,0.5)",cursor:"pointer",fontSize:12,fontFamily:SN,textDecoration:"underline"}}>Impressum</button>
        <span style={{color:"rgba(255,255,255,0.25)"}}>·</span>
        <button onClick={()=>setLegal("datenschutz")} style={{background:"none",border:"none",color:"rgba(255,255,255,0.5)",cursor:"pointer",fontSize:12,fontFamily:SN,textDecoration:"underline"}}>Datenschutz</button>
      </div>
      <div style={{marginTop:8,fontSize:11,color:"rgba(255,255,255,0.25)",fontFamily:SN}}>© {new Date().getFullYear()} Andrea Winkler</div>
    </div>
  );
}


// ── Main App ──
export default function App(){
  const [session,setSession]=useState(null);
  const [profile,setProfile]=useState(null);
  const [profiles,setProfiles]=useState([]);
  const [boards,setBoards]=useState({});
  const [boardCategories,setBoardCategories]=useState([]);
  const [boardTemplates,setBoardTemplates]=useState([]);
  const [messages,setMessages]=useState([]);
  const [todos,setTodos]=useState({});
  const [meetings,setMeetings]=useState([]);
  const [notifications,setNotifications]=useState([]);
  const [prospects,setProspects]=useState([]);
  const [personalTodos,setPersonalTodos]=useState([]);
  const [recurringTodos,setRecurringTodos]=useState([]);
  const [recurringDone,setRecurringDone]=useState({});
  const [vacations,setVacations]=useState([]);
  const [timeBoards,setTimeBoards]=useState({});
  const [training,setTraining]=useState([]);
  const [loading,setLoading]=useState(true);
  const [view,setView]=useState(()=>{try{return sessionStorage.getItem("sv_view")||"dashboard";}catch{return "dashboard";}});
  const [activeBoard,setActiveBoard]=useState(()=>{try{return sessionStorage.getItem("sv_board")||null;}catch{return null;}});
  const [chatDmWith,setChatDmWith]=useState(null);
  const savingBoardIds=useRef(new Set());

  // Persist navigation state so tab switches don't lose position
  function persistNav(v,b){
    try{
      if(v)sessionStorage.setItem("sv_view",v);
      if(b)sessionStorage.setItem("sv_board",b);
      else sessionStorage.removeItem("sv_board");
    }catch{}
  }
  const [navOpen,setNavOpen]=useState(false);
  const [isMobile,setIsMobile]=useState(window.innerWidth<=768);

  const [needsPasswordSet,setNeedsPasswordSet]=useState(false);
  const [newPassword,setNewPassword]=useState("");
  const [newPasswordConfirm,setNewPasswordConfirm]=useState("");
  const [passwordMsg,setPasswordMsg]=useState("");

  // Responsive listener
  useEffect(()=>{
    const handler=()=>setIsMobile(window.innerWidth<=768);
    window.addEventListener("resize",handler);
    return()=>window.removeEventListener("resize",handler);
  },[]);

  // Service Worker registrieren
  useEffect(()=>{
    if("serviceWorker" in navigator){
      navigator.serviceWorker.register("/sw.js").catch(()=>{});
    }
  },[]);

  // Warn on page refresh if user might lose data
  useEffect(()=>{
    const handler=(e)=>{e.preventDefault();e.returnValue="";};
    window.addEventListener("beforeunload",handler);
    return()=>window.removeEventListener("beforeunload",handler);
  },[]);

  // Tab visibility - do nothing on tab switch to prevent reload
  useEffect(()=>{
    // intentionally empty - realtime subscriptions handle live updates
  },[]);

  // Auth
  useEffect(()=>{
    // Token aus URL Hash verarbeiten (Supabase hängt Token als Hash an)
    const hash=window.location.hash;
    if(hash&&hash.includes("access_token")){
      // Hash in Query-Parameter umwandeln damit Supabase ihn lesen kann
      const hashParams=new URLSearchParams(hash.replace("#",""));
      const accessToken=hashParams.get("access_token");
      const refreshToken=hashParams.get("refresh_token");
      const type=hashParams.get("type");
      if(accessToken&&refreshToken){
        sb.auth.setSession({access_token:accessToken,refresh_token:refreshToken}).then(({data})=>{
          if(data?.session){
            setSession(data.session);
            if(type==="recovery"||type==="invite"){
              setNeedsPasswordSet(true);
            }
          }
        });
        // Hash aus URL entfernen
        window.history.replaceState(null,"",window.location.pathname);
        return;
      }
    }

    sb.auth.getSession().then(({data:{session}})=>{setSession(session);});
    const{data:{subscription}}=sb.auth.onAuthStateChange((event,session)=>{
      if(event==="SIGNED_IN"||event==="TOKEN_REFRESHED"){
        setSession(session);
      } else if(event==="SIGNED_OUT"){
        setSession(null);
      } else if(event==="PASSWORD_RECOVERY"){
        setNeedsPasswordSet(true);
      }
    });
    return()=>subscription.unsubscribe();
  },[]);

  // Prüfen ob User Passwort setzen muss
  useEffect(()=>{
    if(!session)return;
    sb.from("profiles").select("needs_password_set").eq("id",session.user.id).single().then(({data})=>{
      if(data?.needs_password_set)setNeedsPasswordSet(true);
    });
  },[session]);

  async function handleSetPassword(){
    if(!newPassword||newPassword.length<6){setPasswordMsg("Passwort muss mindestens 6 Zeichen haben");return;}
    if(newPassword!==newPasswordConfirm){setPasswordMsg("Passwörter stimmen nicht überein");return;}
    const{error}=await sb.auth.updateUser({password:newPassword});
    if(error){setPasswordMsg("Fehler: "+error.message);return;}
    // Flag entfernen
    await sb.from("profiles").update({needs_password_set:false}).eq("id",session?.user?.id);
    setNeedsPasswordSet(false);setNewPassword("");setNewPasswordConfirm("");setPasswordMsg("");
  }

  const hasLoadedRef=useRef(false);
  // Load profile when session changes
  useEffect(()=>{
    if(!session){setProfile(null);setLoading(false);hasLoadedRef.current=false;return;}
    if(hasLoadedRef.current)return; // Already loaded - don't reload on tab switch
    hasLoadedRef.current=true;
    loadAll();
  },[session]);

  async function loadAll(){
    setLoading(true);
    await Promise.all([loadProfiles(),loadBoards(),loadMessages(),loadTodos(),loadMeetings(),loadNotifications(),loadPersonalTodos(),loadVacations(),loadTimeBoards(),loadTraining(),loadRecurringTodos(),loadBoardCategories(),loadBoardTemplates(),loadProspects()]);
    setLoading(false);
    // Desktop Benachrichtigungen anfragen
    if("Notification" in window&&Notification.permission==="default"){
      Notification.requestPermission();
    }
  }

  function sendDesktopNotif(title,body,onClick){
    if("Notification" in window&&Notification.permission==="granted"){
      const n=new Notification(title,{body,icon:"/SiteLogoBRVH.png"});
      if(onClick)n.onclick=onClick;
    }
  }

  async function loadProfiles(){
    const{data}=await sb.from("profiles").select("*");
    if(data){
      setProfiles(data);
      const me=data.find(p=>p.id===session?.user?.id);
      setProfile(me||null);
    }
  }
  async function loadProspects(){
    const{data}=await sb.from("prospects").select("*").order("date");
    if(data)setProspects(data);
  }
  async function loadBoards(){const{data}=await sb.from("boards").select("*");if(data){const m={};data.forEach(b=>{m[b.id]=typeof b.data==="string"?JSON.parse(b.data):b.data;});setBoards(m);}}
  async function loadBoardCategories(){
    const{data}=await sb.from("board_categories").select("*").order("created_at");
    if(data&&data.length>0){
      setBoardCategories(data);
    } else {
      // Defaults noch nicht in DB - jetzt einfügen
      const defaults=[{id:"client",name:"Kundenprojekte"},{id:"internal",name:"Interne Boards"}];
      for(const c of defaults){
        await sb.from("board_categories").upsert({id:c.id,name:c.name,created_at:new Date().toISOString()});
      }
      setBoardCategories(defaults);
    }
  }
  async function loadBoardTemplates(){
    const{data}=await sb.from("board_templates").select("*").order("created_at");
    if(data)setBoardTemplates(data.map(t=>({...t,columns:typeof t.columns==="string"?JSON.parse(t.columns):t.columns})));
  }
  async function loadMessages(){const{data}=await sb.from("chat").select("*").order("created_at");if(data)setMessages(data.map(m=>({id:m.id,from:m.from_user,to:m.to_user,topic:m.topic,text:m.text,time:m.time,read_by:m.read_by||[]})));}
  async function loadTodos(){const{data}=await sb.from("todos").select("*");if(data){const m={};data.forEach(t=>{
    const start=new Date((t.date||today())+"T00:00:00");
    const end=new Date((t.date_end||t.date||today())+"T00:00:00");
    const d=new Date(start);
    while(d<=end){
      const ds=d.toISOString().slice(0,10);
      if(!m[ds])m[ds]=[];
      // Only add once per day, avoid duplicates
      if(!m[ds].find(x=>x.id===t.id)){
        m[ds].push({id:t.id,userId:t.user_id,text:t.text,done:t.done,due:t.due,date:t.date,date_end:t.date_end||t.date,recurring:t.recurring||"",label:t.label||""});
      }
      d.setDate(d.getDate()+1);
    }
  });setTodos(m);}}
  async function loadMeetings(){const{data}=await sb.from("meetings").select("*");if(data)setMeetings(data.map(m=>({...m.data,id:m.id})));}
  async function loadNotifications(){const{data}=await sb.from("notifications").select("*").order("created_at");if(data)setNotifications(data.map(n=>({id:n.id,userId:n.user_id,type:n.type,message:n.message,link:n.link,time:n.time,read:n.read})));}
  async function loadPersonalTodos(){const{data}=await sb.from("personal_todos").select("*").eq("user_id",session?.user?.id);if(data)setPersonalTodos(data);}
  async function loadRecurringTodos(){
    const{data}=await sb.from("recurring_todos").select("*");
    if(data)setRecurringTodos(data.map(r=>({...r,days:(r.days||"").split(",").filter(Boolean).map(Number),start_date:r.start_date||today()})));
    const{data:done}=await sb.from("recurring_done").select("*");
    if(done){const m={};done.forEach(d=>{m[d.rec_id+"|"+d.date]=true;});setRecurringDone(m);}
  }
  async function loadVacations(){const{data}=await sb.from("vacations").select("*");if(data)setVacations(data);}
  async function loadTimeBoards(){const{data}=await sb.from("time_boards").select("*");if(data){const m={};data.forEach(t=>{m[t.key]=t.data;});setTimeBoards(m);}}
  async function loadTraining(){const{data}=await sb.from("training").select("*");if(data)setTraining(data);}

  // Realtime subscriptions
  useEffect(()=>{
    if(!session)return;
    const msgSub=sb.channel("chat").on("postgres_changes",{event:"INSERT",schema:"public",table:"chat"},payload=>{
      const m=payload.new;
      setMessages(prev=>[...prev,{id:m.id,from:m.from_user,to:m.to_user,topic:m.topic,text:m.text,time:m.time,read_by:m.read_by||[]}]);
      // Desktop Benachrichtigung bei DM
      if(m.to_user===session.user.id&&m.from_user!==session.user.id){
        if("Notification" in window&&Notification.permission==="granted"){
          new Notification("BRVH Strategieraum – Neue Nachricht",{body:m.text,icon:"/SiteLogoBRVH.png"});
        }
      }
    }).on("postgres_changes",{event:"UPDATE",schema:"public",table:"chat"},payload=>{
      const m=payload.new;
      setMessages(prev=>prev.map(x=>x.id===m.id?{...x,read_by:m.read_by||[],text:m.text}:x));
    }).subscribe();
    const notifSub=sb.channel("notifications").on("postgres_changes",{event:"INSERT",schema:"public",table:"notifications"},payload=>{
      const n=payload.new;
      if(n.user_id===session.user.id){
        setNotifications(prev=>[...prev,{id:n.id,userId:n.user_id,type:n.type,message:n.message,link:n.link,time:n.time,read:n.read}]);
        // Desktop Benachrichtigung
        if("Notification" in window&&Notification.permission==="granted"){
          new Notification("BRVH Strategieraum",{body:n.message,icon:"/SiteLogoBRVH.png"});
        }
      }
    }).subscribe();
    // Realtime für Boards
    const boardSub=sb.channel("boards-realtime").on("postgres_changes",{event:"*",schema:"public",table:"boards"},payload=>{
      if(payload.eventType==="DELETE"){
        setBoards(prev=>{const n={...prev};delete n[payload.old.id];return n;});
      } else {
        const b=payload.new;
        if(savingBoardIds.current.has(b.id))return;
        const parsed=typeof b.data==="string"?JSON.parse(b.data):b.data;
        setBoards(prev=>({...prev,[b.id]:parsed}));
      }
    }).subscribe();
    // Realtime für Meetings
    const meetingSub=sb.channel("meetings-realtime").on("postgres_changes",{event:"*",schema:"public",table:"meetings"},payload=>{
      if(payload.eventType==="DELETE"){
        setMeetings(prev=>prev.filter(m=>m.id!==payload.old.id));
      } else if(payload.eventType==="INSERT"){
        const m={...payload.new.data,id:payload.new.id};
        setMeetings(prev=>{if(prev.find(x=>x.id===m.id))return prev;return [...prev,m];});
      } else if(payload.eventType==="UPDATE"){
        const m={...payload.new.data,id:payload.new.id};
        setMeetings(prev=>prev.map(x=>x.id===m.id?m:x));
      }
    }).subscribe();
    return()=>{sb.removeChannel(msgSub);sb.removeChannel(notifSub);sb.removeChannel(boardSub);sb.removeChannel(meetingSub);};
  },[session]);

  const isAdmin=profile?.role==="admin";
  const isEmp=profile?.role==="employee";
  const isClient=profile?.role==="client";

  // ── Actions ──
  async function saveBoard(board){
    savingBoardIds.current.add(board.id);
    setBoards(prev=>({...prev,[board.id]:board}));
    try{await sb.from("boards").upsert({id:board.id,name:board.name,data:board});}
    finally{setTimeout(()=>savingBoardIds.current.delete(board.id),2000);}
  }

  async function deleteBoard(id){
    await sb.from("boards").delete().eq("id",id);
    setBoards(prev=>{const n={...prev};delete n[id];return n;});
  }
  async function sendMessage(msg){
    await sb.from("chat").insert({id:msg.id,from_user:msg.from,to_user:msg.to||null,topic:msg.topic,text:msg.text,time:msg.time});
  }
  async function pushNotif(userId,type,message,link){
    const n={id:uid(),user_id:userId,type,message,link,time:nowT(),read:false};
    await sb.from("notifications").insert(n);
  }
  async function markNotifRead(id){
    await sb.from("notifications").update({read:true}).eq("id",id);
    setNotifications(prev=>prev.map(n=>n.id===id?{...n,read:true}:n));
  }
  async function markAllNotifsRead(){
    await sb.from("notifications").update({read:true}).eq("user_id",session.user.id);
    setNotifications(prev=>prev.map(n=>n.userId===profile?.id?{...n,read:true}:n));
  }
  async function addTodo(date,userId,text,due,dateEnd,recurring,label){
    const t={id:uid(),user_id:userId,text,done:false,due:due||"",date,date_end:dateEnd||date,recurring:recurring||"",label:label||""};
    await sb.from("todos").insert(t);
    const start=new Date(date+"T00:00:00");
    const end=new Date((dateEnd||date)+"T00:00:00");
    setTodos(prev=>{
      const next={...prev};
      const d=new Date(start);
      while(d<=end){
        const ds=d.toISOString().slice(0,10);
        if(!next[ds])next[ds]=[];
        next[ds]=[...next[ds],{id:t.id,userId,text,done:false,due:due||"",date,date_end:dateEnd||date,recurring:recurring||"",label:label||""}];
        d.setDate(d.getDate()+1);
      }
      return next;
    });
  }
  async function toggleTodo(date,id){
    const day=todos[date]||[];const t=day.find(x=>x.id===id);if(!t)return;
    const newDone=!t.done;
    await sb.from("todos").update({done:newDone}).eq("id",id);
    // Mark all days in range as done
    setTodos(prev=>{
      const next={...prev};
      Object.keys(next).forEach(ds=>{
        next[ds]=next[ds].map(x=>x.id===id?{...x,done:newDone}:x);
      });
      return next;
    });
    // Create next recurring
    if(newDone&&t.recurring&&t.recurring!==""){
      const baseDate=t.date_end&&t.date_end!==t.date?t.date_end:t.date;
      const d=new Date(baseDate+"T00:00:00");
      if(t.recurring==="daily")d.setDate(d.getDate()+1);
      else if(t.recurring==="weekly")d.setDate(d.getDate()+7);
      else if(t.recurring==="monthly")d.setMonth(d.getMonth()+1);
      const nextDate=d.toISOString().slice(0,10);
      const allTodos=Object.values(todos).flat();
      const exists=allTodos.find(x=>x.id!==id&&x.text===t.text&&x.date===nextDate&&x.recurring===t.recurring);
      if(!exists){
        await addTodo(nextDate,t.userId,t.text,t.due,nextDate,t.recurring);
      }
    }
  }
  async function deleteTodo(date,id){
    await sb.from("todos").delete().eq("id",id);
    // Remove from all days
    setTodos(prev=>{
      const next={...prev};
      Object.keys(next).forEach(ds=>{next[ds]=next[ds].filter(x=>x.id!==id);});
      return next;
    });
  }
  async function addMeeting(meet){
    const m={...meet,id:uid(),done:false,rescheduleRequest:null};
    await sb.from("meetings").insert({id:m.id,data:m});
    setMeetings(prev=>[...prev,m]);
    // Automatisch in "Meine To-Dos" eintragen
    if(meet.date){
      const person=profiles.find(p=>p.id===meet.with);
      const text="📅 "+meet.topic+(person?" – "+person.name:"");
      const todoId=uid();
      const todoObj={id:todoId,user_id:session?.user?.id,text,done:false,due:"",date:meet.date,date_end:meet.date,recurrence:"none",label:""};
      const{error}=await sb.from("personal_todos").insert(todoObj);
      if(!error)setPersonalTodos(prev=>[...prev,{...todoObj,recurring:""}]);
    }
  }
  async function updateMeeting(id,data){
    const m=meetings.find(x=>x.id===id);if(!m)return;
    const updated={...m,...data};
    await sb.from("meetings").update({data:updated}).eq("id",id);
    setMeetings(prev=>prev.map(x=>x.id===id?updated:x));
    // If marking as done and recurring - create next meeting
    if(data.done===true&&m.recurring&&m.recurring!=="once"){
      const d=new Date(m.date+"T00:00:00");
      const next=new Date(d);
      if(m.recurring==="weekly")next.setDate(d.getDate()+7);
      else if(m.recurring==="biweekly")next.setDate(d.getDate()+14);
      else if(m.recurring==="monthly")next.setMonth(d.getMonth()+1);
      const ds=next.getFullYear()+"-"+String(next.getMonth()+1).padStart(2,"0")+"-"+String(next.getDate()).padStart(2,"0");
      const nextMeeting={...m,id:uid(),date:ds,done:false,rescheduleRequest:null};
      await sb.from("meetings").insert({id:nextMeeting.id,data:nextMeeting});
      setMeetings(prev=>[...prev,nextMeeting]);
      // Add to personal todos
      const person=profiles.find(p=>p.id===m.with);
      const text="📅 "+m.topic+(person?" – "+person.name:"");
      const todoId=uid();
      const todoObj={id:todoId,user_id:session?.user?.id,text,done:false,due:"",date:ds,date_end:ds,recurrence:"none",label:""};
      await sb.from("personal_todos").insert(todoObj);
      setPersonalTodos(prev=>[...prev,{...todoObj,recurring:""}]);
    }
  }
  async function deleteMeeting(id){
    const m=meetings.find(x=>x.id===id);
    await sb.from("meetings").delete().eq("id",id);
    setMeetings(prev=>prev.filter(x=>x.id!==id));
    // Remove related personal_todo
    if(m){
      const text="📅 "+m.topic;
      const{data}=await sb.from("personal_todos").select("id").eq("user_id",session?.user?.id).eq("date",m.date);
      if(data){
        for(const t of data){
          if(t.id){
            await sb.from("personal_todos").delete().eq("id",t.id);
            setPersonalTodos(prev=>prev.filter(x=>x.id!==t.id));
          }
        }
      }
    }
  }
  async function addProfile(p){
    await sb.from("profiles").insert(p);
    setProfiles(prev=>[...prev,p]);
  }
  async function updateProfile(id,data){
    await sb.from("profiles").update(data).eq("id",id);
    setProfiles(prev=>prev.map(p=>p.id===id?{...p,...data}:p));
  }

  if(!session)return <Login/>;
  if(needsPasswordSet){
    return(
      <div style={{minHeight:"100vh",background:"linear-gradient(135deg,#1E3448 0%,#2D4F72 50%,#4A7BAF 100%)",display:"flex",alignItems:"center",justifyContent:"center",fontFamily:SN,padding:"20px"}}>
        <div style={{width:"100%",maxWidth:440,background:C.white,borderRadius:16,boxShadow:"0 24px 64px rgba(0,0,0,0.2)",overflow:"hidden"}}>
          <div style={{padding:"40px 44px 32px",textAlign:"center",background:"linear-gradient(135deg,#1E3448,#2D4F72)"}}>
            <div style={{display:"flex",justifyContent:"center",gap:6,marginBottom:14}}>
              {[["B","#6AAFAA"],["R","#4A9090"],["V","#4A7BAF"],["H","#2D4F72"]].map(([l,bg])=>(
                <div key={l} style={{width:44,height:44,background:bg,borderRadius:6,display:"flex",alignItems:"center",justifyContent:"center",fontSize:22,fontWeight:700,color:"#fff",fontFamily:SR}}>{l}</div>
              ))}
            </div>
            <div style={{fontFamily:SR,fontSize:13,color:"rgba(255,255,255,0.55)",letterSpacing:3,textTransform:"uppercase"}}>Strategieraum</div>
          </div>
          <div style={{padding:"32px 40px 36px"}}>
            <p style={{fontFamily:SR,fontSize:20,color:C.text,marginBottom:8}}>Passwort setzen</p>
            <p style={{fontSize:13,color:C.muted,marginBottom:20}}>Bitte wählen Sie ein sicheres Passwort für Ihren Zugang.</p>
            <Inp value={newPassword} onChange={e=>setNewPassword(e.target.value)} type="password" placeholder="Neues Passwort (min. 6 Zeichen)" style={{width:"100%",marginBottom:12}}/>
            <Inp value={newPasswordConfirm} onChange={e=>setNewPasswordConfirm(e.target.value)} type="password" placeholder="Passwort wiederholen" style={{width:"100%",marginBottom:20}}/>
            {passwordMsg&&<p style={{color:C.red,fontSize:13,marginBottom:12}}>{passwordMsg}</p>}
            <Btn onClick={handleSetPassword} full>Passwort speichern & einloggen</Btn>
          </div>
        </div>
      </div>
    );
  }
  if(loading)return <Spinner/>;
  if(!profile)return <div style={{display:"flex",alignItems:"center",justifyContent:"center",height:"100vh",fontFamily:SN,color:C.muted}}>Kein Profil gefunden. Bitte kontaktiere den Admin.</div>;

  const myNotifs=notifications.filter(n=>n.userId===profile.id&&!n.read);
  const dmUnread=messages.filter(m=>m.to===profile.id&&!(m.read_by||[]).includes(profile.id)&&m.from!==profile.id).length;

  const navItems=[
    {id:"dashboard",label:"Dashboard",icon:"⊞"},
    ...(!isClient?[{id:"boards",label:"Projekte & Boards",icon:"◫"}]:[]),
    ...(!isClient?[{id:"calendar",label:"Wochenplan",icon:"⊡"}]:[]),
    {id:"chat",label:"Chat",icon:"💬"},
    {id:"meetings",label:"Gespräche",icon:"📅"},
    ...(isAdmin?[{id:"mytodos",label:"Meine To-Dos",icon:"✓"}]:[]),
    ...(!isClient?[{id:"training",label:"Weiterbildung",icon:"📚"}]:[]),
    ...(!isClient?[{id:"timetracking",label:"Zeiterfassung",icon:"⏱"}]:[]),
    ...(isAdmin||isEmp?[{id:"vacations",label:"Urlaube",icon:"✈"}]:[]),
    ...(isAdmin?[{id:"team",label:"Team & Kunden",icon:"👤"}]:[]),
    ...(isClient?[{id:"boards",label:"Meine Projekte",icon:"◫"}]:[]),
  ];

  function notifsForView(viewId){return myNotifs.filter(n=>n.link&&(n.link.view===viewId||(viewId==="boards"&&n.link.view==="board"))).length;}

  function navigate(viewId,boardId){
    setChatDmWith(null);
    setActiveBoard(boardId||null);
    setView(viewId);
    persistNav(viewId,boardId||null);
    if(isMobile)setNavOpen(false);
  }

  function renderMain(){
    if(activeBoard){
      const board=boards[activeBoard];
      if(!board)return <div style={{display:"flex",alignItems:"center",justifyContent:"center",height:"60vh",color:C.muted,fontFamily:SN}}>Laden…</div>;
      return <KanbanView board={board} profile={profile} profiles={profiles} saveBoard={saveBoard} pushNotif={pushNotif}/>;
    }
    switch(view){
      case "dashboard":
        if(isClient)return <ClientDash profile={profile} boards={boards} onOpen={id=>{setActiveBoard(id);setView("board");persistNav("board",id);}} onNav={v=>setView(v)} notifications={notifications} meetings={meetings} onApprove={async(bid,cardId)=>{const b={...boards[bid]};let cardTitle="";const cols={};Object.keys(b.columns).forEach(cid=>{cols[cid]={...b.columns[cid],cards:b.columns[cid].cards.map(c=>{if(c.id===cardId){cardTitle=c.title;return{...c,clientApproved:true};}return c;})};});let card2;Object.keys(cols).forEach(cid=>{const i=cols[cid].cards.findIndex(c=>c.id===cardId);if(i!==-1){card2=cols[cid].cards[i];cols[cid]={...cols[cid],cards:cols[cid].cards.filter((_,j)=>j!==i)};}});if(card2){let tgt=b.colOrder.find(cid=>b.columns[cid].name.toLowerCase().includes("freigegeben"));if(!tgt)tgt=b.colOrder[b.colOrder.length-1];cols[tgt]={...cols[tgt],cards:[...cols[tgt].cards,{...card2,clientApproved:true}]};}const updated={...b,columns:cols};await saveBoard(updated);const toNotify=profiles.filter(p=>p.role==="admin"||(p.role==="employee"&&(p.board_ids||[]).includes(bid)));for(const p of toNotify){await pushNotif(p.id,"approval","✅ "+profile.name+" hat freigegeben: "+cardTitle,{view:"board",board:bid})};}}/>;
        if(isEmp)return <EmpDash profile={profile} boards={boards} todos={todos} onOpen={id=>{setActiveBoard(id);setView("board");persistNav("board",id);}}/>;
        return <AdminDash profile={profile} profiles={profiles} boards={boards} todos={todos} meetings={meetings} prospects={prospects} notifications={notifications} personalTodos={personalTodos} onOpen={id=>{setActiveBoard(id);setView("board");persistNav("board",id);}} onToggleTodo={async(id)=>{const t=personalTodos.find(x=>x.id===id);if(!t)return;await sb.from("personal_todos").update({done:!t.done}).eq("id",id);setPersonalTodos(prev=>prev.map(x=>x.id===id?{...x,done:!x.done}:x));}}/>;
      case "boards":return <BoardsView profile={profile} profiles={profiles} boards={boards} onOpen={id=>{setActiveBoard(id);setView("board");persistNav("board",id);}} saveBoard={saveBoard} deleteBoard={deleteBoard} boardCategories={boardCategories} setBoardCategories={setBoardCategories} boardTemplates={boardTemplates} setBoardTemplates={setBoardTemplates}/>;
      case "calendar":return <WeekCalView profile={profile} profiles={profiles} todos={todos} addTodo={addTodo} toggleTodo={toggleTodo} deleteTodo={deleteTodo} recurringTodos={recurringTodos} recurringDone={recurringDone} setRecurringTodos={setRecurringTodos} setRecurringDone={setRecurringDone}/>;
      case "chat":return <ChatView profile={profile} profiles={profiles} messages={messages} setMessages={setMessages} sendMessage={sendMessage} initialDmWith={chatDmWith} notifications={notifications} markRead={markNotifRead} isMobile={isMobile}/>;
      case "meetings":return <MeetingsView profile={profile} profiles={profiles} meetings={meetings} prospects={prospects} setProspects={setProspects} addMeeting={addMeeting} updateMeeting={updateMeeting} deleteMeeting={deleteMeeting} pushNotif={pushNotif} setPersonalTodos={setPersonalTodos} session={session}/>;
      case "mytodos":return <PersonalTodosView profile={profile} personalTodos={personalTodos} setPersonalTodos={setPersonalTodos}/>;
      case "training":return <TrainingView profile={profile} profiles={profiles} training={training} setTraining={setTraining}/>;
      case "timetracking":return <TimeTrackingView profile={profile} profiles={profiles} timeBoards={timeBoards} setTimeBoards={setTimeBoards}/>;
      case "vacations":return <VacationsView profile={profile} profiles={profiles} vacations={vacations} setVacations={setVacations}/>;
      case "team":return <TeamView profile={profile} profiles={profiles} addProfile={addProfile} updateProfile={updateProfile} loadProfiles={loadProfiles} setProfiles={setProfiles} boards={boards} meetings={meetings} messages={messages}/>;
      default:return null;
    }
  }

  return(
    <div style={{fontFamily:SN,minHeight:"100vh",background:C.bg,display:"flex"}}>

      {/* Mobile overlay */}
      {isMobile&&navOpen&&(
        <div onClick={()=>setNavOpen(false)} style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.5)",zIndex:150}}/>
      )}

      {/* Sidebar */}
      <div style={{
        width:230,background:C.navBg,minHeight:"100vh",display:"flex",flexDirection:"column",flexShrink:0,boxShadow:"2px 0 12px rgba(0,0,0,0.15)",
        ...(isMobile?{position:"fixed",top:0,left:0,height:"100%",zIndex:200,transform:navOpen?"translateX(0)":"translateX(-100%)",transition:"transform 0.25s ease"}:{})
      }}>
        <div style={{padding:"20px 18px 16px",borderBottom:"1px solid rgba(255,255,255,0.08)"}}>
          <div style={{display:"flex",gap:5,marginBottom:8}}>
            {[["B","#6AAFAA"],["R","#4A9090"],["V","#4A7BAF"],["H","#2D4F72"]].map(([l,bg])=>(
              <div key={l} style={{width:28,height:28,background:bg,borderRadius:4,display:"flex",alignItems:"center",justifyContent:"center",fontSize:13,fontWeight:700,color:"#fff",fontFamily:SR}}>{l}</div>
            ))}
          </div>
          <div style={{fontSize:11,color:"rgba(255,255,255,0.45)",letterSpacing:2,textTransform:"uppercase"}}>Strategieraum</div>
        </div>
        <nav style={{flex:1,padding:"10px",overflowY:"auto"}}>
          {navItems.map(item=>{
            const active=(view===item.id&&!activeBoard)||(item.id==="boards"&&!!activeBoard);
            const badge=item.id==="chat"?notifsForView("chat")+dmUnread:notifsForView(item.id);
            return(
              <button key={item.id} onClick={()=>navigate(item.id)} style={{width:"100%",padding:"9px 12px",borderRadius:6,border:"none",background:active?"rgba(74,123,175,0.25)":"transparent",color:active?"#fff":"rgba(255,255,255,0.55)",cursor:"pointer",fontSize:12,fontWeight:active?700:400,marginBottom:2,textAlign:"left",fontFamily:SN,display:"flex",alignItems:"center",justifyContent:"space-between",borderLeft:active?"2px solid "+C.blue1:"2px solid transparent"}}>
                <span style={{display:"flex",alignItems:"center",gap:8}}><span style={{fontSize:13}}>{item.icon}</span>{item.label}</span>
                {badge>0&&<Badge n={badge}/>}
              </button>
            );
          })}
        </nav>
        <div style={{padding:"12px 10px",borderTop:"1px solid rgba(255,255,255,0.08)"}}>
          <div style={{display:"flex",alignItems:"center",gap:8,padding:"10px 12px",background:"rgba(255,255,255,0.07)",borderRadius:8,marginBottom:8}}>
            <Av name={profile.name} color={profile.color} size={28}/>
            <div style={{overflow:"hidden",flex:1}}>
              <div style={{fontSize:12,fontWeight:600,color:"#fff",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{profile.name}</div>
              <div style={{fontSize:10,color:"rgba(255,255,255,0.45)"}}>{ROLE_L[profile.role]}</div>
            </div>
            <NotifBell notifications={notifications} profile={profile} markRead={markNotifRead} markAll={markAllNotifsRead} onNavigate={(link)=>{if(link.view==="board"&&link.board){setActiveBoard(link.board);setView("board");}else setView(link.view);if(isMobile)setNavOpen(false);}}/>
          </div>
          <button onClick={()=>{try{sessionStorage.clear();}catch{}sb.auth.signOut();}} style={{width:"100%",padding:"7px",borderRadius:6,border:"1px solid rgba(255,255,255,0.12)",background:"transparent",color:"rgba(255,255,255,0.4)",cursor:"pointer",fontSize:12,fontFamily:SN}}>Abmelden</button>
        </div>
      </div>

      {/* Main content */}
      <div style={{flex:1,padding:isMobile?"12px 14px":"32px 36px",overflowY:"auto",maxWidth:isMobile?"100vw":"calc(100vw - 230px)",minWidth:0,boxSizing:"border-box"}}>

        {/* Mobile top bar */}
        {isMobile&&(
          <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:16}}>
            <button onClick={()=>setNavOpen(true)} style={{background:C.navBg,border:"none",borderRadius:8,padding:"9px 13px",cursor:"pointer",color:"#fff",fontSize:20,lineHeight:1,flexShrink:0}}>☰</button>
            <div style={{display:"flex",gap:4}}>
              {[["B","#6AAFAA"],["R","#4A9090"],["V","#4A7BAF"],["H","#2D4F72"]].map(([l,bg])=>(
                <div key={l} style={{width:24,height:24,background:bg,borderRadius:3,display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,fontWeight:700,color:"#fff",fontFamily:SR}}>{l}</div>
              ))}
            </div>
            <span style={{fontSize:10,color:C.muted,letterSpacing:2,textTransform:"uppercase",flex:1}}>Strategieraum</span>
          </div>
        )}

        {activeBoard&&(
          <div style={{display:"flex",alignItems:"center",gap:9,marginBottom:18,flexWrap:"wrap"}}>
            <button onClick={()=>{setActiveBoard(null);setView("boards");persistNav("boards",null);}} style={{background:"none",border:"none",color:C.blue1,cursor:"pointer",fontWeight:700,fontSize:14,fontFamily:SN}}>← Projekte & Boards</button>
            <span style={{color:C.border}}>/</span>
            <span style={{fontFamily:SR,fontSize:17,color:C.text}}>{boards[activeBoard]?.name}</span>
          </div>
        )}
        {renderMain()}
      </div>
    </div>
  );
}

// ── NotifBell ──
function NotifBell({notifications,profile,markRead,markAll,onNavigate}){
  const [open,setOpen]=useState(false);
  const mine=notifications.filter(n=>n.userId===profile?.id);
  const unread=mine.filter(n=>!n.read);
  return(
    <div style={{position:"relative"}}>
      {open&&<div onClick={()=>setOpen(false)} style={{position:"fixed",inset:0,zIndex:298}}/>}
      <button onClick={()=>setOpen(p=>!p)} style={{background:"rgba(255,255,255,0.1)",border:"1px solid rgba(255,255,255,0.2)",borderRadius:6,padding:"6px 10px",cursor:"pointer",color:"#fff",fontSize:13,display:"flex",alignItems:"center",gap:6}}>
        🔔{unread.length>0&&<Badge n={unread.length}/>}
      </button>
      {open&&(
        <div style={{position:"fixed",right:12,bottom:80,width:300,background:C.white,borderRadius:10,boxShadow:"0 8px 32px rgba(45,79,114,0.18)",zIndex:299,border:"1px solid "+C.border,maxHeight:"55vh",overflowY:"auto"}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"12px 16px",borderBottom:"1px solid "+C.border,background:C.blue2,borderRadius:"10px 10px 0 0"}}>
            <span style={{fontFamily:SR,fontSize:15,color:"#fff"}}>Benachrichtigungen</span>
            {unread.length>0&&<button onClick={e=>{e.stopPropagation();markAll();}} style={{border:"none",background:"rgba(255,255,255,0.15)",color:"#fff",cursor:"pointer",fontWeight:600,fontSize:11,borderRadius:4,padding:"3px 8px"}}>Alle gelesen</button>}
          </div>
          {mine.length===0&&<p style={{padding:16,color:C.muted,fontSize:13}}>Keine Benachrichtigungen.</p>}
          {mine.slice().reverse().map(n=>(
            <div key={n.id} onClick={()=>{markRead(n.id);setOpen(false);if(n.link)onNavigate(n.link);}} style={{padding:"10px 16px",borderBottom:"1px solid "+C.border,cursor:n.link?"pointer":"default",background:n.read?"transparent":C.accentLight}}>
              <div style={{display:"flex",justifyContent:"space-between",gap:6}}>
                <span style={{fontSize:12,color:C.text,lineHeight:1.4,flex:1}}>{n.message}</span>
                {!n.read&&<div style={{width:7,height:7,borderRadius:"50%",background:C.blue1,flexShrink:0,marginTop:3}}/>}
              </div>
              {n.link&&<div style={{fontSize:10,color:C.blue1,marginTop:3,fontWeight:700}}>→ Öffnen</div>}
              <div style={{fontSize:10,color:C.muted,marginTop:2}}>{n.time}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ── Kanban ──
function KanbanView({board,profile,profiles,saveBoard,pushNotif}){
  const boardRef=useRef(board);
  useEffect(()=>{boardRef.current=board;},[board]);
  const [openCardId,setOpenCardId]=useState(()=>{
    try{return sessionStorage.getItem("openCard_"+board.id)||null;}catch{return null;}
  });
  function openCard2(id){
    setOpenCardId(id);
    try{if(id)sessionStorage.setItem("openCard_"+board.id,id);else sessionStorage.removeItem("openCard_"+board.id);}catch{}
  }
  const [drag,setDrag]=useState(null);
  const [over,setOver]=useState(null);
  const [colDrag,setColDrag]=useState(null);
  const [colOver,setColOver]=useState(null);
  const [editColId,setEditColId]=useState(null);
  const [editColName,setEditColName]=useState("");
  const [showAddCol,setShowAddCol]=useState(false);
  const [newColName,setNewColName]=useState("");
  const [addCol,setAddCol]=useState(null);
  const [nc,setNc]=useState({title:"",desc:"",due:""});
  const [showBg,setShowBg]=useState(false);
  const [editBoardName,setEditBoardName]=useState(false);
  const [boardNameVal,setBoardNameVal]=useState(board.name||"");
  const [editBoardClient,setEditBoardClient]=useState(false);
  const [boardClientVal,setBoardClientVal]=useState(board.clientId||"");
  const isAdmin=profile?.role==="admin";
  const isAdminOrEmp=isAdmin||(profile?.role==="employee");

  async function renameCol(colId,name){if(!name.trim())return;const updated={...board,columns:{...board.columns,[colId]:{...board.columns[colId],name}}};await saveBoard(updated);setEditColId(null);}
  async function addNewCol(){if(!newColName.trim())return;const newId=uid();const updated={...board,columns:{...board.columns,[newId]:{name:newColName,cards:[]}},colOrder:[...board.colOrder,newId]};await saveBoard(updated);setNewColName("");setShowAddCol(false);}
  async function delCol(colId){const cols={...board.columns};delete cols[colId];const updated={...board,columns:cols,colOrder:board.colOrder.filter(id=>id!==colId)};await saveBoard(updated);}
  async function moveCol(fromId,toId){
    if(!fromId||!toId||fromId===toId)return;
    const order=[...board.colOrder];
    const fi=order.indexOf(fromId);
    const ti=order.indexOf(toId);
    if(fi===-1||ti===-1)return;
    order.splice(fi,1);
    order.splice(ti,0,fromId);
    await saveBoard({...board,colOrder:order});
  }
  async function addCard(colId){if(!nc.title.trim())return;const card={id:uid(),title:nc.title,desc:nc.desc,due:nc.due,content:"",comments:[],files:[],clientTag:false,reviews:[],clientApproved:false};const updated={...board,columns:{...board.columns,[colId]:{...board.columns[colId],cards:[...board.columns[colId].cards,card]}}};await saveBoard(updated);setNc({title:"",desc:"",due:""});setAddCol(null);}
  async function moveCard(cardId,toCid,toIdx){let card;const cols={...board.columns};Object.keys(cols).forEach(cid=>{const i=cols[cid].cards.findIndex(c=>c.id===cardId);if(i!==-1){card=cols[cid].cards[i];cols[cid]={...cols[cid],cards:cols[cid].cards.filter((_,j)=>j!==i)};}});if(!card)return;const tgt=[...cols[toCid].cards];tgt.splice(toIdx!=null?toIdx:tgt.length,0,card);cols[toCid]={...cols[toCid],cards:tgt};await saveBoard({...board,columns:cols});}
  async function setBg(color){await saveBoard({...board,bgColor:color});setShowBg(false);}
  async function deleteCard(cardId){
    if(!window.confirm("Karte wirklich loeschen?"))return;
    const cols={};
    Object.keys(board.columns).forEach(cid=>{cols[cid]={...board.columns[cid],cards:board.columns[cid].cards.filter(c=>c.id!==cardId)};});
    await saveBoard({...board,columns:cols});
    setOpenCardId(null);
  }

  const openCard=openCardId?(()=>{for(const cid of board.colOrder){const found=board.columns[cid].cards.find(c=>c.id===openCardId);if(found)return{card:found,colId:cid};}return null;})():null;

  return(
    <div style={{background:board.bgColor||"#fff",borderRadius:10,padding:16,minHeight:"60vh"}} onClick={()=>showBg&&setShowBg(false)}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
        {editBoardName?(
          <input value={boardNameVal} onChange={e=>setBoardNameVal(e.target.value)}
            onKeyDown={e=>{if(e.key==="Enter"){saveBoard({...board,name:boardNameVal});setEditBoardName(false);}if(e.key==="Escape")setEditBoardName(false);}}
            onBlur={()=>{saveBoard({...board,name:boardNameVal});setEditBoardName(false);}}
            autoFocus style={{fontFamily:SR,fontSize:17,fontWeight:600,padding:"3px 8px",borderRadius:6,border:"1.5px solid "+C.blue1,outline:"none",minWidth:200}}/>
        ):(
          <span onClick={()=>{if(isAdminOrEmp){setBoardNameVal(board.name);setEditBoardName(true);}}} style={{fontFamily:SR,fontSize:17,color:C.text,fontWeight:600,cursor:isAdminOrEmp?"pointer":"default"}} title={isAdminOrEmp?"Klicken zum Umbenennen":""}>
            {board.name}{isAdminOrEmp&&<span style={{fontSize:12,color:C.muted,marginLeft:6}}>✎</span>}
          </span>
        )}
        {isAdminOrEmp&&<div style={{display:"flex",gap:8}}>
          <div style={{position:"relative"}}>
            <Btn sm outline onClick={e=>{e.stopPropagation();setShowBg(p=>!p);}}>Hintergrund</Btn>
            {showBg&&<div onClick={e=>e.stopPropagation()} style={{position:"absolute",right:0,top:"110%",background:C.white,borderRadius:8,padding:14,boxShadow:"0 8px 32px rgba(0,0,0,0.15)",zIndex:50,width:260,border:"1px solid "+C.border}}><div style={{fontSize:11,fontWeight:700,color:C.muted,textTransform:"uppercase",letterSpacing:1,marginBottom:10}}>Hintergrundfarbe</div><div style={{display:"grid",gridTemplateColumns:"repeat(6,1fr)",gap:5}}>{BCOLS.map(col=><div key={col.v} onClick={()=>setBg(col.v)} title={col.n} style={{width:34,height:34,borderRadius:6,background:col.v,cursor:"pointer",border:board.bgColor===col.v?"3px solid "+C.blue1:"1px solid "+C.border,boxSizing:"border-box",transition:"transform 0.1s"}} onMouseEnter={e=>e.currentTarget.style.transform="scale(1.15)"} onMouseLeave={e=>e.currentTarget.style.transform="scale(1)"}/>)}</div></div>}
          </div>
          <div style={{position:"relative"}}>
            <Btn sm outline onClick={e=>{e.stopPropagation();setEditBoardClient(p=>!p);}}>👤 Kunde</Btn>
            {editBoardClient&&<div onClick={e=>e.stopPropagation()} style={{position:"absolute",right:0,top:"110%",background:C.white,borderRadius:8,padding:10,boxShadow:"0 8px 32px rgba(0,0,0,0.15)",zIndex:50,width:240,border:"1px solid "+C.border}}>
              <div style={{fontSize:11,fontWeight:700,color:C.muted,textTransform:"uppercase",letterSpacing:1,marginBottom:8}}>Kunden zuweisen</div>
              <select value={boardClientVal} onChange={e=>{setBoardClientVal(e.target.value);saveBoard({...board,clientId:e.target.value||null});setEditBoardClient(false);}} style={{width:"100%",padding:"8px 10px",borderRadius:6,border:"1px solid "+C.border,fontSize:13}}>
                <option value="">Kein Kunde</option>
                {profiles.filter(p=>p.role==="client").map(c=><option key={c.id} value={c.id}>{c.name}</option>)}
              </select>
            </div>}
          </div>
        </div>}
      </div>
      <div style={{overflowX:"auto",paddingBottom:6}}>
        <div style={{display:"flex",gap:12,minWidth:"max-content",alignItems:"flex-start"}}>
          {board.colOrder.map(colId=>{
            const col=board.columns[colId];
            return(
              <div key={colId}
                style={{width:256,background:"rgba(255,255,255,0.92)",borderRadius:8,border:"2px solid "+(colOver===colId?C.blue1:colDrag===colId?"rgba(74,123,175,0.3)":"rgba(0,0,0,0.08)"),opacity:colDrag===colId?0.4:1,transition:"all 0.15s"}}
                onDragOver={e=>{e.preventDefault();if(colDrag&&colDrag!==colId)setColOver(colId);else if(!colDrag)setOver({colId,idx:col.cards.length});}}
                onDragLeave={e=>{if(!e.currentTarget.contains(e.relatedTarget)){setColOver(null);}}}
                onDrop={e=>{
                  e.preventDefault();
                  const fromId=e.dataTransfer.getData("text/plain");
                  if(fromId&&fromId!==colId){moveCol(fromId,colId);}
                  else if(drag){moveCard(drag.cardId,colId,col.cards.length);setDrag(null);setOver(null);}
                  setColDrag(null);setColOver(null);
                }}>
                <div
                  draggable={isAdminOrEmp}
                  onDragStart={e=>{
                    if(!isAdminOrEmp)return;
                    setColDrag(colId);
                    e.dataTransfer.effectAllowed="move";
                    e.dataTransfer.setData("text/plain",colId);
                  }}
                  onDragEnd={()=>{setColDrag(null);setColOver(null);}}
                  style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 12px",borderBottom:"1px solid rgba(0,0,0,0.07)",cursor:isAdminOrEmp?"grab":"default"}}>
                  {editColId===colId&&isAdminOrEmp?(
                    <div style={{display:"flex",gap:5,flex:1}}>
                      <input value={editColName} onChange={e=>setEditColName(e.target.value)} onKeyDown={e=>{if(e.key==="Enter")renameCol(colId,editColName);if(e.key==="Escape")setEditColId(null);}} autoFocus style={{flex:1,padding:"3px 7px",borderRadius:4,border:"1px solid "+C.blue1,fontSize:13,fontFamily:SN,outline:"none"}}/>
                      <button onClick={()=>renameCol(colId,editColName)} style={{border:"none",background:C.blue1,color:"#fff",borderRadius:4,cursor:"pointer",padding:"2px 8px",fontSize:12}}>✓</button>
                      <button onClick={()=>setEditColId(null)} style={{border:"none",background:"transparent",color:C.muted,cursor:"pointer",fontSize:14}}>✕</button>
                    </div>
                  ):(
                    <div style={{display:"flex",alignItems:"center",gap:6,flex:1}}>
                      <span style={{fontFamily:SR,fontSize:14,color:C.text,flex:1}}>{col.name}</span>
                      {isAdminOrEmp&&<button onClick={()=>{setEditColId(colId);setEditColName(col.name);}} style={{border:"none",background:"none",color:C.muted,cursor:"pointer",fontSize:11,padding:"1px 4px"}}>✎</button>}
                      {isAdmin&&col.cards.length===0&&<button onClick={()=>delCol(colId)} style={{border:"none",background:"none",color:C.red,cursor:"pointer",fontSize:12,padding:"1px 4px"}}>✕</button>}
                    </div>
                  )}
                  <span style={{background:C.blue2,color:"#fff",borderRadius:99,padding:"2px 8px",fontSize:11,fontWeight:700,flexShrink:0,marginLeft:4}}>{col.cards.length}</span>
                </div>
                <div style={{padding:8,display:"flex",flexDirection:"column",gap:6,minHeight:60}}>
                  {col.cards.map((card,idx)=>{
                    const isDragging=drag&&drag.cardId===card.id;
                    const pendingRev=(card.reviews||[]).filter(r=>r.status==="pending").length;
                    const coverImg=firstImg(card.files);
                    return(
                      <div key={card.id}>
                        {over&&over.colId===colId&&over.idx===idx&&<div style={{height:3,background:C.blue1,borderRadius:2,marginBottom:3}}/>}
                        <div draggable={isAdminOrEmp} onDragStart={()=>isAdminOrEmp&&setDrag({cardId:card.id,colId})} onDragEnd={()=>{setDrag(null);setOver(null);}}
                          onDragOver={e=>{e.preventDefault();e.stopPropagation();setOver({colId,idx});}}
                          onDrop={e=>{e.preventDefault();e.stopPropagation();if(drag){moveCard(drag.cardId,colId,idx);setDrag(null);setOver(null);}}}
                          onClick={()=>!isDragging&&openCard2(card.id)}
                          style={{background:"#fff",borderRadius:6,overflow:"hidden",cursor:"pointer",boxShadow:"0 1px 4px rgba(0,0,0,0.07)",borderLeft:"3px solid "+(card.clientApproved?C.green2:C.blue1),opacity:isDragging?0.4:1}}>
                          {coverImg&&<img src={coverImg.data} alt="Cover" style={{width:"100%",height:90,objectFit:"cover",display:"block"}}/>}
                          <div style={{padding:"8px 10px"}}>
                            <p style={{margin:"0 0 4px",fontFamily:SR,fontSize:13,color:C.text,lineHeight:1.4}}>{card.title}</p>
                            {card.content&&<p style={{margin:"0 0 5px",fontSize:11,color:C.muted,fontStyle:"italic"}}>{card.content.slice(0,60)+(card.content.length>60?"...":"")}</p>}
                            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                              <div style={{display:"flex",gap:4}}>{pendingRev>0&&<span style={{fontSize:10,padding:"1px 6px",borderRadius:4,background:"#fffbeb",color:"#b8860b",fontWeight:700,border:"1px solid #f0c040"}}>Abnahme</span>}{card.clientApproved&&<span style={{fontSize:10,color:C.green2,fontWeight:700}}>✅</span>}</div>
                              <div style={{display:"flex",gap:4}}>{card.due&&<span style={{fontSize:10,color:C.muted}}>{card.due}</span>}{(card.files||[]).length>0&&<span style={{fontSize:10,color:C.muted}}>📎{card.files.length}</span>}{(card.comments||[]).length>0&&<span style={{fontSize:10,color:C.muted}}>💬{card.comments.length}</span>}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                  {over&&over.colId===colId&&over.idx>=col.cards.length&&<div style={{height:3,background:C.blue1,borderRadius:2,marginTop:3}}/>}
                  {isAdminOrEmp&&(addCol===colId?(
                    <div style={{background:"#fff",borderRadius:6,padding:9,border:"1px solid "+C.border}}>
                      <input placeholder="Titel*" value={nc.title} onChange={e=>setNc(p=>({...p,title:e.target.value}))} style={{width:"100%",marginBottom:6,padding:"7px 10px",borderRadius:4,border:"1px solid "+C.border,fontSize:12,boxSizing:"border-box"}}/>
                      <textarea placeholder="Beschreibung" value={nc.desc} onChange={e=>setNc(p=>({...p,desc:e.target.value}))} rows={2} style={{width:"100%",marginBottom:6,padding:"6px 8px",borderRadius:4,border:"1px solid "+C.border,fontSize:11,resize:"none",boxSizing:"border-box"}}/>
                      <input type="date" value={nc.due} onChange={e=>setNc(p=>({...p,due:e.target.value}))} style={{width:"100%",marginBottom:7,padding:"6px 8px",borderRadius:4,border:"1px solid "+C.border,fontSize:11,boxSizing:"border-box"}}/>
                      <div style={{display:"flex",gap:5}}><Btn sm onClick={()=>addCard(colId)}>+</Btn><Btn sm outline onClick={()=>setAddCol(null)}>✕</Btn></div>
                    </div>
                  ):(
                    <button onClick={()=>setAddCol(colId)} style={{padding:"6px",border:"1.5px dashed "+C.border,background:"transparent",borderRadius:6,cursor:"pointer",color:C.muted,fontSize:12}}>+ Karte</button>
                  ))}
                </div>
              </div>
            );
          })}
          {isAdminOrEmp&&<div style={{width:220,flexShrink:0}}>{showAddCol?(<div style={{background:"rgba(255,255,255,0.9)",borderRadius:8,padding:10,border:"1px solid "+C.border}}><input placeholder="Spaltenname*" value={newColName} onChange={e=>setNewColName(e.target.value)} onKeyDown={e=>{if(e.key==="Enter")addNewCol();}} autoFocus style={{width:"100%",marginBottom:8,padding:"8px 10px",borderRadius:4,border:"1px solid "+C.border,fontSize:13,boxSizing:"border-box"}}/><div style={{display:"flex",gap:6}}><Btn sm onClick={addNewCol}>+ Hinzufügen</Btn><Btn sm outline onClick={()=>{setShowAddCol(false);setNewColName("");}}>Abbrechen</Btn></div></div>):(<button onClick={()=>setShowAddCol(true)} style={{width:"100%",padding:"12px",border:"1.5px dashed rgba(0,0,0,0.15)",background:"rgba(255,255,255,0.5)",borderRadius:8,cursor:"pointer",color:"rgba(0,0,0,0.35)",fontSize:13,fontFamily:SN}}>+ Neue Spalte</button>)}</div>}
        </div>
      </div>
      {openCard&&<CardModal card={openCard.card} colId={openCard.colId} boardRef={boardRef} profile={profile} profiles={profiles} saveBoard={saveBoard} pushNotif={pushNotif} onClose={()=>openCard2(null)} onDelete={deleteCard}/>}
    </div>
  );
}

// ── CardModal ──
function CardModal({card,colId,boardRef,profile,profiles,saveBoard,pushNotif,onClose,onDelete}){
  const [editContent,setEditContent]=useState(false);
  const [content,setContent]=useState(()=>{try{return sessionStorage.getItem("card_content_"+card.id)||card.content||"";}catch{return card.content||"";}});
  const [showReview,setShowReview]=useState(false);
  const [reviewNote,setReviewNote]=useState("");
  const [decideId,setDecideId]=useState(null);
  const [decideNote,setDecideNote]=useState("");
  const [editTitle,setEditTitle]=useState(false);
  const [newTitle,setNewTitle]=useState(card.title||"");
  const autoSaveRef=useRef(null);
  const fileRef=useRef();

  function setContentAndCache(val){
    setContent(val);
    try{sessionStorage.setItem("card_content_"+card.id,val);}catch{}
    // Auto-save after 2 seconds of no typing
    if(autoSaveRef.current)clearTimeout(autoSaveRef.current);
    autoSaveRef.current=setTimeout(async()=>{
      await updateCard({content:val});
      try{sessionStorage.removeItem("card_content_"+card.id);}catch{}
    },2000);
  }
  const isAdmin=profile?.role==="admin";
  const isEmp=profile?.role==="employee";
  const isClient=profile?.role==="client";
  const isAdminOrEmp=isAdmin||isEmp;
  const reviews=card.reviews||[];
  const pendingReviews=reviews.filter(r=>r.status==="pending");
  const board=boardRef.current;
  const cols=board.colOrder.map(id=>({id,name:board.columns[id].name}));

  async function updateCard(data){
    const b=boardRef.current;
    const cols2={};
    Object.keys(b.columns).forEach(cid=>{cols2[cid]={...b.columns[cid],cards:b.columns[cid].cards.map(c=>c.id===card.id?{...c,...data}:c)};});
    await saveBoard({...b,columns:cols2});
  }
  async function moveCard(toCid){
    const b=boardRef.current;
    let c;const cols2={...b.columns};
    Object.keys(cols2).forEach(cid=>{const i=cols2[cid].cards.findIndex(x=>x.id===card.id);if(i!==-1){c=cols2[cid].cards[i];cols2[cid]={...cols2[cid],cards:cols2[cid].cards.filter((_,j)=>j!==i)};}});
    if(!c)return;cols2[toCid]={...cols2[toCid],cards:[...cols2[toCid].cards,c]};
    await saveBoard({...b,columns:cols2});onClose();
  }
  async function addComment(text){
    const comment={id:uid(),text,author:profile.id,authorName:profile.name,time:nowT()};
    await updateCard({comments:[...(card.comments||[]),comment]});
  }
  async function addFile(e){
    const allFiles=Array.from(e.target.files);
    if(!allFiles.length)return;
    const newData=await Promise.all(allFiles.map(f=>readFile(f)));
    await updateCard({files:[...(card.files||[]),...newData]});
    e.target.value="";
  }
  async function submitReview(){
    if(!reviewNote.trim())return;
    const review={id:uid(),requestedBy:profile.id,requestedByName:profile.name,requestedAt:today(),status:"pending",note:reviewNote};
    await updateCard({reviews:[...(card.reviews||[]),review]});
    const admins=profiles.filter(p=>p.role==="admin");
    for(const a of admins){await pushNotif(a.id,"review","Abnahme angefragt von "+profile.name+": "+card.title,{view:"board",board:board.id});}
    setReviewNote("");setShowReview(false);
  }
  async function decide(reviewId,decision){
    const updated=(card.reviews||[]).map(r=>r.id===reviewId?{...r,status:decision,decisionNote,decidedAt:today(),decidedBy:profile.name}:r);
    await updateCard({reviews:updated});
    const req=(card.reviews||[]).find(r=>r.id===reviewId);
    if(req)await pushNotif(req.requestedBy,(decision==="approved"?"Genehmigt":"Abgelehnt")+": "+card.title,{view:"board",board:board.id});
    setDecideId(null);setDecideNote("");
  }

  return(
    <div onClick={onClose} style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.55)",zIndex:100,display:"flex",alignItems:"center",justifyContent:"center",padding:"12px"}}>
      <div onClick={e=>e.stopPropagation()} style={{background:C.white,borderRadius:12,padding:28,width:"100%",maxWidth:680,maxHeight:"94vh",overflowY:"auto",boxShadow:"0 30px 80px rgba(0,0,0,0.2)"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:14,gap:8}}>
          {editTitle?(
            <input value={newTitle} onChange={e=>setNewTitle(e.target.value)}
              onKeyDown={e=>{if(e.key==="Enter"){updateCard({title:newTitle});setEditTitle(false);}if(e.key==="Escape")setEditTitle(false);}}
              autoFocus style={{flex:1,fontFamily:SR,fontSize:20,padding:"4px 8px",borderRadius:6,border:"1.5px solid "+C.blue1,outline:"none"}}/>
          ):(
            <h3 onClick={()=>{if(isAdminOrEmp){setNewTitle(card.title);setEditTitle(true);}}} style={{margin:0,fontFamily:SR,fontSize:20,fontWeight:400,color:C.text,flex:1,cursor:isAdminOrEmp?"pointer":"default"}} title={isAdminOrEmp?"Klicken zum Bearbeiten":""}>
              {card.title}{isAdminOrEmp&&<span style={{fontSize:12,color:C.muted,marginLeft:6}}>✎</span>}
            </h3>
          )}
          <div style={{display:"flex",gap:6,flexShrink:0}}>
            {isAdminOrEmp&&<button onClick={()=>{if(window.confirm("Karte wirklich loeschen?"))onDelete(card.id);}} style={{border:"none",background:"none",color:C.red,cursor:"pointer",fontSize:16,padding:"2px 6px"}} title="Karte loeschen">🗑</button>}
            <button onClick={onClose} style={{border:"none",background:"none",fontSize:22,cursor:"pointer",color:C.muted}}>×</button>
          </div>
        </div>
        {firstImg(card.files)&&<img src={firstImg(card.files).data} alt="Cover" style={{width:"100%",borderRadius:8,marginBottom:14,display:"block",maxHeight:220,objectFit:"cover"}}/>}
        <div style={{display:"flex",gap:8,marginBottom:14,flexWrap:"wrap"}}>
          {card.due&&<Tag color={C.blue1}>Fällig: {card.due}</Tag>}
          {card.clientApproved&&<Tag color={C.green2}>✅ Freigegeben</Tag>}
        </div>
        {card.desc&&<p style={{color:C.muted,marginBottom:14,lineHeight:1.7,fontSize:14}}>{card.desc}</p>}

        <div style={{marginBottom:16}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:6}}>
            <div style={{fontSize:11,fontWeight:700,color:C.muted,textTransform:"uppercase",letterSpacing:1}}>Inhalt</div>
            {isAdminOrEmp&&!editContent&&<button onClick={()=>{setContent(card.content||"");setEditContent(true);}} style={{border:"none",background:"none",color:C.blue1,cursor:"pointer",fontSize:12,fontWeight:700}}>✎ Bearbeiten</button>}
          </div>
          {editContent?(
            <div>
              <div style={{position:"relative"}}>
                <textarea value={content} onChange={e=>setContentAndCache(e.target.value)} rows={12} placeholder="Beitragstext, LinkedIn-Post…" style={{width:"100%",padding:"12px 14px",borderRadius:8,border:"1.5px solid "+C.blue1,fontSize:14,resize:"vertical",boxSizing:"border-box",fontFamily:SN,lineHeight:1.7,outline:"none",minHeight:200}}/>
                <div style={{position:"absolute",bottom:8,right:8,fontSize:10,color:C.muted}}>Auto-Speichern aktiv</div>
              </div>
              <div style={{display:"flex",gap:8,marginTop:8}}><Btn sm onClick={async()=>{if(autoSaveRef.current)clearTimeout(autoSaveRef.current);await updateCard({content});try{sessionStorage.removeItem("card_content_"+card.id);}catch{}setEditContent(false);}}>Speichern</Btn><Btn sm outline onClick={()=>setEditContent(false)}>Abbrechen</Btn></div>
            </div>
          ):(
            <div style={{background:C.bg,borderRadius:8,padding:"12px 14px",minHeight:80,fontSize:14,color:card.content?C.text:C.muted,whiteSpace:"pre-wrap",lineHeight:1.7,border:"1px solid "+C.border}}>
              {card.content||"(Kein Inhalt)"}
            </div>
          )}
        </div>

        {isClient&&(
          <div style={{marginBottom:14}}>
            <Btn sm outline onClick={()=>fileRef.current.click()}>📎 Datei hochladen</Btn>
          </div>
        )}

        {isAdminOrEmp&&(
          <div style={{marginBottom:14}}>
            <div style={{fontSize:11,fontWeight:700,color:C.muted,textTransform:"uppercase",letterSpacing:1,marginBottom:8}}>Verschieben</div>
            <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>{cols.filter(c=>c.id!==colId).map(c=><Btn key={c.id} sm outline onClick={()=>moveCard(c.id)}>→ {c.name}</Btn>)}</div>
          </div>
        )}

        {isEmp&&(
          <div style={{marginBottom:14,padding:12,background:"#f0faf4",borderRadius:8,border:"1px solid #b7dfc4"}}>
            <div style={{fontSize:11,fontWeight:700,color:C.text,textTransform:"uppercase",letterSpacing:1,marginBottom:8}}>Abnahme anfordern</div>
            {showReview?(<div><textarea value={reviewNote} onChange={e=>setReviewNote(e.target.value)} rows={3} placeholder="Hinweis…" style={{width:"100%",padding:"8px 10px",borderRadius:6,border:"1px solid "+C.border,fontSize:13,resize:"none",boxSizing:"border-box",marginBottom:8}}/><div style={{display:"flex",gap:8}}><Btn sm onClick={submitReview}>Einreichen</Btn><Btn sm outline onClick={()=>setShowReview(false)}>Abbrechen</Btn></div></div>):<Btn sm onClick={()=>setShowReview(true)}>Zur Abnahme einreichen</Btn>}
          </div>
        )}
        {isAdmin&&pendingReviews.length>0&&(
          <div style={{marginBottom:14,padding:12,background:"#fffbeb",borderRadius:8,border:"1px solid #f0c040"}}>
            <div style={{fontSize:11,fontWeight:700,color:C.text,textTransform:"uppercase",letterSpacing:1,marginBottom:10}}>Abnahme-Anfragen ({pendingReviews.length})</div>
            {pendingReviews.map(r=>(
              <div key={r.id} style={{marginBottom:10,padding:10,background:C.white,borderRadius:8,border:"1px solid "+C.border}}>
                <div style={{fontSize:13,fontWeight:700,color:C.text,marginBottom:4}}>{r.requestedByName} · {r.requestedAt}</div>
                {r.note&&<p style={{fontSize:13,color:C.text,margin:"0 0 8px",background:C.bg,padding:"6px 10px",borderRadius:6}}>{r.note}</p>}
                {decideId===r.id?(<div><textarea value={decideNote} onChange={e=>setDecideNote(e.target.value)} rows={2} placeholder="Begründung…" style={{width:"100%",padding:"7px 10px",borderRadius:6,border:"1px solid "+C.border,fontSize:12,resize:"none",boxSizing:"border-box",marginBottom:8}}/><div style={{display:"flex",gap:6}}><Btn sm onClick={()=>decide(r.id,"approved")} style={{background:C.green2,borderColor:C.green2,color:"#fff"}}>Genehmigen</Btn><Btn sm onClick={()=>decide(r.id,"rejected")} style={{background:C.red,borderColor:C.red,color:"#fff"}}>Ablehnen</Btn><Btn sm outline onClick={()=>setDecideId(null)}>Abbrechen</Btn></div></div>):<Btn sm onClick={()=>setDecideId(r.id)}>Entscheidung</Btn>}
              </div>
            ))}
          </div>
        )}

        <div style={{marginBottom:14}}>
          <div style={{fontSize:11,fontWeight:700,color:C.muted,textTransform:"uppercase",letterSpacing:1,marginBottom:8}}>Anhänge ({(card.files||[]).length})</div>
          <div style={{display:"flex",flexWrap:"wrap",gap:8}}>
            {(card.files||[]).map((f,i)=>(<div key={i} onClick={()=>{const a=document.createElement("a");a.href=f.data;a.download=f.name;a.click();}} style={{border:"1px solid "+C.border,borderRadius:6,overflow:"hidden",cursor:"pointer"}}>{isImg(f)?<img src={f.data} alt={f.name} style={{width:72,height:56,objectFit:"cover",display:"block"}}/>:<div style={{width:72,height:56,display:"flex",alignItems:"center",justifyContent:"center",background:C.bg}}><span style={{fontSize:10,color:C.muted,textAlign:"center",padding:"0 4px"}}>{f.name.slice(0,14)}</span></div>}<div style={{padding:"2px 5px",fontSize:9,color:C.muted,background:C.bg,borderTop:"1px solid "+C.border}}>{fmtSize(f.size)}</div></div>))}
            <div onClick={()=>fileRef.current.click()} style={{width:72,height:66,border:"1.5px dashed "+C.border,borderRadius:6,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",cursor:"pointer",color:C.muted,gap:2}}><span style={{fontSize:20}}>+</span><span style={{fontSize:10}}>Datei</span></div>
          </div>
          <input ref={fileRef} type="file" multiple style={{display:"none"}} onChange={addFile}/>
        </div>

        <div style={{marginBottom:12}}>
          <div style={{fontSize:11,fontWeight:700,color:C.muted,textTransform:"uppercase",letterSpacing:1,marginBottom:8}}>Kommentare ({(card.comments||[]).length})</div>
          {(card.comments||[]).map(cm=>(<div key={cm.id} style={{background:C.bg,borderRadius:6,padding:"8px 12px",marginBottom:5}}><div style={{display:"flex",justifyContent:"space-between"}}><span style={{fontSize:12,fontWeight:700,color:C.blue1}}>{cm.authorName}</span><span style={{fontSize:11,color:C.muted}}>{cm.time}</span></div><p style={{margin:"3px 0 0",fontSize:13,color:C.text,whiteSpace:"pre-wrap"}}>{cm.text}</p></div>))}
        </div>
        <MsgBox users={profiles} onSend={addComment} placeholder="Kommentar…" minRows={2}/>
      </div>
    </div>
  );
}

// ── Boards View ──
function BoardsView({profile,profiles,boards,onOpen,saveBoard,deleteBoard,boardCategories,setBoardCategories,boardTemplates,setBoardTemplates}){
  const isAdmin=profile?.role==="admin";
  const isEmp=profile?.role==="employee";
  const isClient=profile?.role==="client";
  const cats=boardCategories.length>0?boardCategories:[{id:"client",name:"Kundenprojekte"},{id:"internal",name:"Interne Boards"}];
  const [tab,setTab]=useState(()=>{try{return sessionStorage.getItem("sv_board_tab")||cats[0]?.id||"client";}catch{return cats[0]?.id||"client";}});
  // Wenn Kunde einen Tab hat der nicht existiert, setze ersten verfügbaren
  useEffect(()=>{if(isClient&&clientCats.length>0&&!clientCats.find(c=>c.id===tab)){setTabAndSave(clientCats[0].id);}},[clientCats]);
  function setTabAndSave(id){setTab(id);try{sessionStorage.setItem("sv_board_tab",id);}catch{}}
  const [showNew,setShowNew]=useState(false);
  const [showCatMgr,setShowCatMgr]=useState(false);
  const [showTplMgr,setShowTplMgr]=useState(false);
  const [editBoardClientModal,setEditBoardClientModal]=useState({show:false,boardId:null,clientId:""});
  const [newCatName,setNewCatName]=useState("");
  const [editCatId,setEditCatId]=useState(null);
  const [editCatName,setEditCatName]=useState("");
  const [dragCat,setDragCat]=useState(null);
  const [overCat,setOverCat]=useState(null);

  async function moveCat(fromId,toId){
    if(!fromId||!toId||fromId===toId)return;
    const arr=[...cats];
    const fi=arr.findIndex(c=>c.id===fromId);
    const ti=arr.findIndex(c=>c.id===toId);
    if(fi===-1||ti===-1)return;
    arr.splice(fi,1);
    arr.splice(ti,0,cats[fi]);
    setBoardCategories(arr);
    // Save order via sort_order field
    for(let i=0;i<arr.length;i++){
      await sb.from("board_categories").update({sort_order:i}).eq("id",arr[i].id);
    }
    setDragCat(null);setOverCat(null);
  }
  const [frm,setFrm]=useState({name:"",tplId:"",clientId:"",empIds:[],bg:"#ffffff",categoryId:cats[0]?.id||"client"});
  const all=Object.values(boards);
  // Tabs die der Kunde sieht – nur Kategorien wo er Boards hat
  const clientCats=isClient?cats.filter(c=>all.some(b=>(b.clientId===profile.id||(b.visibleTo||[]).includes(profile.id))&&(b.categoryId||(b.internal?"internal":"client"))===c.id)):cats;
  const shown=all.filter(b=>{
    const catId=b.categoryId||(b.internal?"internal":"client");
    if(isClient){
      if(catId!==tab)return false;
      return(b.clientId===profile.id)||(b.visibleTo||[]).includes(profile.id);
    }
    if(catId!==tab)return false;
    if(isAdmin)return true;
    return(b.employeeIds||[]).includes(profile.id)||(b.clientId===profile.id);
  });
  const clients=profiles.filter(p=>p.role==="client");
  const emps=profiles.filter(p=>p.role==="employee");

  // Built-in + custom templates
  const allTpls=[
    {id:"linkedin",name:"LinkedIn Pipeline",icon:"LI",columns:["Idee","In Arbeit","Zur Abnahme","Freigegeben","Veröffentlicht"]},
    {id:"internal",name:"Internes Board",icon:"IN",columns:["Backlog","In Bearbeitung","Zur Abnahme","Erledigt"]},
    {id:"marketing",name:"Marketing",icon:"MK",columns:["Ideen","Planung","Umsetzung","Review","Live"]},
    {id:"onboarding",name:"Onboarding",icon:"OB",columns:["Vorbereitung","Woche 1","Woche 2","Abschluss"]},
    {id:"general",name:"Allg. Projekt",icon:"AP",columns:["To Do","In Progress","Review","Done"]},
    ...boardTemplates.map(t=>({...t,isCustom:true})),
  ];

  async function addCategory(){
    if(!newCatName.trim())return;
    const c={id:uid(),name:newCatName};
    await sb.from("board_categories").insert({id:c.id,name:c.name});
    setBoardCategories(prev=>[...prev,c]);
    setNewCatName("");
  }

  async function renameCategory(id,name){
    await sb.from("board_categories").update({name}).eq("id",id);
    setBoardCategories(prev=>prev.map(c=>c.id===id?{...c,name}:c));
    setEditCatId(null);
  }

  async function deleteCategory(id){
    // Prüfen ob Boards in dieser Kategorie sind
    const boardsInCat=all.filter(b=>(b.categoryId||(b.internal?"internal":"client"))===id);
    if(boardsInCat.length>0){
      alert("⚠️ Diese Kategorie kann nicht gelöscht werden, solange noch "+boardsInCat.length+" Board(s) darin sind.\n\nVerschiebe zuerst alle Boards in eine andere Kategorie.");
      return;
    }
    if(!window.confirm('Kategorie '+cats.find(c=>c.id===id)?.name+' wirklich loeschen? Diese Aktion kann nicht rueckgaengig gemacht werden.'))return;
    await sb.from("board_categories").delete().eq("id",id);
    setBoardCategories(prev=>prev.filter(c=>c.id!==id));
    if(tab===id)setTabAndSave(cats.find(c=>c.id!==id)?.id||"client");
  }

  async function saveBoardAsTemplate(board){
    const colNames=board.colOrder.map(cid=>board.columns[cid].name);
    const t={id:uid(),name:board.name+" (Vorlage)",icon:board.icon||"AP",columns:JSON.stringify(colNames)};
    await sb.from("board_templates").insert(t);
    setBoardTemplates(prev=>[...prev,{...t,columns:colNames}]);
    alert("✅ Als Vorlage gespeichert!");
  }

  async function deleteTemplate(id){
    await sb.from("board_templates").delete().eq("id",id);
    setBoardTemplates(prev=>prev.filter(t=>t.id!==id));
  }

  async function create(){
    if(!frm.name)return;
    const tpl=allTpls.find(t=>t.id===frm.tplId)||allTpls[0];
    const columns={};(tpl.columns||["To Do","In Progress","Done"]).forEach(c=>{columns[uid()]={name:c,cards:[]};});
    const colOrder=Object.keys(columns);
    const catId=frm.categoryId||tab;
    const isInternal=cats.find(c=>c.id===catId)?.id==="internal";
    const b={id:uid(),name:frm.name,columns,colOrder,clientId:frm.clientId||null,employeeIds:frm.empIds,internal:isInternal,bgColor:frm.bg,icon:tpl.icon||"AP",categoryId:catId,created:today()};
    await saveBoard(b);
    setFrm({name:"",tplId:"",clientId:"",empIds:[],bg:"#ffffff",categoryId:tab});
    setShowNew(false);
  }

  return(
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:18,flexWrap:"wrap",gap:8}}>
        <H1>Projekte & Boards</H1>
        <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
          {isAdmin&&<Btn sm outline onClick={()=>setShowCatMgr(p=>!p)}>⚙ Kategorien</Btn>}
          {isAdmin&&<Btn sm outline onClick={()=>setShowTplMgr(p=>!p)}>📋 Vorlagen</Btn>}
          {(isAdmin||isEmp)&&<Btn onClick={()=>setShowNew(p=>!p)}>+ Neues Board</Btn>}
        </div>
      </div>

      {/* Category Manager */}
      {showCatMgr&&isAdmin&&(
        <Panel style={{marginBottom:16}}>
          <H2>Kategorien verwalten</H2>
          <div style={{marginBottom:12}}>
            {cats.map(c=>(
              <div key={c.id} style={{display:"flex",alignItems:"center",gap:8,padding:"7px 0",borderBottom:"1px solid "+C.border}}>
                {editCatId===c.id?(
                  <>
                    <Inp value={editCatName} onChange={e=>setEditCatName(e.target.value)} style={{flex:1}}/>
                    <Btn sm onClick={()=>renameCategory(c.id,editCatName)}>✓</Btn>
                    <Btn sm outline onClick={()=>setEditCatId(null)}>✕</Btn>
                  </>
                ):(
                  <>
                    <span style={{flex:1,fontSize:14,color:C.text}}>{c.name}</span>
                    <button onClick={()=>{setEditCatId(c.id);setEditCatName(c.name);}} style={{border:"none",background:"none",color:C.muted,cursor:"pointer",fontSize:14}}>✎</button>
                    <button onClick={()=>deleteCategory(c.id)} style={{border:"none",background:"none",color:C.red,cursor:"pointer",fontSize:14}}>✕</button>
                  </>
                )}
              </div>
            ))}
          </div>
          <div style={{display:"flex",gap:8}}>
            <Inp placeholder="Neue Kategorie…" value={newCatName} onChange={e=>setNewCatName(e.target.value)} onKeyDown={e=>{if(e.key==="Enter")addCategory();}} style={{flex:1}}/>
            <Btn sm onClick={addCategory}>+ Hinzufügen</Btn>
          </div>
        </Panel>
      )}

      {/* Template Manager */}
      {showTplMgr&&isAdmin&&(
        <Panel style={{marginBottom:16}}>
          <H2>Vorlagen verwalten</H2>
          <p style={{fontSize:12,color:C.muted,marginBottom:12}}>Öffne ein Board und klicke auf „Als Vorlage speichern" um eigene Vorlagen zu erstellen.</p>
          <div style={{display:"flex",flexWrap:"wrap",gap:8}}>
            {allTpls.map(t=>(
              <div key={t.id} style={{padding:"8px 14px",borderRadius:6,background:t.isCustom?C.accentLight:"#f4f7fa",border:"1px solid "+(t.isCustom?C.blue1:C.border),display:"flex",alignItems:"center",gap:8}}>
                <span style={{fontSize:13,fontWeight:600,color:t.isCustom?C.blue1:C.text}}>{t.icon} {t.name}</span>
                <span style={{fontSize:11,color:C.muted}}>{(t.columns||[]).join(" → ")}</span>
                {t.isCustom&&<button onClick={()=>deleteTemplate(t.id)} style={{border:"none",background:"none",color:C.red,cursor:"pointer",fontSize:13}}>✕</button>}
              </div>
            ))}
          </div>
        </Panel>
      )}

      {/* Tabs */}
      {(clientCats.length>1||!isClient)&&(
        <div style={{display:"flex",marginBottom:18,borderBottom:"2px solid "+C.border,flexWrap:"wrap",gap:0}}>
          {(isClient?clientCats:cats).map(c=>(
            <button key={c.id}
              draggable
              onDragStart={()=>setDragCat(c.id)}
              onDragEnd={()=>{setDragCat(null);setOverCat(null);}}
              onDragOver={e=>{e.preventDefault();setOverCat(c.id);}}
              onDrop={e=>{e.preventDefault();if(dragCat&&dragCat!==c.id)moveCat(dragCat,c.id);}}
              onClick={()=>setTabAndSave(c.id)}
              style={{padding:"10px 20px",border:"none",background:overCat===c.id?C.accentLight:"transparent",color:tab===c.id?C.blue1:C.muted,fontWeight:700,cursor:"grab",fontSize:14,borderBottom:tab===c.id?"2px solid "+C.blue1:overCat===c.id?"2px solid "+C.blue1+"66":"2px solid transparent",marginBottom:-2,fontFamily:SN,whiteSpace:"nowrap",opacity:dragCat===c.id?0.4:1,transition:"all 0.15s"}}>
              {c.name}
            </button>
          ))}
        </div>
      )}

      {/* New Board Form */}
      {showNew&&(isAdmin||isEmp)&&(
        <Panel style={{marginBottom:22}}>
          <H2>Neues Board</H2>
          <div style={{marginBottom:14,padding:"10px 14px",borderRadius:6,background:"#e3f2fd",border:"1px solid #90caf9",fontSize:12,color:"#1565c0"}}>
            💡 <strong>Tipp:</strong> Richte das Board erst ein. Du kannst einen Kunden später noch zuweisen.
          </div>
          <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:12}}>
            <Inp placeholder="Name*" value={frm.name} onChange={e=>setFrm(p=>({...p,name:e.target.value}))} style={{flex:2,minWidth:170}}/>
            {!isClient&&<select value={frm.categoryId} onChange={e=>setFrm(p=>({...p,categoryId:e.target.value}))} style={{flex:1,minWidth:150,padding:"9px 10px",borderRadius:6,border:"1px solid "+C.border,fontSize:14}}>
              {cats.map(c=><option key={c.id} value={c.id}>{c.name}</option>)}
            </select>}
          </div>
          <div style={{marginBottom:8,fontSize:12,fontWeight:700,color:C.muted,textTransform:"uppercase",letterSpacing:1}}>Vorlage wählen</div>
          <div style={{display:"flex",gap:6,flexWrap:"wrap",marginBottom:12}}>
            {allTpls.map(t=>(
              <button key={t.id} onClick={()=>setFrm(p=>({...p,tplId:t.id}))} style={{padding:"6px 12px",borderRadius:6,cursor:"pointer",fontSize:12,fontWeight:600,border:"1.5px solid "+(frm.tplId===t.id?C.blue1:C.border),background:frm.tplId===t.id?C.accentLight:"transparent",color:frm.tplId===t.id?C.blue2:C.muted}}>
                {t.icon} {t.name}{t.isCustom&&" ⭐"}
              </button>
            ))}
          </div>
          {isAdmin&&<div style={{display:"flex",gap:6,flexWrap:"wrap",marginBottom:12}}>{emps.map(e=><button key={e.id} onClick={()=>setFrm(p=>({...p,empIds:p.empIds.includes(e.id)?p.empIds.filter(x=>x!==e.id):[...p.empIds,e.id]}))} style={{display:"flex",alignItems:"center",gap:5,padding:"5px 10px",borderRadius:6,border:"1.5px solid "+(frm.empIds.includes(e.id)?C.blue1:C.border),background:frm.empIds.includes(e.id)?C.accentLight:"transparent",cursor:"pointer",fontSize:12}}><Av name={e.name} color={e.color} size={16}/>{e.name}</button>)}</div>}
          <Btn onClick={create}>Board erstellen</Btn>
        </Panel>
      )}

      {/* Assign Client Modal */}
      {editBoardClientModal.show&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.4)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:999}}>
          <Panel style={{width:"90%",maxWidth:400,boxShadow:"0 20px 60px rgba(0,0,0,0.3)"}}>
            <H2>Kunde zuweisen</H2>
            <p style={{fontSize:13,color:C.muted,marginBottom:14}}>Wähle einen Kunden aus oder entferne die Zuweisung.</p>
            <select value={editBoardClientModal.clientId} onChange={e=>setEditBoardClientModal(p=>({...p,clientId:e.target.value}))} style={{width:"100%",padding:"10px 14px",borderRadius:6,border:"1.5px solid "+C.border,fontSize:14,marginBottom:16,fontFamily:SN}}>
              <option value="">🚫 Kein Kunde</option>
              {profiles.filter(p=>p.role==="client").map(c=><option key={c.id} value={c.id}>{c.name}</option>)}
            </select>
            <div style={{display:"flex",gap:8}}>
              <Btn onClick={()=>{const b=boards[editBoardClientModal.boardId];if(b)saveBoard({...b,clientId:editBoardClientModal.clientId||null});setEditBoardClientModal({show:false,boardId:null,clientId:""});}} full>Speichern</Btn>
              <Btn outline onClick={()=>setEditBoardClientModal({show:false,boardId:null,clientId:""})} style={{flex:1}}>Abbrechen</Btn>
            </div>
          </Panel>
        </div>
      )}

      {/* Board Grid */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(260px,1fr))",gap:14}}>
        {shown.map(b=>{
          const client=profiles.find(p=>p.id===b.clientId);
          const cnt=b.colOrder.reduce((s,cid)=>s+b.columns[cid].cards.length,0);
          const cat=cats.find(c=>c.id===(b.categoryId||( b.internal?"internal":"client")));
          return(
            <div key={b.id} style={{background:b.bgColor||C.white,borderRadius:10,padding:20,cursor:"pointer",border:"1.5px solid "+C.border,transition:"all .2s",boxShadow:"0 2px 8px rgba(45,79,114,0.05)",position:"relative"}}
              onClick={()=>onOpen(b.id)}
              onMouseEnter={e=>{e.currentTarget.style.borderColor=C.blue1;e.currentTarget.style.boxShadow="0 6px 24px rgba(74,123,175,0.15)";}}
              onMouseLeave={e=>{e.currentTarget.style.borderColor=C.border;e.currentTarget.style.boxShadow="0 2px 8px rgba(45,79,114,0.05)";}}>
              {isAdmin&&<div style={{position:"absolute",top:10,right:10,display:"flex",gap:4}}>
                <button onClick={e=>{e.stopPropagation();setEditBoardClientModal({show:true,boardId:b.id,clientId:b.clientId||""});}} title="Kunden ändern" style={{border:"1px solid "+C.border,background:"white",borderRadius:4,cursor:"pointer",fontSize:11,padding:"2px 6px",color:C.blue2}}>👤</button>
                <button onClick={e=>{e.stopPropagation();saveBoardAsTemplate(b);}} title="Als Vorlage speichern" style={{border:"1px solid "+C.border,background:"white",borderRadius:4,cursor:"pointer",fontSize:11,padding:"2px 6px",color:C.muted}}>⭐</button>
                <button onClick={e=>{e.stopPropagation();const totalCards=b.colOrder.reduce((s,cid)=>s+b.columns[cid].cards.length,0);if(totalCards>0){alert("Board kann nicht geloescht werden solange noch "+totalCards+" Karte(n) darin sind.");return;}if(window.confirm("Board '"+b.name+"' wirklich loeschen?"))deleteBoard(b.id);}} title="Board loeschen" style={{border:"1px solid #fca5a5",background:"white",borderRadius:4,cursor:"pointer",fontSize:11,padding:"2px 6px",color:C.red}}>✕</button>
              </div>}
              <div style={{display:"flex",justifyContent:"space-between",marginBottom:10,paddingRight:isAdmin?70:0}}>
                <span style={{fontSize:24,fontWeight:700,color:C.blue1}}>{b.icon}</span>
                {client&&<span style={{padding:"3px 10px",background:C.blue2,color:"#fff",borderRadius:6,fontSize:11,fontWeight:700}}>{client.name}</span>}
              </div>
              <div style={{fontFamily:SR,fontSize:15,color:C.text,marginBottom:4}}>{b.name}</div>
              <div style={{fontSize:12,color:C.muted,marginBottom:10}}>
                {cnt+" Karten"}
                {cat&&<span style={{marginLeft:8,padding:"1px 6px",background:C.accentLight,color:C.blue1,borderRadius:4,fontSize:10,fontWeight:700}}>{cat.name}</span>}
              </div>
              <div style={{display:"flex",gap:4}}>{(b.employeeIds||[]).map(eid=>{const u=profiles.find(x=>x.id===eid);return u?<Av key={eid} name={u.name} color={u.color} size={22}/>:null;})}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

// ── WeekCal View ──
const DEFAULT_LABELS_CAL=[
  {id:"linkedin",name:"LinkedIn",color:"#0A66C2"},
  {id:"instagram",name:"Instagram",color:"#E1306C"},
  {id:"allgemein",name:"Allgemein",color:"#4A7BAF"},
];

function WeekCalView({profile,profiles,todos,addTodo,toggleTodo,deleteTodo,recurringTodos,recurringDone,setRecurringTodos,setRecurringDone}){
  const [isMobW,setIsMobW]=useState(window.innerWidth<=768);
  useEffect(()=>{const h=()=>setIsMobW(window.innerWidth<=768);window.addEventListener("resize",h);return()=>window.removeEventListener("resize",h);},[]);
  const isAdmin=profile?.role==="admin";
  const canEdit=isAdmin||(profile?.role==="employee");
  const [off,setOff]=useState(0);
  const [viewMode,setViewMode]=useState("2week");
  const [addDay,setAddDay]=useState(null);
  const [nt,setNt]=useState({text:"",userId:"",due:"",dateStart:"",dateEnd:"",labelId:""});
  const [calOff,setCalOff]=useState(0);
  const [editTd,setEditTd]=useState(null);
  const [showRec,setShowRec]=useState(false);
  const [nr,setNr]=useState({text:"",userId:"",days:[],label:"",type:"weekly"});
  const [editRec,setEditRec]=useState(null);
  const [labels,setLabels]=useState(()=>{try{const s=localStorage.getItem("ptodo_labels");return s?JSON.parse(s):DEFAULT_LABELS_CAL;}catch{return DEFAULT_LABELS_CAL;}});
  const [showLabelMgr,setShowLabelMgr]=useState(false);
  const [newLabel,setNewLabel]=useState({name:"",color:"#4A7BAF"});
  const week1=weekDays(off);const week2=weekDays(off+1);
  const emps=profiles.filter(p=>p.role!=="client");
  const DAYS_SHORT=["Mo","Di","Mi","Do","Fr","Sa","So"];

  function saveLabels(next){setLabels(next);try{localStorage.setItem("ptodo_labels",JSON.stringify(next));}catch{}}
  function addNewLabel(){if(!newLabel.name.trim())return;const l={id:uid(),name:newLabel.name,color:newLabel.color};saveLabels([...labels,l]);setNewLabel({name:"",color:"#4A7BAF"});}
  function getLabelById(id){return labels.find(l=>l.id===id)||null;}

  async function toggleRecDone(recId,date){
    const k=recId+"|"+date;
    const cur=recurringDone[k];
    if(cur){
      await sb.from("recurring_done").delete().eq("rec_id",recId).eq("date",date);
      setRecurringDone(prev=>{const n={...prev};delete n[k];return n;});
    } else {
      const id=uid();
      await sb.from("recurring_done").insert({id,rec_id:recId,user_id:profile.id,date});
      setRecurringDone(prev=>({...prev,[k]:true}));
    }
  }

  async function addRecurring(){
    const type=nr.type||"weekly";
    if(!nr.text.trim())return;
    if(type!=="daily"&&!nr.days.length)return;
    const days=type==="daily"?[0,1,2,3,4,5,6]:nr.days;
    const startDate=today();
    const r={id:uid(),user_id:nr.userId||profile.id,text:nr.text,label:nr.label||"",days:days.join(","),rec_type:type,start_date:startDate};
    await sb.from("recurring_todos").insert(r);
    setRecurringTodos(prev=>[...prev,{...r,days,start_date:startDate}]);
    setNr({text:"",userId:"",days:[],label:"",type:"weekly"});
  }

  async function editRecurring(r){
    const days=editRec.days.join(",");
    await sb.from("recurring_todos").update({text:editRec.text,days,label:editRec.label||""}).eq("id",r.id);
    setRecurringTodos(prev=>prev.map(x=>x.id===r.id?{...x,text:editRec.text,days:editRec.days,label:editRec.label||""}:x));
    setEditRec(null);
  }

  async function deleteRecurring(id){
    await sb.from("recurring_todos").delete().eq("id",id);
    await sb.from("recurring_done").delete().eq("rec_id",id);
    setRecurringTodos(prev=>prev.filter(r=>r.id!==id));
    setRecurringDone(prev=>{const n={...prev};Object.keys(n).forEach(k=>{if(k.startsWith(id+"|"))delete n[k];});return n;});
  }

  function getDayItems(date){
    const d=new Date(date+"T00:00:00");
    const dow=(d.getDay()+6)%7; // 0=Mo
    const dayOfMonth=d.getDate();
    const rec=(recurringTodos||[])
      .filter(r=>{
        if(!isAdmin&&r.user_id!==profile.id)return false;
        // Nicht vor dem Erstellungsdatum anzeigen
        if(r.start_date&&date<r.start_date)return false;
        const type=r.rec_type||"weekly";
        const matches=type==="daily"?true:
          type==="weekly"?r.days.includes(dow):
          type==="monthly_weekday"?r.days.includes(dow):
          type==="monthly_date"?r.days.includes(dayOfMonth):
          r.days.includes(dow);
        if(!matches)return false;
        // Nur anzeigen wenn noch nicht abgehakt ODER heute
        const k=r.id+"|"+date;
        const isDone=!!(recurringDone&&recurringDone[k]);
        // Zeige immer an (auch wenn erledigt, damit man es sieht)
        return true;
      })
      .map(r=>({...r,isRec:true,done:!!(recurringDone&&recurringDone[r.id+"|"+date])}));
    const one=(todos[date]||[]).filter(t=>isAdmin||t.userId===profile.id);
    return [...rec,...one];
  }

  function renderDayCol(date,compact){
    const dayOfWeek=new Date(date+"T00:00:00").getDay();
    const isWE=dayOfWeek===0||dayOfWeek===6;
    const isTod=date===today();
    const items=getDayItems(date);
    const dayIdx=(dayOfWeek+6)%7;
    return(
      <div key={date} style={{background:isTod?"linear-gradient(135deg,"+C.blue2+","+C.blue1+")":isWE?"#eef2f7":C.white,borderRadius:8,border:"1.5px solid "+(isTod?C.blue1:C.border),display:"flex",flexDirection:"column",minHeight:compact?220:280}}>
        <div style={{padding:compact?"6px 9px 4px":"9px 11px 5px",borderBottom:"1px solid "+(isTod?"rgba(255,255,255,0.15)":C.border)}}>
          <div style={{fontSize:compact?10:11,fontWeight:700,color:isTod?"rgba(255,255,255,0.7)":C.muted,textTransform:"uppercase",letterSpacing:1}}>{DAYS[dayIdx]}</div>
          <div style={{fontFamily:SR,fontSize:compact?16:20,color:isTod?C.white:C.text,fontWeight:600}}>{new Date(date+"T00:00:00").getDate()}</div>
        </div>
        <div style={{flex:1,padding:"6px 8px",overflowY:"auto"}}>
          {items.map((t)=>{
            if(t.isRec){
              // Wiederkehrendes To-Do
              const u2=profiles.find(x=>x.id===t.user_id);
              const canTog=isAdmin||t.user_id===profile.id;
              return(
                <div key={"rec"+t.id+date} style={{display:"flex",alignItems:"flex-start",gap:5,marginBottom:5,padding:"5px 7px",borderRadius:5,background:isTod?"rgba(255,255,255,0.12)":"#eef6ff",border:"1px solid "+C.blue1+"33",borderLeft:"3px solid "+C.teal1}}>
                  <input type="checkbox" checked={!!t.done} disabled={!canTog} onChange={()=>toggleRecDone(t.id,date)} style={{marginTop:3,accentColor:C.teal1,cursor:canTog?"pointer":"default",flexShrink:0}}/>
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{fontSize:compact?11:12,lineHeight:1.4,textDecoration:t.done?"line-through":"none",color:isTod?(t.done?"rgba(255,255,255,0.5)":"#fff"):(t.done?C.muted:C.text)}}>
                      <span style={{fontSize:9,opacity:0.6}}>↻ </span>{t.text}
                    </div>
                    {isAdmin&&u2&&<div style={{display:"flex",alignItems:"center",gap:2,marginTop:1}}><Av name={u2.name} color={u2.color} size={11}/><span style={{fontSize:9,color:isTod?"rgba(255,255,255,0.6)":C.muted}}>{u2.name.split(" ")[0]}</span></div>}
                  </div>
                </div>
              );
            }
            // Normales To-Do
            const u=profiles.find(x=>x.id===t.userId);
            const canTog=isAdmin||t.userId===profile.id;
            const overdue=t.due&&t.due<today()&&!t.done;
            const lbl=getLabelById(t.label||"");
            return(
              <div key={t.id} style={{display:"flex",alignItems:"flex-start",gap:5,marginBottom:5,padding:"5px 7px",borderRadius:5,background:isTod?"rgba(255,255,255,0.12)":"#f4f7fa",border:overdue?"1px solid #e07070":"1px solid transparent",borderLeft:lbl?"3px solid "+lbl.color:"3px solid transparent"}}>
                <input type="checkbox" checked={!!t.done} disabled={!canTog} onChange={()=>toggleTodo(date,t.id)} style={{marginTop:3,accentColor:C.blue1,cursor:canTog?"pointer":"default",flexShrink:0}}/>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{fontSize:compact?11:12,lineHeight:1.4,wordBreak:"break-word",textDecoration:t.done?"line-through":"none",color:isTod?(t.done?"rgba(255,255,255,0.5)":"#fff"):(t.done?C.muted:C.text)}}>{t.text}</div>
                  {lbl&&<span style={{fontSize:9,fontWeight:700,padding:"1px 5px",borderRadius:99,background:lbl.color+"22",color:isTod?"rgba(255,255,255,0.7)":lbl.color}}>{lbl.name}</span>}
                  {t.due&&<div style={{fontSize:9,color:overdue?"#e07070":isTod?"rgba(255,255,255,0.6)":C.muted}}>Fällig: {t.due}</div>}
                  {isAdmin&&u&&<div style={{display:"flex",alignItems:"center",gap:2,marginTop:1}}><Av name={u.name} color={u.color} size={11}/><span style={{fontSize:9,color:isTod?"rgba(255,255,255,0.6)":C.muted}}>{u.name.split(" ")[0]}</span></div>}
                </div>
                {canTog&&(
                  <div style={{display:"flex",flexDirection:"column",gap:1}}>
                    <button onClick={()=>setEditTd({date:t.date||date,id:t.id,text:t.text,due:t.due||""})} style={{border:"none",background:"none",cursor:"pointer",fontSize:11,color:isTod?"rgba(255,255,255,0.6)":C.muted,padding:0}}>✎</button>
                    <button onClick={()=>deleteTodo(date,t.id)} style={{border:"none",background:"none",cursor:"pointer",fontSize:11,color:isTod?"rgba(255,255,255,0.5)":C.red,padding:0}}>✕</button>
                  </div>
                )}
              </div>
            );
          })}
          {canEdit&&(addDay===date?(
            <div style={{background:C.white,borderRadius:5,padding:6,marginTop:4,border:"1px solid "+C.border}}>
              <input placeholder="To-Do…" value={nt.text} onChange={e=>setNt(p=>({...p,text:e.target.value}))} autoFocus style={{width:"100%",marginBottom:4,padding:"4px 6px",borderRadius:3,border:"1px solid "+C.border,fontSize:12,boxSizing:"border-box"}}/>
              {isAdmin&&<select value={nt.userId} onChange={e=>setNt(p=>({...p,userId:e.target.value}))} style={{width:"100%",marginBottom:4,padding:"3px 5px",borderRadius:3,border:"1px solid "+C.border,fontSize:11}}><option value="">Mitarbeiter…</option>{emps.map(u=><option key={u.id} value={u.id}>{u.name}</option>)}</select>}
              <select value={nt.labelId||""} onChange={e=>setNt(p=>({...p,labelId:e.target.value}))} style={{width:"100%",marginBottom:4,padding:"3px 5px",borderRadius:3,border:"1px solid "+C.border,fontSize:11}}>
                <option value="">Kein Label</option>
                {labels.map(l=><option key={l.id} value={l.id}>{l.name}</option>)}
              </select>
              <div style={{display:"flex",gap:3,marginBottom:4}}>
                <input type="date" value={nt.dateStart||date} onChange={e=>setNt(p=>({...p,dateStart:e.target.value}))} style={{flex:1,padding:"3px 5px",borderRadius:3,border:"1px solid "+C.border,fontSize:11,boxSizing:"border-box"}}/>
                <span style={{fontSize:10,color:C.muted,alignSelf:"center",padding:"0 2px"}}>bis</span>
                <input type="date" value={nt.dateEnd||date} onChange={e=>setNt(p=>({...p,dateEnd:e.target.value}))} style={{flex:1,padding:"3px 5px",borderRadius:3,border:"1px solid "+C.border,fontSize:11,boxSizing:"border-box"}}/>
              </div>
              <div style={{display:"flex",gap:3}}><button onClick={()=>{if(nt.text.trim()){addTodo(nt.dateStart||date,nt.userId||profile.id,nt.text,nt.due,nt.dateEnd||date,"",nt.labelId||"");setNt({text:"",userId:"",due:"",dateStart:"",dateEnd:"",labelId:""});setAddDay(null);}}} style={{flex:1,padding:"3px",border:"none",background:C.blue1,color:"#fff",borderRadius:3,cursor:"pointer",fontSize:11,fontWeight:700}}>+</button><button onClick={()=>setAddDay(null)} style={{padding:"3px 6px",border:"1px solid "+C.border,background:"transparent",borderRadius:3,cursor:"pointer",fontSize:11}}>✕</button></div>
            </div>
          ):<button onClick={()=>setAddDay(date)} style={{width:"100%",marginTop:4,padding:"3px",border:"1px dashed "+(isTod?"rgba(255,255,255,0.3)":C.border),background:"transparent",borderRadius:3,cursor:"pointer",fontSize:compact?10:11,color:isTod?"rgba(255,255,255,0.5)":C.muted}}>+ To-Do</button>)}
        </div>
      </div>
    );
  }

  function renderMonthView(){
    const n=new Date();n.setMonth(n.getMonth()+calOff);
    const yr=n.getFullYear();const mo=n.getMonth();
    const fd=(new Date(yr,mo,1).getDay()+6)%7;const dim=new Date(yr,mo+1,0).getDate();
    return(
      <div>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}><span style={{fontFamily:SR,fontSize:17,color:C.text}}>{MONTHSL[mo]+" "+yr}</span><div style={{display:"flex",gap:6}}><Btn sm outline onClick={()=>setCalOff(p=>p-1)}>{"<"}</Btn><Btn sm outline onClick={()=>setCalOff(0)}>Heute</Btn><Btn sm outline onClick={()=>setCalOff(p=>p+1)}>{">"}</Btn></div></div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(7,1fr)",gap:3,marginBottom:4}}>{DAYS.map(d=><div key={d} style={{textAlign:"center",fontSize:11,fontWeight:700,color:C.muted,padding:"4px 0"}}>{d}</div>)}</div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(7,1fr)",gap:3}}>
          {Array.from({length:fd}).map((_,i)=><div key={"e"+i} style={{minHeight:80}}/>)}
          {Array.from({length:dim}).map((_,i)=>{const day=i+1;const ds=yr+"-"+String(mo+1).padStart(2,"0")+"-"+String(day).padStart(2,"0");const items=getDayItems(ds);const isTod=ds===today();return(
            <div key={day} style={{minHeight:80,background:isTod?C.accentLight:C.white,border:"1.5px solid "+(isTod?C.blue1:C.border),borderRadius:6,padding:"4px 6px"}}>
              <div style={{fontSize:12,fontWeight:isTod?700:400,color:isTod?C.blue1:C.text,marginBottom:3}}>{day}</div>
              {items.map(t=>(
                <div key={t.id} style={{fontSize:10,padding:"3px 6px",borderRadius:3,background:t.done?"#e0e0e0":C.blue1,color:t.done?"#777":"#fff",marginBottom:2,display:"flex",alignItems:"center",gap:3,cursor:"pointer"}} onClick={()=>setEditTd({date:ds,id:t.id,text:t.text,due:t.due||""})}>
                  <input type="checkbox" checked={!!t.done} onChange={()=>toggleTodo(ds,t.id)} onClick={e=>e.stopPropagation()} style={{width:10,height:10,cursor:"pointer",flexShrink:0}}/>
                  <span style={{overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{t.text}</span>
                </div>
              ))}
            </div>
          );})}
        </div>
      </div>
    );
  }

  return(
    <div>
      {editTd&&(<div onClick={()=>setEditTd(null)} style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.45)",zIndex:200,display:"flex",alignItems:"center",justifyContent:"center",padding:"12px"}}><div onClick={e=>e.stopPropagation()} style={{background:C.white,borderRadius:10,padding:26,width:"100%",maxWidth:340,boxShadow:"0 20px 60px rgba(0,0,0,0.15)"}}><H2>To-Do bearbeiten</H2>
                  <Inp value={editTd.text} onChange={e=>setEditTd(p=>({...p,text:e.target.value}))} placeholder="Text…" style={{width:"100%",marginBottom:10}}/>
                  <div style={{display:"flex",gap:8,marginBottom:10,alignItems:"center"}}>
                    <Inp type="date" value={editTd.date||today()} onChange={e=>setEditTd(p=>({...p,date:e.target.value}))} style={{flex:1}}/>
                    <span style={{fontSize:12,color:C.muted}}>bis</span>
                    <Inp type="date" value={editTd.date_end||editTd.date||today()} onChange={e=>setEditTd(p=>({...p,date_end:e.target.value}))} style={{flex:1}}/>
                  </div>
                  <Inp type="date" value={editTd.due||""} onChange={e=>setEditTd(p=>({...p,due:e.target.value}))} placeholder="Fällig (optional)" style={{width:"100%",marginBottom:10}}/>
                  <select value={editTd.recurring||""} onChange={e=>setEditTd(p=>({...p,recurring:e.target.value}))} style={{width:"100%",marginBottom:16,padding:"9px 10px",borderRadius:6,border:"1.5px solid "+C.border,fontSize:14}}>
                    <option value="">Einmalig</option>
                    <option value="daily">🔁 Täglich</option>
                    <option value="weekly">🔁 Wöchentlich</option>
                    <option value="monthly">🔁 Monatlich</option>
                  </select><div style={{display:"flex",gap:8}}><Btn onClick={async()=>{await sb.from("todos").update({text:editTd.text,due:editTd.due,date:editTd.date,date_end:editTd.date_end||editTd.date,recurring:editTd.recurring||""}).eq("id",editTd.id);setTodos(prev=>{const next={...prev};Object.keys(next).forEach(ds=>{next[ds]=next[ds].map(x=>x.id===editTd.id?{...x,...editTd,date_end:editTd.date_end||editTd.date}:x);});return next;});setEditTd(null);}}>Speichern</Btn><Btn outline onClick={()=>setEditTd(null)}>Abbrechen</Btn></div></div></div>)}
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14,flexWrap:"wrap",gap:8}}>
        <H1>Wochenplan</H1>
        <div style={{display:"flex",gap:8,alignItems:"center",flexWrap:"wrap"}}>
          <div style={{display:"flex",border:"1px solid "+C.border,borderRadius:6,overflow:"hidden"}}>
            {[["week","1 Woche"],["2week","2 Wochen"],["month","Monat"]].map(([v,l])=>(
              <button key={v} onClick={()=>setViewMode(v)} style={{padding:"5px 10px",border:"none",background:viewMode===v?C.blue2:"transparent",color:viewMode===v?"#fff":C.muted,cursor:"pointer",fontSize:11,fontWeight:viewMode===v?700:400,fontFamily:SN}}>{l}</button>
            ))}
          </div>
          {viewMode!=="month"&&<><Btn sm outline onClick={()=>setOff(p=>p-1)}>{"<"}</Btn><Btn sm outline onClick={()=>setOff(0)}>Heute</Btn><Btn sm outline onClick={()=>setOff(p=>p+1)}>{">"}</Btn></>}
          {canEdit&&<Btn sm onClick={()=>setShowRec(p=>!p)}>🔁 Wiederkehrend</Btn>}
          <button onClick={()=>setShowLabelMgr(p=>!p)} title="Labels verwalten" style={{background:C.white,border:"1px solid "+C.border,borderRadius:6,padding:"6px 10px",cursor:"pointer",fontSize:13,color:C.muted}}>⚙ Labels</button>
        </div>
      </div>

      {showLabelMgr&&(
        <div style={{background:C.white,borderRadius:10,padding:20,border:"1px solid "+C.border,marginBottom:16}}>
          <div style={{fontFamily:SR,fontSize:18,fontWeight:400,color:C.text,marginBottom:14}}>Labels verwalten</div>
          <div style={{display:"flex",flexWrap:"wrap",gap:8,marginBottom:14}}>
            {labels.map(l=>(
              <div key={l.id} style={{display:"flex",alignItems:"center",gap:6,padding:"5px 10px",borderRadius:6,background:l.color+"15",border:"1px solid "+l.color+"44"}}>
                <div style={{width:12,height:12,borderRadius:"50%",background:l.color}}/>
                <span style={{fontSize:13,color:C.text,fontWeight:600}}>{l.name}</span>
                <button onClick={()=>saveLabels(labels.filter(x=>x.id!==l.id))} style={{border:"none",background:"none",color:C.red,cursor:"pointer",fontSize:13,padding:"0 2px"}}>✕</button>
              </div>
            ))}
          </div>
          <div style={{display:"flex",gap:8,alignItems:"center",flexWrap:"wrap"}}>
            <input type="color" value={newLabel.color} onChange={e=>setNewLabel(p=>({...p,color:e.target.value}))} style={{width:36,height:36,borderRadius:6,border:"1px solid "+C.border,cursor:"pointer",padding:2,flexShrink:0}}/>
            <input placeholder="Label Name…" value={newLabel.name} onChange={e=>setNewLabel(p=>({...p,name:e.target.value}))} onKeyDown={e=>{if(e.key==="Enter")addNewLabel();}} style={{flex:1,minWidth:80,padding:"7px 10px",borderRadius:6,border:"1px solid "+C.border,fontSize:13,outline:"none"}}/>
            <Btn sm onClick={addNewLabel}>+</Btn>
          </div>
        </div>
      )}

      {showRec&&canEdit&&(
        <div style={{background:C.white,borderRadius:10,padding:20,border:"1px solid "+C.border,marginBottom:16}}>
          <div style={{fontFamily:SR,fontSize:18,fontWeight:400,color:C.text,marginBottom:6}}>Wiederkehrende To-Dos</div>
          <p style={{fontSize:12,color:C.muted,marginBottom:14}}>↻ Einträge erscheinen automatisch an den gewählten Wochentagen. Täglich abhakbar, am nächsten Tag wieder aktiv.</p>
          {(recurringTodos||[]).filter(r=>isAdmin||r.user_id===profile.id).map(r=>{
            const u2=profiles.find(x=>x.id===r.user_id);
            const isE=editRec&&editRec.id===r.id;
            return(
              <div key={r.id} style={{background:"#f4f7fa",borderRadius:6,padding:"8px 10px",marginBottom:6,borderLeft:"3px solid "+C.teal1}}>
                {isE?(
                  <div style={{display:"flex",gap:6,flexWrap:"wrap",alignItems:"center"}}>
                    <input value={editRec.text} onChange={e=>setEditRec(p=>({...p,text:e.target.value}))} style={{flex:2,minWidth:120,padding:"6px 10px",borderRadius:4,border:"1px solid "+C.border,fontSize:13}}/>
                    <div style={{display:"flex",gap:3,flexWrap:"wrap"}}>{DAYS_SHORT.map((d,i)=><button key={i} onClick={()=>setEditRec(p=>({...p,days:p.days.includes(i)?p.days.filter(x=>x!==i):[...p.days,i]}))} style={{padding:"3px 7px",borderRadius:4,border:"1px solid "+(editRec.days.includes(i)?C.blue1:C.border),background:editRec.days.includes(i)?C.accentLight:"transparent",cursor:"pointer",fontSize:10,fontWeight:editRec.days.includes(i)?700:400}}>{d}</button>)}</div>
                    <Btn sm onClick={()=>editRecurring(r)}>Speichern</Btn>
                    <Btn sm outline onClick={()=>setEditRec(null)}>✕</Btn>
                  </div>
                ):(
                  <div style={{display:"flex",alignItems:"center",gap:10}}>
                    {u2&&<Av name={u2.name} color={u2.color} size={22}/>}
                    <span style={{flex:1,fontSize:13,color:C.text}}>↻ {r.text}</span>
                    <span style={{fontSize:11,color:C.muted}}>
                      {r.rec_type==="daily"?"Täglich":
                       r.rec_type==="monthly_date"?"Monatlich am "+r.days.join(".")+".":
                       r.rec_type==="monthly_weekday"?"Monatlich am "+r.days.map(d=>DAYS_SHORT[d]).join(", "):
                       r.days.map(d=>DAYS_SHORT[d]).join(", ")}
                    </span>
                    <Btn sm outline onClick={()=>setEditRec({id:r.id,text:r.text,days:r.days.slice(),label:r.label||""})}>✎</Btn>
                    <button onClick={()=>deleteRecurring(r.id)} style={{border:"none",background:"none",color:C.red,cursor:"pointer",fontSize:16}}>✕</button>
                  </div>
                )}
              </div>
            );
          })}
          <div style={{marginTop:12,paddingTop:12,borderTop:"1px solid "+C.border}}>
            <div style={{display:"flex",gap:8,flexWrap:"wrap",alignItems:"center",marginBottom:8}}>
              <input placeholder="Text*" value={nr.text} onChange={e=>setNr(p=>({...p,text:e.target.value}))} style={{flex:2,minWidth:150,padding:"8px 12px",borderRadius:6,border:"1px solid "+C.border,fontSize:13}}/>
              {isAdmin&&<select value={nr.userId||""} onChange={e=>setNr(p=>({...p,userId:e.target.value}))} style={{padding:"8px 10px",borderRadius:6,border:"1px solid "+C.border,fontSize:13}}><option value="">Mitarbeiter…</option>{emps.map(u=><option key={u.id} value={u.id}>{u.name}</option>)}</select>}
              <select value={nr.type||"weekly"} onChange={e=>setNr(p=>({...p,type:e.target.value,days:[]}))} style={{padding:"8px 10px",borderRadius:6,border:"1px solid "+C.border,fontSize:13}}>
                <option value="weekly">Wöchentlich (Wochentage)</option>
                <option value="monthly_weekday">Monatlich (Wochentag)</option>
                <option value="monthly_date">Monatlich (Datum)</option>
                <option value="daily">Täglich</option>
              </select>
            </div>
            {(nr.type==="weekly"||!nr.type)&&(
              <div style={{marginBottom:8}}>
                <div style={{fontSize:11,color:C.muted,marginBottom:5}}>Wochentage auswählen:</div>
                <div style={{display:"flex",gap:3,flexWrap:"wrap"}}>{DAYS_SHORT.map((d,i)=><button key={i} onClick={()=>setNr(p=>({...p,days:p.days.includes(i)?p.days.filter(x=>x!==i):[...p.days,i]}))} style={{padding:"4px 10px",borderRadius:4,border:"1px solid "+(nr.days.includes(i)?C.blue1:C.border),background:nr.days.includes(i)?C.accentLight:"transparent",cursor:"pointer",fontSize:12,fontWeight:nr.days.includes(i)?700:400}}>{d}</button>)}</div>
              </div>
            )}
            {nr.type==="monthly_weekday"&&(
              <div style={{marginBottom:8}}>
                <div style={{fontSize:11,color:C.muted,marginBottom:5}}>Jeden Monat an diesem Wochentag:</div>
                <div style={{display:"flex",gap:3,flexWrap:"wrap"}}>{DAYS_SHORT.map((d,i)=><button key={i} onClick={()=>setNr(p=>({...p,days:[i]}))} style={{padding:"4px 10px",borderRadius:4,border:"1px solid "+(nr.days[0]===i?C.blue1:C.border),background:nr.days[0]===i?C.accentLight:"transparent",cursor:"pointer",fontSize:12,fontWeight:nr.days[0]===i?700:400}}>{d}</button>)}</div>
              </div>
            )}
            {nr.type==="monthly_date"&&(
              <div style={{marginBottom:8}}>
                <div style={{fontSize:11,color:C.muted,marginBottom:5}}>Jeden Monat am:</div>
                <div style={{display:"flex",flexWrap:"wrap",gap:3}}>{Array.from({length:31},(_,i)=>i+1).map(d=><button key={d} onClick={()=>setNr(p=>({...p,days:[d]}))} style={{padding:"3px 7px",borderRadius:4,border:"1px solid "+(nr.days[0]===d?C.blue1:C.border),background:nr.days[0]===d?C.accentLight:"transparent",cursor:"pointer",fontSize:11,fontWeight:nr.days[0]===d?700:400}}>{d}.</button>)}</div>
              </div>
            )}
            {nr.type==="daily"&&<p style={{fontSize:12,color:C.muted,marginBottom:8}}>Erscheint jeden Tag.</p>}
            <Btn sm onClick={addRecurring}>+ Hinzufügen</Btn>
          </div>
        </div>
      )}
      {viewMode==="month"?renderMonthView():isMobW?(
        <div style={{display:"flex",flexDirection:"column",gap:6}}>{(viewMode==="2week"?[...week1,...week2]:week1).map(d=>renderDayCol(d,false))}</div>
      ):viewMode==="2week"?(
        <div style={{display:"flex",flexDirection:"column",gap:8,overflowX:"auto"}}>
          <div style={{display:"grid",gridTemplateColumns:"repeat(7,minmax(100px,1fr))",gap:5,minWidth:700}}>{week1.map(d=>renderDayCol(d,true))}</div>
          <div style={{display:"grid",gridTemplateColumns:"repeat(7,minmax(100px,1fr))",gap:5,minWidth:700}}>{week2.map(d=>renderDayCol(d,true))}</div>
        </div>
      ):(
        <div style={{display:"grid",gridTemplateColumns:"repeat(7,1fr)",gap:8}}>{week1.map(d=>renderDayCol(d,false))}</div>
      )}
    </div>
  );
}

// ── Chat View ──
function ChatView({profile,profiles,messages,sendMessage,initialDmWith,notifications,markRead,isMobile}){
  const isClient=profile?.role==="client";
  const isAdmin=profile?.role==="admin";
  const dmContacts=isClient?profiles.filter(p=>p.role==="admin"):profiles.filter(p=>p.id!==profile.id);
  // Für Kunden: automatisch den ersten Admin als DM-Ziel setzen
  const defaultDmTarget=isClient&&dmContacts.length>0?dmContacts[0].id:"";
  const [mode,setMode]=useState(initialDmWith?"dm":(isClient?"dm":"public"));
  const [dmTarget,setDmTarget]=useState(initialDmWith||defaultDmTarget);
  const ref=useRef();

  const teamMsgs=messages.filter(m=>!m.to);
  const dmMsgs=dmTarget?messages.filter(m=>(m.to===profile.id&&m.from===dmTarget)||(m.from===profile.id&&m.to===dmTarget)):[];
  const visible=mode==="public"?teamMsgs:dmMsgs;
  useEffect(()=>{if(ref.current)ref.current.scrollIntoView({behavior:"smooth"});},[visible.length,mode,dmTarget]);

  useEffect(()=>{
    if(mode==="dm"&&dmTarget){
      const toRead=notifications.filter(n=>n.userId===profile.id&&n.type==="dm"&&n.link&&n.link.dmWith===dmTarget&&!n.read);
      toRead.forEach(n=>markRead(n.id));
      // Mark DM messages as read
      const unreadMsgs=messages.filter(m=>m.to===profile.id&&m.from===dmTarget&&!(m.read_by||[]).includes(profile.id));
      if(unreadMsgs.length>0){
        unreadMsgs.forEach(async m=>{
          const newReadBy=[...(m.read_by||[]),profile.id];
          await sb.from("chat").update({read_by:newReadBy}).eq("id",m.id);
          setMessages(prev=>prev.map(x=>x.id===m.id?{...x,read_by:newReadBy}:x));
        });
      }
    }
  },[mode,dmTarget,messages.length]);

  // Mark messages as read when chat view is opened and DM is active
  useEffect(()=>{
    if(dmTarget&&mode==="dm"){
      const unreadMsgs=messages.filter(m=>m.to===profile.id&&m.from===dmTarget&&!(m.read_by||[]).includes(profile.id));
      if(unreadMsgs.length>0){
        unreadMsgs.forEach(async m=>{
          const newReadBy=[...(m.read_by||[]),profile.id];
          await sb.from("chat").update({read_by:newReadBy}).eq("id",m.id);
          setMessages(prev=>prev.map(x=>x.id===m.id?{...x,read_by:newReadBy}:x));
        });
      }
    }
  },[dmTarget]);

  async function send(text){
    if(!text.trim())return;
    const msg={id:uid(),from:profile.id,to:mode==="dm"?dmTarget:null,topic:"Team",text,time:nowT()};
    await sendMessage(msg);
  }

  async function deleteMessage(id){
    await sb.from("chat").delete().eq("id",id);
    setMessages(prev=>prev.filter(m=>m.id!==id));
  }

  const [editMsgId,setEditMsgId]=useState(null);
  const [editMsgText,setEditMsgText]=useState("");

  async function saveEditMessage(id){
    if(!editMsgText.trim())return;
    await sb.from("chat").update({text:editMsgText}).eq("id",id);
    setMessages(prev=>prev.map(m=>m.id===id?{...m,text:editMsgText}:m));
    setEditMsgId(null);setEditMsgText("");
  }

  // Letzte eigene Nachricht im aktuellen Modus
  const myLastMsg=visible.filter(m=>m.from===profile.id).slice(-1)[0];

  function lastDm(cId){const msgs=messages.filter(m=>(m.to===profile.id&&m.from===cId)||(m.from===profile.id&&m.to===cId));return msgs[msgs.length-1]||null;}

  const [mobileShowChat,setMobileShowChat]=useState(!!initialDmWith);
  return(
    <div style={{display:"flex",height:"calc(100vh - 140px)",borderRadius:10,overflow:"hidden",border:"1px solid "+C.border,background:C.white,flexDirection:isMobile?"column":"row"}}>
      <div style={{width:isMobile?"100%":240,background:"#f8fafc",borderRight:isMobile?"none":"1px solid "+C.border,borderBottom:isMobile?"1px solid "+C.border:"none",display:isMobile&&mobileShowChat?"none":"flex",flexDirection:"column",flexShrink:0,maxHeight:isMobile?"45%":"none"}}>
        <div style={{padding:"14px 16px",borderBottom:"1px solid "+C.border}}><div style={{fontFamily:SR,fontSize:17,color:C.text}}>Chat</div></div>
        {!isClient&&<div style={{padding:"10px 12px 4px"}}><button onClick={()=>{setMode("public");if(isMobile)setMobileShowChat(true);}} style={{width:"100%",padding:"8px 10px",borderRadius:6,border:"none",background:mode==="public"?C.accentLight:"transparent",color:mode==="public"?C.blue1:C.text,cursor:"pointer",fontSize:13,textAlign:"left",fontFamily:SN,fontWeight:mode==="public"?700:400}}>Team-Chat</button></div>}
        <div style={{padding:"10px 12px 4px",flex:1,overflowY:"auto"}}>
          {!isClient&&<div style={{fontSize:10,fontWeight:700,color:C.muted,textTransform:"uppercase",letterSpacing:1,marginBottom:6}}>Direktnachrichten</div>}
          {dmContacts.map(u=>{
            const last=lastDm(u.id);const active=mode==="dm"&&dmTarget===u.id;
            const unread=messages.filter(m=>m.to===profile.id&&m.from===u.id&&!(m.read_by||[]).includes(profile.id)).length;
            return(
              <button key={u.id} onClick={()=>{setMode("dm");setDmTarget(u.id);if(isMobile)setMobileShowChat(true);}} style={{width:"100%",padding:"8px 10px",borderRadius:6,border:"none",background:active?C.accentLight:"transparent",cursor:"pointer",textAlign:"left",fontFamily:SN,marginBottom:2,display:"flex",alignItems:"center",gap:8}}>
                <div style={{position:"relative",flexShrink:0}}><Av name={u.name} color={u.color} size={28}/><div style={{position:"absolute",bottom:0,right:0,width:8,height:8,borderRadius:"50%",background:C.green2,border:"1.5px solid #f8fafc"}}/></div>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{fontSize:13,color:active?C.blue1:C.text,fontWeight:active||unread>0?700:400,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{u.name}</div>
                  {last&&<div style={{fontSize:11,color:C.muted,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{last.text.slice(0,28)}{last.text.length>28?"...":""}</div>}
                </div>
                {unread>0&&!active&&<div style={{width:8,height:8,borderRadius:"50%",background:C.red,flexShrink:0}}/>}
              </button>
            );
          })}
        </div>
      </div>
      <div style={{flex:1,display:isMobile&&!mobileShowChat?"none":"flex",flexDirection:"column",minWidth:0}}>
        <div style={{padding:"12px 18px",borderBottom:"1px solid "+C.border,display:"flex",alignItems:"center",gap:10}}>
          {isMobile&&<button onClick={()=>setMobileShowChat(false)} style={{border:"none",background:"none",color:C.blue1,cursor:"pointer",fontSize:20,padding:"0 8px 0 0",lineHeight:1}}>←</button>}
          {mode==="dm"&&dmTarget?(()=>{const u=profiles.find(x=>x.id===dmTarget);return u?<><Av name={u.name} color={u.color} size={28}/><div><div style={{fontSize:14,fontWeight:700,color:C.text}}>{u.name}</div><div style={{fontSize:11,color:C.muted}}>{ROLE_L[u.role]}</div></div></>:null;})():<div style={{fontFamily:SR,fontSize:15,color:C.text}}>Team-Chat</div>}
        </div>
        <div style={{flex:1,overflowY:"auto",padding:"16px 18px"}}>
          {visible.length===0&&<div style={{textAlign:"center",color:C.muted,marginTop:40,fontFamily:SR,fontSize:15}}>Noch keine Nachrichten.</div>}
          {visible.map(m=>{
            const sender=profiles.find(p=>p.id===m.from);
            const isMe=m.from===profile.id;
            const isMyLast=myLastMsg&&m.id===myLastMsg.id;
            const canDelete=isAdmin||(isMe&&isMyLast);
            const canEdit=isMe&&isMyLast;
            const isEditing=editMsgId===m.id;
            return(
              <div key={m.id} style={{display:"flex",flexDirection:isMe?"row-reverse":"row",gap:10,marginBottom:14,alignItems:"flex-end"}}>
                {!isMe&&<Av name={sender?.name} color={sender?.color||C.blue2} size={30}/>}
                <div style={{maxWidth:"68%"}}>
                  {!isMe&&<div style={{fontSize:11,fontWeight:700,color:C.muted,marginBottom:3}}>{sender?.name}</div>}
                  {isEditing?(
                    <div style={{display:"flex",flexDirection:"column",gap:6}}>
                      <textarea value={editMsgText} onChange={e=>setEditMsgText(e.target.value)} autoFocus
                        style={{padding:"10px 14px",borderRadius:12,border:"1.5px solid "+C.blue1,fontSize:14,resize:"none",fontFamily:SN,minWidth:200,outline:"none",lineHeight:1.6}}
                        rows={3}/>
                      <div style={{display:"flex",gap:6,justifyContent:"flex-end"}}>
                        <Btn sm onClick={()=>saveEditMessage(m.id)}>Speichern</Btn>
                        <Btn sm outline onClick={()=>{setEditMsgId(null);setEditMsgText("");}}>Abbrechen</Btn>
                      </div>
                    </div>
                  ):(
                    <div style={{background:isMe?"linear-gradient(135deg,"+C.blue2+","+C.blue1+")":C.bg,color:isMe?C.white:C.text,borderRadius:isMe?"12px 12px 2px 12px":"12px 12px 12px 2px",padding:"10px 14px",whiteSpace:"pre-wrap",wordBreak:"break-word",lineHeight:1.6}}>
                      <span style={{fontSize:14}}>{m.text}</span>
                    </div>
                  )}
                  <div style={{fontSize:10,color:C.muted,marginTop:3,textAlign:isMe?"right":"left",display:"flex",alignItems:"center",gap:6,justifyContent:isMe?"flex-end":"flex-start"}}>
                    <span>{m.time}</span>
                    {canEdit&&!isEditing&&<button onClick={()=>{setEditMsgId(m.id);setEditMsgText(m.text);}} style={{border:"none",background:"none",color:isMe?"rgba(255,255,255,0.7)":C.muted,cursor:"pointer",fontSize:11,padding:0}}>✎</button>}
                    {canDelete&&!isEditing&&<button onClick={()=>{if(window.confirm("Nachricht löschen?"))deleteMessage(m.id);}} style={{border:"none",background:"none",color:C.red,cursor:"pointer",fontSize:11,padding:0,opacity:0.7}}>✕</button>}
                  </div>
                </div>
              </div>
            );
          })}
          <div ref={ref}/>
        </div>
        <div style={{padding:"12px 18px",borderTop:"1px solid "+C.border}}>
          {mode==="dm"&&!dmTarget?<div style={{textAlign:"center",color:C.muted,padding:"10px",fontSize:13}}>Bitte wähle links einen Kontakt aus.</div>:<MsgBox users={profiles} onSend={send} placeholder={mode==="dm"?"Nachricht schreiben…":"Nachricht ans Team…"} minRows={3}/>}
        </div>
      </div>
    </div>
  );
}

// ── Meetings View ──
function MeetingsView({profile,profiles,meetings,prospects,setProspects,addMeeting,updateMeeting,deleteMeeting,pushNotif,setPersonalTodos,session}){
  const isAdmin=profile?.role==="admin";
  const isClient=profile?.role==="client";
  const [tab,setTab]=useState(isClient?"client":"employee");
  const [showF,setShowF]=useState(false);
  const [editId,setEditId]=useState(null);
  const [editD,setEditD]=useState(null);
  const [reschedId,setReschedId]=useState(null);
  const [reschedDate,setReschedDate]=useState("");
  const [frm,setFrm]=useState(()=>{try{const s=sessionStorage.getItem("meetings_frm");return s?JSON.parse(s):{with:"",date:today(),topic:"",notes:"",openPoints:"",nextCall:"",meetLink:""};}catch{return {with:"",date:today(),topic:"",notes:"",openPoints:"",nextCall:"",meetLink:""};}});
  function setFrmAndSave(v){const next=typeof v==="function"?v(frm):v;setFrm(next);try{sessionStorage.setItem("meetings_frm",JSON.stringify(next));}catch{}}
  // Interessenten state
  const [prospectFrm,setProspectFrm]=useState(()=>{try{const s=sessionStorage.getItem("prospect_frm");return s?JSON.parse(s):{name:"",company:"",email:"",phone:"",date:today(),topic:"",notes:"",meetLink:""};}catch{return {name:"",company:"",email:"",phone:"",date:today(),topic:"",notes:"",meetLink:""};}});
  function setProspectFrmAndSave(v){const next=typeof v==="function"?v(prospectFrm):v;setProspectFrm(next);try{sessionStorage.setItem("prospect_frm",JSON.stringify(next));}catch{}}
  const [showProspectF,setShowProspectF]=useState(false);
  const [editProspectId,setEditProspectId]=useState(null);
  const [editProspectD,setEditProspectD]=useState(null);



  function genMeet(){return "https://meet.google.com/"+uid().slice(0,3)+"-"+uid().slice(0,4)+"-"+uid().slice(0,3);}
  let filtered=meetings.filter(m=>m.type===tab);
  if(!isAdmin)filtered=filtered.filter(m=>m.with===profile.id);
  filtered=filtered.sort((a,b)=>a.date.localeCompare(b.date));
  const tabs=isClient?[["client","Meine Termine"]]:isAdmin?[["employee","Mitarbeiter"],["client","Kunden"],["prospect","Interessenten"]]:[["employee","Mitarbeiter"]];
  const contacts=tab==="employee"?profiles.filter(p=>p.role==="employee"):profiles.filter(p=>p.role==="client");

  async function save(){
    if(!frm.with||!frm.topic)return;
    const base={...frm,type:tab};
    await addMeeting(base);
    setFrmAndSave({with:"",date:today(),topic:"",notes:"",openPoints:"",nextCall:"",meetLink:"",recurring:"",recurringDay:""});
    try{sessionStorage.removeItem("meetings_frm");}catch{}
    setShowF(false);
  }
  async function saveEdit(){await updateMeeting(editId,editD);setEditId(null);setEditD(null);}
  async function submitRs(id){if(!reschedDate)return;await updateMeeting(id,{rescheduleRequest:{by:profile.id,proposedDate:reschedDate,status:"pending"}});setReschedId(null);setReschedDate("");}

  async function saveProspect(){
    if(!prospectFrm.name||!prospectFrm.topic)return;
    const p={id:uid(),name:prospectFrm.name,company:prospectFrm.company||"",email:prospectFrm.email||"",phone:prospectFrm.phone||"",date:prospectFrm.date,topic:prospectFrm.topic,notes:prospectFrm.notes||"",meet_link:prospectFrm.meetLink||"",recurring:prospectFrm.recurring||"once"};
    await sb.from("prospects").insert(p);
    setProspects(prev=>[...prev,p]);
    // Automatisch in Meine To-Dos eintragen
    if(prospectFrm.date&&profile){
      const text="📅 Interessent: "+prospectFrm.name+(prospectFrm.company?" ("+prospectFrm.company+")":"")+" – "+prospectFrm.topic;
      const todoId=uid();
      const todoObj={id:todoId,user_id:profile?.id,text,done:false,due:"",date:prospectFrm.date,date_end:prospectFrm.date,recurrence:"none",label:""};
      const{error}=await sb.from("personal_todos").insert(todoObj);
      if(!error&&setPersonalTodos)setPersonalTodos(prev=>[...prev,{...todoObj,recurring:""}]);
    }
    // recurring info is stored on the prospect, next will be created when marked done
    setProspectFrmAndSave({name:"",company:"",email:"",phone:"",date:today(),topic:"",notes:"",meetLink:"",recurring:""});
    try{sessionStorage.removeItem("prospect_frm");}catch{}
    setShowProspectF(false);
  }
  async function saveProspectEdit(){
    if(!editProspectD)return;
    await sb.from("prospects").update(editProspectD).eq("id",editProspectId);
    setProspects(prev=>prev.map(p=>p.id===editProspectId?{...p,...editProspectD}:p));
    setEditProspectId(null);setEditProspectD(null);
  }
  async function deleteProspect(id){
    if(!window.confirm("Interessenten-Eintrag wirklich löschen?"))return;
    await sb.from("prospects").delete().eq("id",id);
    setProspects(prev=>prev.filter(p=>p.id!==id));
  }

  return(
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:18}}>
        <H1>Gespräche</H1>
        {isAdmin&&tab!=="prospect"&&<Btn onClick={()=>setShowF(p=>!p)}>+ Gespräch planen</Btn>}
        {isAdmin&&tab==="prospect"&&<Btn onClick={()=>setShowProspectF(p=>!p)}>+ Interessent eintragen</Btn>}
      </div>
      <div style={{display:"flex",marginBottom:22,borderBottom:"2px solid "+C.border}}>
        {tabs.map(([k,l])=>(<button key={k} onClick={()=>setTab(k)} style={{padding:"10px 22px",border:"none",background:"transparent",color:tab===k?C.blue1:C.muted,fontWeight:700,cursor:"pointer",fontSize:14,borderBottom:tab===k?"2px solid "+C.blue1:"2px solid transparent",marginBottom:-2,fontFamily:SN}}>{l}</button>))}
      </div>

      {/* Prospect form */}
      {showProspectF&&isAdmin&&tab==="prospect"&&(
        <Panel style={{marginBottom:22}}>
          <H2>Interessent eintragen</H2>
          <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:10}}>
            <Inp placeholder="Name*" value={prospectFrm.name} onChange={e=>setProspectFrmAndSave(p=>({...p,name:e.target.value}))} style={{flex:2,minWidth:150}}/>
            <Inp placeholder="Firma" value={prospectFrm.company} onChange={e=>setProspectFrmAndSave(p=>({...p,company:e.target.value}))} style={{flex:2,minWidth:150}}/>
            <Inp type="date" value={prospectFrm.date} onChange={e=>setProspectFrmAndSave(p=>({...p,date:e.target.value}))} style={{flex:1,minWidth:130}}/>
          </div>
          <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:10}}>
            <Inp placeholder="E-Mail" value={prospectFrm.email} onChange={e=>setProspectFrmAndSave(p=>({...p,email:e.target.value}))} type="email" style={{flex:2,minWidth:160}}/>
            <Inp placeholder="Telefon" value={prospectFrm.phone} onChange={e=>setProspectFrmAndSave(p=>({...p,phone:e.target.value}))} style={{flex:1,minWidth:130}}/>
          </div>
          <Inp placeholder="Thema*" value={prospectFrm.topic} onChange={e=>setProspectFrmAndSave(p=>({...p,topic:e.target.value}))} style={{width:"100%",marginBottom:10}}/>
          <Inp placeholder="Meet Link" value={prospectFrm.meetLink||""} onChange={e=>setProspectFrmAndSave(p=>({...p,meetLink:e.target.value}))} style={{width:"100%",marginBottom:10}}/>
          <textarea placeholder="Notizen" value={prospectFrm.notes} onChange={e=>setProspectFrmAndSave(p=>({...p,notes:e.target.value}))} rows={3}
            style={{width:"100%",marginBottom:10,padding:"9px 12px",borderRadius:6,border:"1px solid "+C.border,fontSize:13,resize:"vertical",boxSizing:"border-box",fontFamily:SN}}/>
          <div style={{display:"flex",gap:8,marginBottom:10,alignItems:"center",flexWrap:"wrap"}}>
            <select value={prospectFrm.recurring||"once"} onChange={e=>setProspectFrmAndSave(p=>({...p,recurring:e.target.value}))} style={{flex:1,minWidth:160,padding:"9px 10px",borderRadius:6,border:"1px solid "+C.border,fontSize:14}}>
              <option value="once">Einmalig</option>
              <option value="weekly">Wöchentlich</option>
              <option value="biweekly">Alle 2 Wochen</option>
              <option value="monthly">Monatlich</option>
            </select>
            {prospectFrm.recurring&&prospectFrm.recurring!=="once"&&<span style={{fontSize:12,color:C.muted,padding:"4px 10px",background:C.accentLight,borderRadius:6}}>↻ 4 weitere Termine werden erstellt</span>}
          </div>
          <div style={{display:"flex",gap:8}}><Btn onClick={saveProspect}>Speichern</Btn><Btn outline onClick={()=>setShowProspectF(false)}>Abbrechen</Btn></div>
        </Panel>
      )}

      {/* Regular meeting form */}
      {showF&&isAdmin&&tab!=="prospect"&&(
        <Panel style={{marginBottom:22}}>
          <H2>Gespräch planen</H2>
          <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:10}}>
            <select value={frm.with} onChange={e=>setFrmAndSave(p=>({...p,with:e.target.value}))} style={{flex:1,minWidth:130,padding:"9px 10px",borderRadius:6,border:"1px solid "+C.border,fontSize:14}}>
              <option value="">Person…</option>{contacts.map(u=><option key={u.id} value={u.id}>{u.name}</option>)}
            </select>
            <Inp type="date" value={frm.date} onChange={e=>setFrmAndSave(p=>({...p,date:e.target.value}))} style={{flex:1,minWidth:130}}/>
            <Inp placeholder="Thema" value={frm.topic} onChange={e=>setFrmAndSave(p=>({...p,topic:e.target.value}))} style={{flex:2,minWidth:160}}/>
          </div>
          <Inp placeholder="Meet Link" value={frm.meetLink} onChange={e=>setFrm(p=>({...p,meetLink:e.target.value}))} style={{width:"100%",marginBottom:10}}/>
          <div style={{display:"flex",gap:8,alignItems:"center",marginBottom:10,flexWrap:"wrap"}}>
            <select value={frm.recurring||"once"} onChange={e=>setFrmAndSave(p=>({...p,recurring:e.target.value}))} style={{flex:1,minWidth:160,padding:"9px 10px",borderRadius:6,border:"1px solid "+C.border,fontSize:14}}>
              <option value="once">Einmalig</option>
              <option value="weekly">Wöchentlich</option>
              <option value="biweekly">Alle 2 Wochen</option>
              <option value="monthly">Monatlich</option>
            </select>
            {frm.recurring&&frm.recurring!=="once"&&frm.recurring&&(
              <span style={{fontSize:12,color:C.muted,padding:"4px 10px",background:C.accentLight,borderRadius:6}}>
                {frm.recurring==="weekly"?"↻ 4 weitere Termine werden automatisch erstellt":
                 frm.recurring==="biweekly"?"↻ 4 weitere Termine (2-wöchentlich) werden erstellt":
                 "↻ 4 weitere Termine (monatlich) werden erstellt"}
              </span>
            )}
          </div>
          <Btn onClick={save}>Speichern</Btn>
        </Panel>
      )}

      {/* Prospects list */}
      {tab==="prospect"&&(
        <div>
          {prospects.length===0&&<p style={{color:C.muted,fontSize:14}}>Noch keine Interessenten eingetragen.</p>}
          {prospects.sort((a,b)=>b.date.localeCompare(a.date)).map(p=>{
            const isE=editProspectId===p.id;
            return(
              <Panel key={p.id} style={{marginBottom:12}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",flexWrap:"wrap",gap:8}}>
                  <div style={{display:"flex",alignItems:"center",gap:12}}>
                    <div style={{width:42,height:42,borderRadius:"50%",background:"linear-gradient(135deg,"+C.teal1+","+C.teal2+")",display:"flex",alignItems:"center",justifyContent:"center",color:"#fff",fontWeight:700,fontSize:16,flexShrink:0}}>
                      {(p.name||"?")[0].toUpperCase()}
                    </div>
                    <div>
                      {isE?(
                        <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
                          <Inp value={editProspectD.name} onChange={e=>setEditProspectD(x=>({...x,name:e.target.value}))} placeholder="Name*" style={{minWidth:130}}/>
                          <Inp value={editProspectD.topic} onChange={e=>setEditProspectD(x=>({...x,topic:e.target.value}))} placeholder="Thema*" style={{minWidth:140}}/>
                          <Inp type="date" value={editProspectD.date} onChange={e=>setEditProspectD(x=>({...x,date:e.target.value}))} style={{minWidth:130}}/>
                        </div>
                      ):(
                        <div>
                          <div style={{fontFamily:SR,fontSize:16,color:C.text}}>{p.name}</div>
                          <div style={{fontSize:12,color:C.muted,marginTop:2}}>
                            {p.company&&<span style={{marginRight:8,fontWeight:600,color:C.blue1}}>{p.company}</span>}
                            {p.date}
                          </div>
                          <div style={{display:"flex",gap:10,marginTop:4,flexWrap:"wrap"}}>
                            {p.email&&<a href={"mailto:"+p.email} style={{fontSize:12,color:C.blue1}}>✉ {p.email}</a>}
                            {p.phone&&<a href={"tel:"+p.phone} style={{fontSize:12,color:C.teal2}}>📞 {p.phone}</a>}
                            {(p.meet_link||p.meetLink)&&<a href={p.meet_link||p.meetLink} target="_blank" rel="noreferrer" style={{fontSize:12,color:C.blue1,fontWeight:700}}>🎥 Meet beitreten</a>}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                    {isE?(
                      <><Btn sm onClick={saveProspectEdit}>Speichern</Btn><Btn sm outline onClick={()=>setEditProspectId(null)}>Abbrechen</Btn></>
                    ):(
                      <><Btn sm outline onClick={()=>{setEditProspectId(p.id);setEditProspectD({name:p.name,meetLink:p.meetLink||"",company:p.company||"",email:p.email||"",phone:p.phone||"",date:p.date,topic:p.topic,notes:p.notes||""});}}>Bearbeiten</Btn>
                      <button onClick={()=>deleteProspect(p.id)} style={{border:"none",background:"none",color:C.red,cursor:"pointer",fontSize:17}}>✕</button></>
                    )}
                  </div>
                </div>
                {isE&&editProspectD&&(
                  <div style={{borderTop:"1px solid "+C.border,paddingTop:12,marginTop:12}}>
                    <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:10}}>
                      <Inp value={editProspectD.company} onChange={e=>setEditProspectD(x=>({...x,company:e.target.value}))} placeholder="Firma" style={{flex:1,minWidth:140}}/>
                      <Inp value={editProspectD.email} onChange={e=>setEditProspectD(x=>({...x,email:e.target.value}))} placeholder="E-Mail" type="email" style={{flex:1,minWidth:150}}/>
                      <Inp value={editProspectD.phone} onChange={e=>setEditProspectD(x=>({...x,phone:e.target.value}))} placeholder="Telefon" style={{flex:1,minWidth:120}}/>
                      <Inp value={editProspectD.meetLink||""} onChange={e=>setEditProspectD(x=>({...x,meetLink:e.target.value}))} placeholder="Meet Link" style={{flex:1,minWidth:150}}/>
                    </div>
                    <textarea value={editProspectD.notes} onChange={e=>setEditProspectD(x=>({...x,notes:e.target.value}))} rows={3} placeholder="Notizen…"
                      style={{width:"100%",padding:"9px 10px",borderRadius:6,border:"1px solid "+C.border,fontSize:13,resize:"vertical",boxSizing:"border-box"}}/>
                  </div>
                )}
                {!isE&&(
                  <div style={{marginTop:10}}>
                    <div style={{fontSize:12,fontWeight:700,color:C.text,marginBottom:3}}>{p.topic}</div>
                    {p.notes&&<div style={{background:C.bg,borderRadius:6,padding:"8px 12px",fontSize:13,color:C.text,lineHeight:1.6}}>{p.notes}</div>}
                  </div>
                )}
              </Panel>
            );
          })}
        </div>
      )}

      {/* Regular meetings list */}
      {tab!=="prospect"&&(
        <div>
          {filtered.length===0&&<p style={{color:C.muted,fontSize:14}}>Keine Gespräche vorhanden.</p>}
          {filtered.map(m=>{
            const person=profiles.find(p=>p.id===m.with);const isE=editId===m.id;
            const hasRs=m.rescheduleRequest&&m.rescheduleRequest.status==="pending";
            return(
              <Panel key={m.id} style={{marginBottom:12,opacity:m.done?0.65:1}}>
                <div style={{display:"flex",flexDirection:"column",gap:10}}>
                  <div style={{display:"flex",alignItems:"center",gap:10}}>
                    {person&&<Av name={person.name} color={person.color} size={38}/>}
                    <div style={{flex:1,minWidth:0}}>
                      {isE?(<div style={{display:"flex",flexDirection:"column",gap:6}}><Inp value={editD.topic} onChange={e=>setEditD(p=>({...p,topic:e.target.value}))} style={{width:"100%"}}/><Inp type="date" value={editD.date} onChange={e=>setEditD(p=>({...p,date:e.target.value}))} style={{width:"100%"}}/></div>):(
                        <div>
                          <div style={{fontFamily:SR,fontSize:15,color:C.text,wordBreak:"break-word"}}>{m.topic}{m.recurring&&m.recurring!=="once"&&<span style={{fontSize:10,marginLeft:6,color:C.teal1,fontWeight:700}}>↻ {m.recurring==="weekly"?"wöchentlich":m.recurring==="biweekly"?"2-wöchentlich":"monatlich"}</span>}</div>
                          <div style={{fontSize:12,color:C.muted,marginTop:2}}>{(person?person.name:"")+" · "+m.date}</div>
                          {m.meetLink&&<a href={m.meetLink} target="_blank" rel="noreferrer" style={{fontSize:12,color:C.blue1,fontWeight:700,display:"block",marginTop:4}}>🎥 Meet beitreten</a>}
                          {hasRs&&<div style={{fontSize:11,color:"#b8860b",background:"#fffbeb",padding:"3px 8px",borderRadius:4,marginTop:4,display:"inline-block"}}>Verschiebung: {m.rescheduleRequest.proposedDate}</div>}
                        </div>
                      )}
                    </div>
                  </div>
                  <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                    {isE?(<><Btn sm onClick={saveEdit}>Speichern</Btn><Btn sm outline onClick={()=>setEditId(null)}>Abbrechen</Btn></>):(
                      <>{isAdmin&&<Btn sm outline onClick={()=>{setEditId(m.id);setEditD({topic:m.topic,date:m.date,notes:m.notes||"",openPoints:m.openPoints||"",nextCall:m.nextCall||"",meetLink:m.meetLink||""});}}>✎ Bearbeiten</Btn>}{isAdmin&&<Btn sm outline onClick={()=>updateMeeting(m.id,{done:!m.done})}>{m.done?"↩ Wiederherstellen":"✓ Abhaken"}</Btn>}{isAdmin&&<button onClick={()=>deleteMeeting(m.id)} style={{border:"none",background:"none",color:C.red,cursor:"pointer",fontSize:20,padding:"0 2px"}}>✕</button>}{!m.done&&reschedId!==m.id&&<Btn sm outline onClick={()=>setReschedId(m.id)}>Verschieben?</Btn>}{isAdmin&&hasRs&&(<><Btn sm onClick={()=>updateMeeting(m.id,{date:m.rescheduleRequest.proposedDate,rescheduleRequest:{...m.rescheduleRequest,status:"accepted"}})} style={{background:C.green2,borderColor:C.green2,color:"#fff"}}>✓ Annehmen</Btn><Btn sm onClick={()=>updateMeeting(m.id,{rescheduleRequest:{...m.rescheduleRequest,status:"rejected"}})} style={{background:C.red,borderColor:C.red,color:"#fff"}}>✕ Ablehnen</Btn></>)}</>
                    )}
                  </div>
                </div>
                {reschedId===m.id&&(<div style={{borderTop:"1px solid "+C.border,paddingTop:12,marginTop:12}}><div style={{display:"flex",gap:8,marginBottom:8}}><Inp type="date" value={reschedDate} onChange={e=>setReschedDate(e.target.value)} style={{flex:1}}/></div><div style={{display:"flex",gap:8}}><Btn sm onClick={()=>submitRs(m.id)}>Anfrage senden</Btn><Btn sm outline onClick={()=>setReschedId(null)}>Abbrechen</Btn></div></div>)}
                {isE&&editD&&(<div style={{borderTop:"1px solid "+C.border,paddingTop:12,marginTop:12}}><div style={{display:"flex",gap:14,flexWrap:"wrap",marginBottom:10}}><div style={{flex:1,minWidth:190}}><div style={{fontSize:11,fontWeight:700,color:C.muted,marginBottom:5}}>Notizen</div><textarea value={editD.notes} onChange={e=>setEditD(p=>({...p,notes:e.target.value}))} rows={4} style={{width:"100%",padding:"9px 10px",borderRadius:6,border:"1px solid "+C.border,fontSize:13,resize:"vertical",boxSizing:"border-box"}}/></div><div style={{flex:1,minWidth:190}}><div style={{fontSize:11,fontWeight:700,color:C.muted,marginBottom:5}}>Offene Punkte</div><textarea value={editD.openPoints} onChange={e=>setEditD(p=>({...p,openPoints:e.target.value}))} rows={4} style={{width:"100%",padding:"9px 10px",borderRadius:6,border:"1px solid "+C.border,fontSize:13,resize:"vertical",boxSizing:"border-box"}}/></div></div><div style={{display:"flex",gap:8,alignItems:"center"}}><Inp placeholder="Meet Link" value={editD.meetLink} onChange={e=>setEditD(p=>({...p,meetLink:e.target.value}))} style={{flex:1}}/><Btn sm onClick={()=>setEditD(p=>({...p,meetLink:genMeet()}))}>Neu</Btn></div></div>)}
                {!isE&&(m.notes||m.openPoints)&&(<div style={{display:"flex",gap:12,marginTop:12,flexWrap:"wrap"}}>{m.notes&&<div style={{flex:1,minWidth:180,background:C.bg,padding:"9px 12px",borderRadius:6}}><div style={{fontSize:11,fontWeight:700,color:C.muted,marginBottom:3}}>NOTIZEN</div><p style={{margin:0,fontSize:13,color:C.text,lineHeight:1.6}}>{m.notes}</p></div>}{m.openPoints&&<div style={{flex:1,minWidth:180,background:C.accentLight,padding:"9px 12px",borderRadius:6}}><div style={{fontSize:11,fontWeight:700,color:C.blue1,marginBottom:3}}>OFFENE PUNKTE</div><p style={{margin:0,fontSize:13,color:C.text,lineHeight:1.6}}>{m.openPoints}</p></div>}</div>)}
              </Panel>
            );
          })}
        </div>
      )}
    </div>
  );
}


// ── Personal Todos ──
// ── Personal Todos ──
const DEFAULT_LABELS=[
  {id:"linkedin",name:"LinkedIn",color:"#0A66C2"},
  {id:"instagram",name:"Instagram",color:"#E1306C"},
  {id:"allgemein",name:"Allgemein",color:"#4A7BAF"},
];

function PersonalTodosView({profile,profiles,personalTodos,setPersonalTodos,recurringTodos,recurringDone,setRecurringTodos,setRecurringDone,isMobile}){
  const [isMob2,setIsMob2]=useState(window.innerWidth<=768);
  useEffect(()=>{const h=()=>setIsMob2(window.innerWidth<=768);window.addEventListener("resize",h);return()=>window.removeEventListener("resize",h);},[]);
  const mob=isMob2||isMobile||false;
  const [viewMode,setViewMode]=useState(window.innerWidth<=768?"week":"2week");
  const [off,setOff]=useState(0);
  const [calOff,setCalOff]=useState(0);
  const [showAdd,setShowAdd]=useState(null); // date string or "quick"
  const [nt,setNt]=useState({text:"",due:"",date:today(),dateEnd:"",labelId:"",recurring:""});
  const [editTodo,setEditTodo]=useState(null);
  const [showLabelMgr,setShowLabelMgr]=useState(false);
  const [labels,setLabels]=useState(()=>{try{const s=localStorage.getItem("ptodo_labels");return s?JSON.parse(s):DEFAULT_LABELS;}catch{return DEFAULT_LABELS;}});
  const [newLabel,setNewLabel]=useState({name:"",color:"#4A7BAF"});
  const [editLabel,setEditLabel]=useState(null);
  const week1=weekDays(off);
  const week2=weekDays(off+1);

  function saveLabels(next){setLabels(next);try{localStorage.setItem("ptodo_labels",JSON.stringify(next));}catch{}}
  function getLabelById(id){return labels.find(l=>l.id===id)||null;}

  async function addTodo(date){
    const text=nt.text.trim();if(!text)return;
    const startDate=date||nt.date;
    const endDate=nt.dateEnd||startDate;
    const t={id:uid(),user_id:profile.id,text,done:false,due:nt.due,date:startDate,date_end:endDate,label:nt.labelId||"",recurring:nt.recurring||""};
    await sb.from("personal_todos").insert(t);
    setPersonalTodos(prev=>[...prev,t]);
    setNt({text:"",due:"",date:today(),dateEnd:"",labelId:"",recurring:""});
    setShowAdd(null);
  }
  async function toggleTodo(id){
    const t=personalTodos.find(x=>x.id===id);if(!t)return;
    const newDone=!t.done;
    await sb.from("personal_todos").update({done:newDone}).eq("id",id);
    setPersonalTodos(prev=>prev.map(x=>x.id===id?{...x,done:newDone}:x));
    // Create next recurring todo when marked done
    if(newDone&&t.recurring&&t.recurring!==""){
      const baseDate=t.date_end&&t.date_end!==t.date?t.date_end:t.date;
      const d=new Date(baseDate+"T00:00:00");
      if(t.recurring==="daily")d.setDate(d.getDate()+1);
      else if(t.recurring==="weekly")d.setDate(d.getDate()+7);
      else if(t.recurring==="monthly")d.setMonth(d.getMonth()+1);
      const nextDate=d.toISOString().slice(0,10);
      const exists=personalTodos.find(x=>x.id!==id&&x.text===t.text&&x.date===nextDate&&!x.done&&x.recurring===t.recurring);
      if(!exists){
        const next={id:uid(),user_id:profile.id,text:t.text,done:false,due:t.due||"",date:nextDate,date_end:nextDate,label:t.label||"",recurring:t.recurring};
        await sb.from("personal_todos").insert(next);
        setPersonalTodos(prev=>[...prev,next]);
      }
    }
  }
  async function deleteTodo(id){
    await sb.from("personal_todos").delete().eq("id",id);
    setPersonalTodos(prev=>prev.filter(x=>x.id!==id));
  }
  async function saveEdit(){
    if(!editTodo)return;
    await sb.from("personal_todos").update({text:editTodo.text,due:editTodo.due,label:editTodo.label||"",recurring:editTodo.recurring||"",date:editTodo.date,date_end:editTodo.date_end||editTodo.date}).eq("id",editTodo.id);
    setPersonalTodos(prev=>prev.map(x=>x.id===editTodo.id?{...x,...editTodo}:x));
    setEditTodo(null);
  }

  function renderTodoItem(t,isTod,currentDate){
    const lbl=getLabelById(t.label);
    const overdue=t.due&&t.due<today()&&!t.done;
    const isMultiDay=t.date_end&&t.date_end!==t.date;
    const isStart=!currentDate||t.date===currentDate;
    const barColor=lbl?lbl.color:C.blue1;
    return(
      <div key={t.id} style={{display:"flex",alignItems:"flex-start",gap:6,marginBottom:5,padding:"6px 8px",borderRadius:6,background:isMultiDay?(isTod?"rgba(255,255,255,0.18)":barColor+"18"):isTod?"rgba(255,255,255,0.12)":"#f4f7fa",border:overdue?"1px solid #e07070":isMultiDay?"1px solid "+barColor+"33":"1px solid transparent",borderLeft:"3px solid "+(isMultiDay?barColor:lbl?lbl.color:"transparent")}}>
        {isStart?<input type="checkbox" checked={!!t.done} onChange={()=>toggleTodo(t.id)} style={{marginTop:3,accentColor:C.blue1,cursor:"pointer",flexShrink:0}}/>:<div style={{width:14,flexShrink:0}}/>}
        <div style={{flex:1,minWidth:0}}>
          <div style={{fontSize:12,lineHeight:1.4,wordBreak:"break-word",textDecoration:t.done?"line-through":"none",color:isTod?(t.done?"rgba(255,255,255,0.45)":"#fff"):(t.done?C.muted:isMultiDay?barColor:C.text)}}>{isStart?t.text:"↳ "+t.text}</div>
          {isStart&&<div style={{display:"flex",gap:5,marginTop:3,flexWrap:"wrap",alignItems:"center"}}>
            {lbl&&<span style={{fontSize:9,fontWeight:700,padding:"1px 6px",borderRadius:99,background:lbl.color+"22",color:lbl.color,border:"1px solid "+lbl.color+"44"}}>{lbl.name}</span>}
            {t.recurring&&<span style={{fontSize:9,color:isTod?"rgba(255,255,255,0.6)":C.muted}}>{t.recurring==="daily"?"🔁 täglich":t.recurring==="weekly"?"🔁 wöchentlich":"🔁 monatlich"}</span>}
            {isMultiDay&&<span style={{fontSize:9,color:isTod?"rgba(255,255,255,0.6)":barColor}}>📅 bis {t.date_end}</span>}
            {!isMultiDay&&t.due&&<span style={{fontSize:9,color:overdue?"#e07070":isTod?"rgba(255,255,255,0.6)":C.muted}}>📅 {t.due}</span>}
          </div>}
        </div>
        {isStart&&<div style={{display:"flex",gap:2,flexShrink:0}}>
          <button onClick={()=>setEditTodo({...t})} style={{border:"none",background:"none",cursor:"pointer",fontSize:11,color:isTod?"rgba(255,255,255,0.6)":C.muted,padding:"1px 3px"}}>✎</button>
          <button onClick={()=>deleteTodo(t.id)} style={{border:"none",background:"none",cursor:"pointer",fontSize:11,color:isTod?"rgba(255,255,255,0.5)":C.red,padding:"1px 3px"}}>✕</button>
        </div>}
      </div>
    );
  }

  function renderAddForm(date){
    return(
      <div style={{background:C.white,borderRadius:6,padding:8,marginTop:4,border:"1px solid "+C.border}}>
        <input placeholder="To-Do…" value={nt.text} onChange={e=>setNt(p=>({...p,text:e.target.value}))}
          onKeyDown={e=>{if(e.key==="Enter"&&nt.text.trim())addTodo(date);if(e.key==="Escape")setShowAdd(null);}}
          autoFocus style={{width:"100%",marginBottom:5,padding:"5px 8px",borderRadius:4,border:"1px solid "+C.border,fontSize:12,boxSizing:"border-box"}}/>
        <div style={{display:"flex",gap:4,marginBottom:4,flexWrap:"wrap"}}>
          <select value={nt.labelId} onChange={e=>setNt(p=>({...p,labelId:e.target.value}))}
            style={{flex:1,minWidth:90,padding:"4px 6px",borderRadius:4,border:"1px solid "+C.border,fontSize:11}}>
            <option value="">Kein Label</option>
            {labels.map(l=><option key={l.id} value={l.id}>{l.name}</option>)}
          </select>
          <select value={nt.recurring||""} onChange={e=>setNt(p=>({...p,recurring:e.target.value}))}
            style={{flex:1,minWidth:90,padding:"4px 6px",borderRadius:4,border:"1px solid "+C.border,fontSize:11}}>
            <option value="">Einmalig</option>
            <option value="daily">🔁 Täglich</option>
            <option value="weekly">🔁 Wöchentlich</option>
            <option value="monthly">🔁 Monatlich</option>
          </select>
        </div>
        <div style={{display:"flex",gap:4,marginBottom:5,alignItems:"center"}}>
          <input type="date" value={nt.due||date} onChange={e=>setNt(p=>({...p,due:e.target.value}))}
            style={{flex:1,padding:"4px 6px",borderRadius:4,border:"1px solid "+C.border,fontSize:11,boxSizing:"border-box"}}/>
          <span style={{fontSize:10,color:C.muted}}>bis</span>
          <input type="date" value={nt.dateEnd||""} onChange={e=>setNt(p=>({...p,dateEnd:e.target.value}))}
            style={{flex:1,padding:"4px 6px",borderRadius:4,border:"1px solid "+C.border,fontSize:11,boxSizing:"border-box"}}/>
        </div>
        <div style={{display:"flex",gap:4}}>
          <button onClick={()=>addTodo(date)} style={{flex:1,padding:"4px",border:"none",background:C.blue1,color:"#fff",borderRadius:4,cursor:"pointer",fontSize:11,fontWeight:700}}>+</button>
          <button onClick={()=>setShowAdd(null)} style={{padding:"4px 8px",border:"1px solid "+C.border,background:"transparent",borderRadius:4,cursor:"pointer",fontSize:11}}>✕</button>
        </div>
      </div>
    );
  }

  function renderDayCol(date,compact){
    const dayOfWeek=new Date(date+"T00:00:00").getDay();
    const isWE=dayOfWeek===0||dayOfWeek===6;
    const isTod=date===today();
    const dayIdx=(dayOfWeek+6)%7;
    const isMob=mob;
    const items=personalTodos.filter(t=>{
      if(t.date_end&&t.date_end!==t.date){
        return date>=t.date&&date<=t.date_end;
      }
      return t.date===date;
    });
    const open=items.filter(t=>!t.done);
    const done=items.filter(t=>t.done);
    return(
      <div key={date} style={{background:isTod?"linear-gradient(135deg,"+C.blue2+","+C.blue1+")":isWE?"#eef2f7":C.white,borderRadius:8,border:"1.5px solid "+(isTod?C.blue1:C.border),display:"flex",flexDirection:isMob?"row":"column",minHeight:isMob?0:(compact?120:200)}}>
        <div style={{padding:isMob?"10px 12px":"9px 11px 5px",borderBottom:isMob?"none":"1px solid "+(isTod?"rgba(255,255,255,0.15)":C.border),borderRight:isMob?"1px solid "+(isTod?"rgba(255,255,255,0.15)":C.border):"none",minWidth:isMob?56:0,width:isMob?56:undefined,display:"flex",flexDirection:"column",justifyContent:"center",alignItems:isMob?"center":"flex-start",flexShrink:0}}>
          <div style={{fontSize:10,fontWeight:700,color:isTod?"rgba(255,255,255,0.7)":C.muted,textTransform:"uppercase",letterSpacing:1}}>{DAYS[dayIdx]}</div>
          <div style={{fontFamily:SR,fontSize:isMob?18:20,color:isTod?C.white:C.text,fontWeight:600}}>{new Date(date+"T00:00:00").getDate()}</div>
          {items.length>0&&<div style={{fontSize:9,color:isTod?"rgba(255,255,255,0.6)":C.muted,marginTop:1}}>{open.length} offen</div>}
        </div>
        <div style={{flex:1,padding:"6px 8px",overflowY:"auto"}}>
          {open.map(t=>renderTodoItem(t,isTod,date))}
          {done.length>0&&<details style={{marginTop:4}}><summary style={{fontSize:9,color:isTod?"rgba(255,255,255,0.45)":C.muted,cursor:"pointer",listStyle:"none"}}>✓ {done.length} erledigt</summary>{done.map(t=>renderTodoItem(t,isTod,date))}</details>}
          {showAdd===date ? renderAddForm(date) : (
            <button onClick={()=>{setShowAdd(date);setNt({text:"",due:"",date,labelId:""}); }}
              style={{width:"100%",marginTop:4,padding:"3px",border:"1px dashed "+(isTod?"rgba(255,255,255,0.3)":C.border),background:"transparent",borderRadius:3,cursor:"pointer",fontSize:compact?10:11,color:isTod?"rgba(255,255,255,0.5)":C.muted}}>+ To-Do</button>
          )}
        </div>
      </div>
    );
  }

  function renderMonthView(){
    const n=new Date();n.setMonth(n.getMonth()+calOff);
    const yr=n.getFullYear();const mo=n.getMonth();
    const fd=(new Date(yr,mo,1).getDay()+6)%7;const dim=new Date(yr,mo+1,0).getDate();
    return(
      <div>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
          <span style={{fontFamily:SR,fontSize:17,color:C.text}}>{MONTHSL[mo]+" "+yr}</span>
          <div style={{display:"flex",gap:6}}><Btn sm outline onClick={()=>setCalOff(p=>p-1)}>{"<"}</Btn><Btn sm outline onClick={()=>setCalOff(0)}>Heute</Btn><Btn sm outline onClick={()=>setCalOff(p=>p+1)}>{">"}</Btn></div>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(7,1fr)",gap:3,marginBottom:4}}>
          {DAYS.map(d=><div key={d} style={{textAlign:"center",fontSize:11,fontWeight:700,color:C.muted,padding:"4px 0"}}>{d}</div>)}
        </div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(7,1fr)",gap:3}}>
          {Array.from({length:fd}).map((_,i)=><div key={"e"+i} style={{minHeight:72}}/>)}
          {Array.from({length:dim}).map((_,i)=>{
            const day=i+1;
            const ds=yr+"-"+String(mo+1).padStart(2,"0")+"-"+String(day).padStart(2,"0");
            const items=personalTodos.filter(t=>t.date===ds);
            const isTod=ds===today();
            return(
              <div key={day} style={{minHeight:72,background:isTod?C.accentLight:C.white,border:"1.5px solid "+(isTod?C.blue1:C.border),borderRadius:6,padding:"4px 5px"}}>
                <div style={{fontSize:11,fontWeight:isTod?700:400,color:isTod?C.blue1:C.text,marginBottom:2}}>{day}</div>
                {items.filter(t=>!t.done).map(t=>{
                  const lbl=getLabelById(t.label);
                  return(
                    <div key={t.id} onClick={()=>setEditTodo({...t})}
                      style={{fontSize:9,padding:"2px 5px",borderRadius:3,background:lbl?lbl.color:C.blue1,color:"#fff",marginBottom:2,cursor:"pointer",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",borderLeft:"none"}}>
                      {t.text}
                    </div>
                  );
                })}
                {items.filter(t=>t.done).length>0&&<div style={{fontSize:9,color:C.muted}}>✓ {items.filter(t=>t.done).length}</div>}
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  // Label Manager Modal
  function LabelManager(){
    return(
      <div onClick={()=>setShowLabelMgr(false)} style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.5)",zIndex:200,display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
        <div onClick={e=>e.stopPropagation()} style={{background:C.white,borderRadius:12,padding:24,width:"100%",maxWidth:420,boxShadow:"0 20px 60px rgba(0,0,0,0.2)"}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:18}}>
            <H2 style={{margin:0}}>Labels verwalten</H2>
            <button onClick={()=>setShowLabelMgr(false)} style={{border:"none",background:"none",fontSize:20,cursor:"pointer",color:C.muted}}>×</button>
          </div>
          {/* Existing labels */}
          {labels.map(l=>(
            <div key={l.id} style={{display:"flex",alignItems:"center",gap:8,marginBottom:8,padding:"8px 10px",borderRadius:8,background:C.bg,border:"1px solid "+C.border}}>
              {editLabel?.id===l.id?(
                <>
                  <input type="color" value={editLabel.color} onChange={e=>setEditLabel(p=>({...p,color:e.target.value}))} style={{width:32,height:32,borderRadius:4,border:"1px solid "+C.border,cursor:"pointer",padding:2,flexShrink:0}}/>
                  <input value={editLabel.name} onChange={e=>setEditLabel(p=>({...p,name:e.target.value}))}
                    style={{flex:1,padding:"5px 8px",borderRadius:4,border:"1px solid "+C.blue1,fontSize:13,outline:"none"}}/>
                  <button onClick={()=>{if(!editLabel.name.trim())return;saveLabels(labels.map(x=>x.id===l.id?{...x,name:editLabel.name,color:editLabel.color}:x));setEditLabel(null);}}
                    style={{border:"none",background:C.blue1,color:"#fff",borderRadius:4,cursor:"pointer",padding:"4px 10px",fontSize:12,fontWeight:700}}>✓</button>
                  <button onClick={()=>setEditLabel(null)} style={{border:"none",background:"transparent",color:C.muted,cursor:"pointer",fontSize:14}}>✕</button>
                </>
              ):(
                <>
                  <div style={{width:18,height:18,borderRadius:99,background:l.color,flexShrink:0}}/>
                  <span style={{flex:1,fontSize:13,color:C.text,fontWeight:600}}>{l.name}</span>
                  <button onClick={()=>setEditLabel({...l})} style={{border:"none",background:"none",color:C.muted,cursor:"pointer",fontSize:13,padding:"2px 6px"}}>✎</button>
                  <button onClick={()=>saveLabels(labels.filter(x=>x.id!==l.id))} style={{border:"none",background:"none",color:C.red,cursor:"pointer",fontSize:14,padding:"2px 6px"}}>✕</button>
                </>
              )}
            </div>
          ))}
          {/* Add new label */}
          <div style={{marginTop:14,padding:"12px",background:C.accentLight,borderRadius:8,border:"1px solid "+C.border}}>
            <div style={{fontSize:11,fontWeight:700,color:C.muted,textTransform:"uppercase",letterSpacing:1,marginBottom:8}}>Neues Label</div>
            <div style={{display:"flex",gap:8,alignItems:"center"}}>
              <input type="color" value={newLabel.color} onChange={e=>setNewLabel(p=>({...p,color:e.target.value}))}
                style={{width:36,height:36,borderRadius:6,border:"1px solid "+C.border,cursor:"pointer",padding:2,flexShrink:0}}/>
              <input placeholder="Label Name…" value={newLabel.name} onChange={e=>setNewLabel(p=>({...p,name:e.target.value}))}
                onKeyDown={e=>{if(e.key==="Enter")addNewLabel();}}
                style={{flex:1,padding:"7px 10px",borderRadius:6,border:"1px solid "+C.border,fontSize:13,outline:"none"}}/>
              <Btn sm onClick={addNewLabel}>+ Hinzufügen</Btn>
            </div>
          </div>
        </div>
      </div>
    );
  }

  function addNewLabel(){
    if(!newLabel.name.trim())return;
    const l={id:uid(),name:newLabel.name,color:newLabel.color};
    saveLabels([...labels,l]);
    setNewLabel({name:"",color:"#4A7BAF"});
  }

  const done=personalTodos.filter(t=>t.done);

  return(
    <div>
      {showLabelMgr&&<LabelManager/>}

      {/* Edit modal */}
      {editTodo&&(
        <div onClick={()=>setEditTodo(null)} style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.45)",zIndex:200,display:"flex",alignItems:"center",justifyContent:"center",padding:"12px"}}>
          <div onClick={e=>e.stopPropagation()} style={{background:C.white,borderRadius:10,padding:26,width:"100%",maxWidth:380,boxShadow:"0 20px 60px rgba(0,0,0,0.15)"}}>
            <H2>To-Do bearbeiten</H2>
            <Inp value={editTodo.text} onChange={e=>setEditTodo(p=>({...p,text:e.target.value}))} style={{width:"100%",marginBottom:10}}/>
            <div style={{marginBottom:10}}>
              <div style={{fontSize:11,color:C.muted,marginBottom:5,fontWeight:700}}>Label</div>
              <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                <button onClick={()=>setEditTodo(p=>({...p,label:""}))}
                  style={{padding:"4px 10px",borderRadius:99,border:"1.5px solid "+(editTodo.label===""?C.blue1:C.border),background:editTodo.label===""?C.accentLight:"transparent",fontSize:11,cursor:"pointer",color:editTodo.label===""?C.blue1:C.muted,fontWeight:600}}>Kein Label</button>
                {labels.map(l=>(
                  <button key={l.id} onClick={()=>setEditTodo(p=>({...p,label:l.id}))}
                    style={{padding:"4px 10px",borderRadius:99,border:"1.5px solid "+(editTodo.label===l.id?l.color:C.border),background:editTodo.label===l.id?l.color+"22":"transparent",fontSize:11,cursor:"pointer",color:editTodo.label===l.id?l.color:C.muted,fontWeight:editTodo.label===l.id?700:400}}>{l.name}</button>
                ))}
              </div>
            </div>
            <div style={{marginBottom:10}}>
              <div style={{fontSize:11,color:C.muted,marginBottom:5,fontWeight:700}}>Zeitraum</div>
              <div style={{display:"flex",gap:8,alignItems:"center"}}>
                <Inp type="date" value={editTodo.date||today()} onChange={e=>setEditTodo(p=>({...p,date:e.target.value}))} style={{flex:1}}/>
                <span style={{fontSize:12,color:C.muted}}>bis</span>
                <Inp type="date" value={editTodo.date_end||editTodo.date||today()} onChange={e=>setEditTodo(p=>({...p,date_end:e.target.value}))} style={{flex:1}}/>
              </div>
            </div>
            <Inp type="date" value={editTodo.due||""} onChange={e=>setEditTodo(p=>({...p,due:e.target.value}))} placeholder="Fälligkeitsdatum (optional)" style={{width:"100%",marginBottom:10}}/>
            <div style={{marginBottom:16}}>
              <div style={{fontSize:11,color:C.muted,marginBottom:5,fontWeight:700}}>Wiederholung</div>
              <select value={editTodo.recurring||""} onChange={e=>setEditTodo(p=>({...p,recurring:e.target.value}))}
                style={{width:"100%",padding:"9px 10px",borderRadius:6,border:"1.5px solid "+C.border,fontSize:14}}>
                <option value="">Einmalig</option>
                <option value="daily">🔁 Täglich</option>
                <option value="weekly">🔁 Wöchentlich</option>
                <option value="monthly">🔁 Monatlich</option>
              </select>
            </div>
            <div style={{display:"flex",gap:8}}><Btn onClick={saveEdit}>Speichern</Btn><Btn outline onClick={()=>setEditTodo(null)}>Abbrechen</Btn></div>
          </div>
        </div>
      )}

      {/* Header */}
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14,flexWrap:"wrap",gap:8}}>
        <H1>Meine To-Dos</H1>
        <div style={{display:"flex",gap:8,alignItems:"center",flexWrap:"wrap"}}>
          <button onClick={()=>setShowLabelMgr(true)} title="Labels verwalten"
            style={{background:C.white,border:"1px solid "+C.border,borderRadius:6,padding:"7px 10px",cursor:"pointer",fontSize:14,color:C.muted,lineHeight:1}}>⚙</button>
          <div style={{display:"flex",border:"1px solid "+C.border,borderRadius:6,overflow:"hidden"}}>
            {[["week","1 Woche"],["2week","2 Wochen"],["month","Monat"]].map(([v,l])=>(
              <button key={v} onClick={()=>setViewMode(v)} style={{padding:"6px 12px",border:"none",background:viewMode===v?C.blue2:"transparent",color:viewMode===v?"#fff":C.muted,cursor:"pointer",fontSize:11,fontWeight:viewMode===v?700:400,fontFamily:SN}}>{l}</button>
            ))}
          </div>
          {viewMode!=="month"&&<><Btn sm outline onClick={()=>setOff(p=>p-1)}>{"<"}</Btn><Btn sm outline onClick={()=>setOff(0)}>Heute</Btn><Btn sm outline onClick={()=>setOff(p=>p+1)}>{">"}</Btn></>}
          <Btn sm onClick={()=>{setShowAdd("quick");setNt({text:"",due:"",date:today(),labelId:""});}}>+ To-Do</Btn>
        </div>
      </div>

      {/* Quick add (no specific day selected) */}
      {showAdd==="quick"&&(
        <Panel style={{marginBottom:16}}>
          <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:8}}>
            <input placeholder="To-Do Text*" value={nt.text} onChange={e=>setNt(p=>({...p,text:e.target.value}))}
              autoFocus style={{flex:3,minWidth:160,padding:"9px 12px",borderRadius:6,border:"1.5px solid "+C.border,fontSize:14,boxSizing:"border-box"}}/>
            <input type="date" value={nt.date} onChange={e=>setNt(p=>({...p,date:e.target.value}))}
              style={{flex:1,minWidth:130,padding:"9px 10px",borderRadius:6,border:"1.5px solid "+C.border,fontSize:14,boxSizing:"border-box"}}/>
          </div>
          <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:10}}>
            <select value={nt.labelId} onChange={e=>setNt(p=>({...p,labelId:e.target.value}))}
              style={{flex:1,minWidth:130,padding:"9px 10px",borderRadius:6,border:"1px solid "+C.border,fontSize:14}}>
              <option value="">Kein Label</option>
              {labels.map(l=><option key={l.id} value={l.id}>{l.name}</option>)}
            </select>
            <select value={nt.recurring||""} onChange={e=>setNt(p=>({...p,recurring:e.target.value}))}
              style={{flex:1,minWidth:130,padding:"9px 10px",borderRadius:6,border:"1px solid "+C.border,fontSize:14}}>
              <option value="">Einmalig</option>
              <option value="daily">🔁 Täglich</option>
              <option value="weekly">🔁 Wöchentlich</option>
              <option value="monthly">🔁 Monatlich</option>
            </select>
            <input type="date" placeholder="Von" value={nt.due} onChange={e=>setNt(p=>({...p,due:e.target.value}))}
              style={{flex:1,minWidth:120,padding:"9px 10px",borderRadius:6,border:"1px solid "+C.border,fontSize:14,boxSizing:"border-box"}}/>
            <input type="date" placeholder="Bis" value={nt.dateEnd||""} onChange={e=>setNt(p=>({...p,dateEnd:e.target.value}))}
              style={{flex:1,minWidth:120,padding:"9px 10px",borderRadius:6,border:"1px solid "+C.border,fontSize:14,boxSizing:"border-box"}}/>
          </div>
          <div style={{display:"flex",gap:8}}>
            <Btn sm onClick={()=>addTodo(nt.date)}>Hinzufügen</Btn>
            <Btn sm outline onClick={()=>setShowAdd(null)}>Abbrechen</Btn>
          </div>
        </Panel>
      )}

      {/* Label filter pills */}
      <div style={{display:"flex",gap:6,marginBottom:14,flexWrap:"wrap"}}>
        {labels.map(l=>{
          const cnt=personalTodos.filter(t=>t.label===l.id&&!t.done).length;
          if(!cnt)return null;
          return(
            <span key={l.id} style={{padding:"3px 10px",borderRadius:99,background:l.color+"22",color:l.color,fontSize:11,fontWeight:700,border:"1px solid "+l.color+"44"}}>
              {l.name} · {cnt}
            </span>
          );
        })}
      </div>

      {/* Calendar views */}
      {viewMode==="month"?renderMonthView():mob?(
        <div style={{display:"flex",flexDirection:"column",gap:6}}>{(viewMode==="2week"?[...week1,...week2]:week1).map(d=>renderDayCol(d,false))}</div>
      ):viewMode==="2week"?(
        <div style={{display:"flex",flexDirection:"column",gap:8,overflowX:"auto"}}>
          <div style={{display:"grid",gridTemplateColumns:"repeat(7,minmax(100px,1fr))",gap:5,minWidth:700}}>{week1.map(d=>renderDayCol(d,true))}</div>
          <div style={{display:"grid",gridTemplateColumns:"repeat(7,minmax(100px,1fr))",gap:5,minWidth:700}}>{week2.map(d=>renderDayCol(d,true))}</div>
        </div>
      ):(
        <div style={{display:"grid",gridTemplateColumns:"repeat(7,1fr)",gap:8}}>{week1.map(d=>renderDayCol(d,false))}</div>
      )}

      {/* Done summary */}
      {done.length>0&&(
        <details style={{marginTop:16}}>
          <summary style={{fontSize:12,color:C.muted,cursor:"pointer",marginBottom:8}}>Erledigt ({done.length})</summary>
          <div style={{display:"flex",flexDirection:"column",gap:4}}>
            {done.map(t=>{
              const lbl=getLabelById(t.label);
              return(
                <div key={t.id} style={{display:"flex",alignItems:"center",gap:10,padding:"8px 14px",background:"#f8f8f8",borderRadius:8,border:"1px solid "+C.border,opacity:0.65,borderLeft:lbl?"3px solid "+lbl.color:"3px solid "+C.border}}>
                  <input type="checkbox" checked onChange={()=>toggleTodo(t.id)} style={{accentColor:C.blue1,cursor:"pointer",flexShrink:0}}/>
                  <div style={{flex:1}}>
                    <div style={{fontSize:13,color:C.muted,textDecoration:"line-through"}}>{t.text}</div>
                    {lbl&&<span style={{fontSize:9,fontWeight:700,padding:"1px 6px",borderRadius:99,background:lbl.color+"22",color:lbl.color}}>{lbl.name}</span>}
                  </div>
                  <button onClick={()=>deleteTodo(t.id)} style={{border:"none",background:"none",color:C.red,cursor:"pointer",fontSize:14}}>✕</button>
                </div>
              );
            })}
          </div>
        </details>
      )}
    </div>
  );
}


// ── Training ──
function TrainingView({profile,profiles,training,setTraining}){
  const isAdmin=profile?.role==="admin";
  const [showAdd,setShowAdd]=useState(false);
  const [frm,setFrm]=useState({title:"",url:"",desc:"",category:"Tools",forUserId:"all"});
  const cats=["Tools","LinkedIn","Marketing","Allgemein","Sonstiges"];
  const emps=profiles?profiles.filter(p=>p.role==="employee"):[];

  async function add(){
    if(!frm.title&&!frm.url)return;
    const t={id:uid(),title:frm.title,url:frm.url,desc:frm.desc,category:frm.category,for_user_id:frm.forUserId||"all"};
    await sb.from("training").insert(t);
    setTraining(prev=>[...prev,t]);
    setFrm({title:"",url:"",desc:"",category:"Tools",forUserId:"all"});
    setShowAdd(false);
  }

  async function del(id){
    await sb.from("training").delete().eq("id",id);
    setTraining(prev=>prev.filter(t=>t.id!==id));
  }

  // Filter: admin sieht alles, mitarbeiter sieht "all" + seine eigenen
  const visible=training.filter(t=>{
    if(isAdmin)return true;
    return !t.for_user_id||t.for_user_id==="all"||t.for_user_id===profile.id;
  });

  return(
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
        <H1>Weiterbildung</H1>
        {isAdmin&&<Btn onClick={()=>setShowAdd(p=>!p)}>+ Hinzufügen</Btn>}
      </div>
      {showAdd&&(
        <Panel style={{marginBottom:20}}>
          <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:10}}>
            <Inp placeholder="Titel" value={frm.title} onChange={e=>setFrm(p=>({...p,title:e.target.value}))} style={{flex:2,minWidth:160}}/>
            <Inp placeholder="URL" value={frm.url} onChange={e=>setFrm(p=>({...p,url:e.target.value}))} style={{flex:2,minWidth:160}}/>
            <select value={frm.category} onChange={e=>setFrm(p=>({...p,category:e.target.value}))} style={{padding:"9px 10px",borderRadius:6,border:"1px solid "+C.border,fontSize:14}}>
              {cats.map(c=><option key={c}>{c}</option>)}
            </select>
          </div>
          <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:10}}>
            <Inp placeholder="Beschreibung" value={frm.desc} onChange={e=>setFrm(p=>({...p,desc:e.target.value}))} style={{flex:1,minWidth:200}}/>
            <select value={frm.forUserId} onChange={e=>setFrm(p=>({...p,forUserId:e.target.value}))} style={{padding:"9px 10px",borderRadius:6,border:"1px solid "+C.border,fontSize:14,minWidth:180}}>
              <option value="all">Alle Mitarbeiter</option>
              <option value={profile.id}>Nur ich</option>
              {emps.filter(e=>e.id!==profile.id).map(e=><option key={e.id} value={e.id}>{e.name}</option>)}
            </select>
          </div>
          <Btn sm onClick={add}>Hinzufügen</Btn>
        </Panel>
      )}
      {cats.map(cat=>{
        const items=visible.filter(t=>t.category===cat);
        if(!items.length)return null;
        return(
          <div key={cat} style={{marginBottom:24}}>
            <div style={{fontSize:11,fontWeight:700,color:C.muted,textTransform:"uppercase",letterSpacing:2,marginBottom:10}}>{cat}</div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(280px,1fr))",gap:12}}>
              {items.map(t=>{
                const forUser=t.for_user_id&&t.for_user_id!=="all"?profiles.find(p=>p.id===t.for_user_id):null;
                return(
                  <Panel key={t.id} style={{padding:16,position:"relative"}}>
                    {forUser&&<div style={{fontSize:10,fontWeight:700,color:C.blue1,marginBottom:4,display:"flex",alignItems:"center",gap:4}}><Av name={forUser.name} color={forUser.color} size={14}/>{forUser.name}</div>}
                    {!forUser&&t.for_user_id==="all"&&isAdmin&&<div style={{fontSize:10,color:C.muted,marginBottom:4}}>Alle Mitarbeiter</div>}
                    <div style={{fontFamily:SR,fontSize:15,color:C.text,marginBottom:4}}>{t.title}</div>
                    {t.desc&&<p style={{fontSize:13,color:C.muted,margin:"0 0 10px",lineHeight:1.5}}>{t.desc}</p>}
                    {t.url&&<a href={t.url} target="_blank" rel="noreferrer" style={{fontSize:13,color:C.blue1,fontWeight:700,textDecoration:"none"}}>Zum Kurs →</a>}
                    {isAdmin&&<button onClick={()=>del(t.id)} style={{position:"absolute",top:10,right:10,border:"none",background:"none",color:C.red,cursor:"pointer",fontSize:16}}>✕</button>}
                  </Panel>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}

// ── Time Tracking ──
function TimeTrackingView({profile,profiles,timeBoards,setTimeBoards}){
  const isAdmin=profile?.role==="admin";
  const emps=profiles.filter(p=>p.role!=="client");
  const [selEmp,setSelEmp]=useState(isAdmin?(emps.find(p=>p.role==="employee")||emps[0])?.id||profile.id:profile.id);
  const [baseOff,setBaseOff]=useState(0);
  const [showAdd,setShowAdd]=useState(null);
  const [newCard,setNewCard]=useState({title:"",note:""});
  const [lightbox,setLightbox]=useState(null);
  const [showArchive,setShowArchive]=useState(false);
  const fileRefs=useRef({});
  const now=new Date();
  const empUser=profiles.find(p=>p.id===selEmp);
  const currentMonthKey=now.getFullYear()+"-"+String(now.getMonth()+1).padStart(2,"0");
  const currentMonthObj={key:currentMonthKey,label:MONTHSL[now.getMonth()]+" "+now.getFullYear(),isCurrent:true};
  const archiveMonths=Array.from({length:11},(_,i)=>{
    const d=new Date(now.getFullYear(),now.getMonth()-11+i,1);
    const key=d.getFullYear()+"-"+String(d.getMonth()+1).padStart(2,"0");
    return{key,label:MONTHSL[d.getMonth()]+" "+d.getFullYear(),isCurrent:false};
  });
  const months=[currentMonthObj,...(showArchive?archiveMonths:[])];
  function getCards(mk){return(timeBoards[selEmp+"-"+mk])||[];}
  async function addCard(mk){if(!newCard.title.trim())return;const card={id:uid(),title:newCard.title,note:newCard.note,file:null,thumbsUp:false};const key=selEmp+"-"+mk;const cards=[...getCards(mk),card];await sb.from("time_boards").upsert({key,data:cards,emp_id:selEmp,month_key:mk});setTimeBoards(prev=>({...prev,[key]:cards}));setNewCard({title:"",note:""});setShowAdd(null);}
  async function delCard(mk,cardId){const key=selEmp+"-"+mk;const cards=getCards(mk).filter(c=>c.id!==cardId);await sb.from("time_boards").upsert({key,data:cards,emp_id:selEmp,month_key:mk});setTimeBoards(prev=>({...prev,[key]:cards}));}
  async function thumbsUp(mk,cardId){const key=selEmp+"-"+mk;const cards=getCards(mk).map(c=>c.id===cardId?{...c,thumbsUp:true}:c);await sb.from("time_boards").upsert({key,data:cards,emp_id:selEmp,month_key:mk});setTimeBoards(prev=>({...prev,[key]:cards}));}
  async function addFile(e,mk,cardId){const f=e.target.files[0];if(!f)return;const data=await readFile(f);const key=selEmp+"-"+mk;const cards=getCards(mk).map(c=>c.id===cardId?{...c,file:data}:c);await sb.from("time_boards").upsert({key,data:cards,emp_id:selEmp,month_key:mk});setTimeBoards(prev=>({...prev,[key]:cards}));e.target.value="";}
  return(
    <div>
      {lightbox&&(<div onClick={()=>setLightbox(null)} style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.85)",zIndex:300,display:"flex",alignItems:"center",justifyContent:"center"}}><div onClick={e=>e.stopPropagation()} style={{maxWidth:"90vw",maxHeight:"90vh"}}><img src={lightbox.data} alt="Screenshot" style={{maxWidth:"88vw",maxHeight:"82vh",borderRadius:8,display:"block"}}/><div style={{display:"flex",gap:10,marginTop:12,justifyContent:"center"}}><Btn onClick={()=>{const a=document.createElement("a");a.href=lightbox.data;a.download=lightbox.name||"screenshot.png";document.body.appendChild(a);a.click();document.body.removeChild(a);}} style={{background:C.blue1,borderColor:C.blue1,color:"#fff"}}>⬇ Herunterladen</Btn><Btn outline onClick={()=>setLightbox(null)} style={{color:"#fff",borderColor:"rgba(255,255,255,0.4)"}}>Schließen</Btn></div></div></div>)}
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:18,flexWrap:"wrap",gap:8}}>
        <H1>Zeiterfassung</H1>
        <div style={{display:"flex",gap:8,alignItems:"center",flexWrap:"wrap"}}>
          {isAdmin&&<select value={selEmp} onChange={e=>setSelEmp(e.target.value)} style={{padding:"8px 10px",borderRadius:6,border:"1px solid "+C.border,fontSize:13}}>{emps.map(u=><option key={u.id} value={u.id}>{u.name}</option>)}</select>}
          <Btn sm outline onClick={()=>setShowArchive(p=>!p)}>{showArchive?"Archiv ausblenden":"Archiv anzeigen"}</Btn>
        </div>
      </div>
      {empUser&&<Panel style={{marginBottom:18,display:"flex",alignItems:"center",gap:12}}><Av name={empUser.name} color={empUser.color} size={42}/><div><div style={{fontFamily:SR,fontSize:16,color:C.text}}>{empUser.name}</div><div style={{fontSize:12,color:C.muted}}>Zeiterfassung</div></div></Panel>}
      <div style={{overflowX:"auto"}}><div style={{display:"flex",gap:14,minWidth:"max-content",paddingBottom:8}}>
        {months.map(({key,label,isCurrent})=>{
          const cards=getCards(key);
          return(<div key={key} style={{width:290,background:C.white,borderRadius:10,border:"1.5px solid "+(isCurrent?C.blue1:C.border),flexShrink:0}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"12px 16px",borderBottom:"1px solid "+(isCurrent?C.blue1+"30":C.border),background:isCurrent?C.accentLight:"#f8fafc",borderRadius:"10px 10px 0 0"}}><span style={{fontFamily:SR,fontSize:14,color:isCurrent?C.blue1:C.text,fontWeight:isCurrent?700:400}}>{label}{isCurrent?" ✦":""}</span><span style={{background:isCurrent?C.blue1:C.muted,color:"#fff",borderRadius:99,padding:"2px 8px",fontSize:11,fontWeight:700}}>{cards.length}</span></div>
            <div style={{padding:10,display:"flex",flexDirection:"column",gap:8,minHeight:80}}>
              {cards.map(card=>(<div key={card.id} style={{background:C.bg,borderRadius:8,padding:10,border:"1px solid "+C.border,borderLeft:"3px solid "+(isCurrent?C.blue1:C.teal2)}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:4}}><div style={{fontFamily:SR,fontSize:13,color:C.text}}>{card.title}</div>{card.thumbsUp&&<span>👍</span>}</div>
                {card.note&&<p style={{margin:"0 0 6px",fontSize:12,color:C.muted}}>{card.note}</p>}
                {card.file&&isImg(card.file)&&<img src={card.file.data} alt="Screenshot" style={{width:"100%",borderRadius:6,marginBottom:6,cursor:"pointer"}} onClick={()=>setLightbox({data:card.file.data,name:card.file.name})}/>}
                {card.file&&!isImg(card.file)&&<div style={{fontSize:11,color:C.muted,marginBottom:6,cursor:"pointer"}} onClick={()=>{const a=document.createElement("a");a.href=card.file.data;a.download=card.file.name;a.click();}}>📎 {card.file.name}</div>}
                <div style={{display:"flex",gap:5,flexWrap:"wrap",marginTop:4}}>
                  <button onClick={()=>{const rk=selEmp+"-"+key+"-"+card.id;if(!fileRefs.current[rk]){const inp=document.createElement("input");inp.type="file";inp.accept="image/*,.pdf";inp.onchange=e=>addFile(e,key,card.id);fileRefs.current[rk]=inp;}fileRefs.current[rk].click();}} style={{fontSize:11,padding:"3px 8px",borderRadius:4,border:"1px solid "+C.border,background:"transparent",cursor:"pointer",color:C.muted}}>📎 Screenshot</button>
                  {isAdmin&&card.file&&isImg(card.file)&&<button onClick={()=>setLightbox({data:card.file.data,name:card.file.name})} style={{fontSize:11,padding:"3px 8px",borderRadius:4,border:"1px solid "+C.blue1+"50",background:C.accentLight,cursor:"pointer",color:C.blue1}}>🔍 Ansehen</button>}
                  {isAdmin&&!card.thumbsUp&&<button onClick={()=>thumbsUp(key,card.id)} style={{fontSize:11,padding:"3px 8px",borderRadius:4,border:"1px solid "+C.green2+"50",background:"#f0faf4",cursor:"pointer",color:C.green2,fontWeight:700}}>👍 Bestätigen</button>}
                  {(isAdmin||profile.id===selEmp)&&<button onClick={()=>delCard(key,card.id)} style={{fontSize:11,padding:"3px 8px",borderRadius:4,border:"1px solid "+C.red+"40",background:"transparent",cursor:"pointer",color:C.red}}>✕</button>}
                </div>
              </div>))}
              {showAdd===key?(<div style={{background:"#fff",borderRadius:6,padding:9,border:"1px solid "+C.border}}><Inp placeholder="Beschreibung*" value={newCard.title} onChange={e=>setNewCard(p=>({...p,title:e.target.value}))} style={{width:"100%",marginBottom:6,fontSize:12}}/><textarea placeholder="Notiz" value={newCard.note} onChange={e=>setNewCard(p=>({...p,note:e.target.value}))} rows={2} style={{width:"100%",marginBottom:6,padding:"6px 8px",borderRadius:4,border:"1px solid "+C.border,fontSize:11,resize:"none",boxSizing:"border-box"}}/><div style={{display:"flex",gap:5}}><Btn sm onClick={()=>addCard(key)}>+ Hinzufügen</Btn><Btn sm outline onClick={()=>setShowAdd(null)}>Abbrechen</Btn></div></div>):(<button onClick={()=>{setShowAdd(key);setNewCard({title:"",note:""}); }} style={{padding:"6px",border:"1.5px dashed "+C.border,background:"transparent",borderRadius:6,cursor:"pointer",color:C.muted,fontSize:12}}>+ Eintrag</button>)}
            </div>
          </div>);
        })}
      </div></div>
    </div>
  );
}

// ── Vacations ──
function VacationsView({profile,profiles,vacations,setVacations}){
  const isAdmin=profile?.role==="admin";
  const [yrOff,setYrOff]=useState(0);const [showAdd,setShowAdd]=useState(false);
  const [frm,setFrm]=useState({userId:"",start:"",end:"",color:C.teal2,substitute:"",tasks:"",isClient:false});
  const yr=new Date().getFullYear()+yrOff;
  const emps=profiles.filter(p=>p.role==="employee");
  function daysInRange(s,e){const days=[];const d=new Date(s+"T00:00:00");const end=new Date(e+"T00:00:00");while(d<=end){days.push(d.toISOString().slice(0,10));d.setDate(d.getDate()+1);}return days;}
  async function addVac(){if(!frm.userId||!frm.start||!frm.end)return;const v={id:uid(),...frm};await sb.from("vacations").insert(v);setVacations(prev=>[...prev,v]);setFrm({userId:"",start:"",end:"",color:C.teal2,substitute:"",tasks:"",isClient:false});setShowAdd(false);}
  async function delVac(id){await sb.from("vacations").delete().eq("id",id);setVacations(prev=>prev.filter(v=>v.id!==id));}
  return(
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20,flexWrap:"wrap",gap:8}}><H1>Urlaube {yr}</H1><div style={{display:"flex",gap:8,flexWrap:"wrap"}}><Btn sm outline onClick={()=>setYrOff(p=>p-1)}>{"<"}</Btn><Btn sm outline onClick={()=>setYrOff(0)}>Aktuell</Btn><Btn sm outline onClick={()=>setYrOff(p=>p+1)}>{">"}</Btn>{isAdmin&&<Btn sm onClick={()=>setShowAdd(p=>!p)}>+ Abwesenheit</Btn>}</div></div>
      {showAdd&&isAdmin&&(<Panel style={{marginBottom:20}}><H2>Abwesenheit eintragen</H2><div style={{display:"flex",gap:8,marginBottom:12}}><button onClick={()=>setFrm(p=>({...p,isClient:false}))} style={{padding:"6px 14px",borderRadius:6,border:"1.5px solid "+(frm.isClient?C.border:C.blue1),background:frm.isClient?"transparent":C.accentLight,color:frm.isClient?C.muted:C.blue1,cursor:"pointer",fontWeight:600,fontSize:13}}>Mitarbeiter</button><button onClick={()=>setFrm(p=>({...p,isClient:true}))} style={{padding:"6px 14px",borderRadius:6,border:"1.5px solid "+(frm.isClient?C.blue1:C.border),background:frm.isClient?C.accentLight:"transparent",color:frm.isClient?C.blue1:C.muted,cursor:"pointer",fontWeight:600,fontSize:13}}>Kunde</button></div><div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:10}}><select value={frm.userId} onChange={e=>setFrm(p=>({...p,userId:e.target.value}))} style={{flex:1,minWidth:140,padding:"9px 10px",borderRadius:6,border:"1px solid "+C.border,fontSize:14}}><option value="">{frm.isClient?"Kunde…":"Mitarbeiter…"}</option>{(frm.isClient?profiles.filter(p=>p.role==="client"):emps).map(u=><option key={u.id} value={u.id}>{u.name}</option>)}</select><Inp type="date" value={frm.start} onChange={e=>setFrm(p=>({...p,start:e.target.value}))} style={{flex:1,minWidth:130}}/><Inp type="date" value={frm.end} onChange={e=>setFrm(p=>({...p,end:e.target.value}))} style={{flex:1,minWidth:130}}/><input type="color" value={frm.color} onChange={e=>setFrm(p=>({...p,color:e.target.value}))} style={{width:38,height:36,borderRadius:6,border:"1px solid "+C.border,cursor:"pointer",padding:2}}/></div>{!frm.isClient&&<div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:10}}><select value={frm.substitute} onChange={e=>setFrm(p=>({...p,substitute:e.target.value}))} style={{flex:1,minWidth:140,padding:"9px 10px",borderRadius:6,border:"1px solid "+C.border,fontSize:14}}><option value="">Vertretung…</option>{emps.map(u=><option key={u.id} value={u.id}>{u.name}</option>)}</select><Inp placeholder="Aufgaben" value={frm.tasks} onChange={e=>setFrm(p=>({...p,tasks:e.target.value}))} style={{flex:2,minWidth:180}}/></div>}<Btn sm onClick={addVac}>Speichern</Btn></Panel>)}
      {vacations.length>0&&<Panel style={{marginBottom:20}}><H2>Eingetragene Abwesenheiten</H2>{vacations.map(v=>{const u=profiles.find(x=>x.id===v.userId);const sub=profiles.find(x=>x.id===v.substitute);return(<div key={v.id} style={{display:"flex",alignItems:"center",gap:12,padding:"10px 0",borderBottom:"1px solid "+C.border}}><div style={{width:12,height:40,borderRadius:4,background:v.color,flexShrink:0}}/><div style={{flex:1}}><div style={{display:"flex",alignItems:"center",gap:6}}><div style={{fontFamily:SR,fontSize:15,color:C.text}}>{u&&u.name}</div>{v.isClient&&<Tag color={C.teal1}>Kunde</Tag>}</div><div style={{fontSize:12,color:C.muted}}>{v.start} bis {v.end}</div>{sub&&<div style={{fontSize:11,color:C.teal2,marginTop:2}}>Vertretung: {sub.name}{v.tasks?" · "+v.tasks:""}</div>}</div>{isAdmin&&<button onClick={()=>delVac(v.id)} style={{border:"none",background:"none",color:C.red,cursor:"pointer",fontSize:17}}>✕</button>}</div>);})}</Panel>}
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(200px,1fr))",gap:14}}>
        {MONTHSL.map((mName,m)=>{const fd=(new Date(yr,m,1).getDay()+6)%7;const dim=new Date(yr,m+1,0).getDate();const mVacs=vacations.filter(v=>{const ss=new Date(v.start+"T00:00:00");const ee=new Date(v.end+"T00:00:00");return(ss.getFullYear()===yr&&ss.getMonth()===m)||(ee.getFullYear()===yr&&ee.getMonth()===m)||(ss<new Date(yr,m,1)&&ee>=new Date(yr,m,1));});return(<Panel key={m} style={{padding:12}}><div style={{fontFamily:SR,fontSize:14,color:C.text,marginBottom:8,textAlign:"center"}}>{mName}</div><div style={{display:"grid",gridTemplateColumns:"repeat(7,1fr)",gap:1,marginBottom:3}}>{["M","D","M","D","F","S","S"].map((d,i)=><div key={i} style={{textAlign:"center",fontSize:8,color:C.muted,fontWeight:700}}>{d}</div>)}</div><div style={{display:"grid",gridTemplateColumns:"repeat(7,1fr)",gap:1}}>{Array.from({length:fd}).map((_,i)=><div key={"e"+i}/>)}{Array.from({length:dim}).map((_,i)=>{const day=i+1;const ds=yr+"-"+String(m+1).padStart(2,"0")+"-"+String(day).padStart(2,"0");const dVacs=mVacs.filter(v=>daysInRange(v.start,v.end).includes(ds));const isTod=yr===new Date().getFullYear()&&m===new Date().getMonth()&&day===new Date().getDate();return(<div key={day} title={dVacs.map(v=>{const u=profiles.find(x=>x.id===v.userId);return u?u.name:"";}).join(", ")} style={{textAlign:"center",fontSize:9,padding:"2px 1px",borderRadius:2,background:dVacs.length>0?dVacs[0].color:(isTod?C.accentLight:"transparent"),color:dVacs.length>0?"#fff":(isTod?C.blue1:C.text),fontWeight:isTod||dVacs.length>0?700:400}}>{day}</div>);})}</div></Panel>);})}
      </div>
    </div>
  );
}

// ── Team View ──
async function exportClientPDF(u, boards, meetings, chat){
  // Dynamic import via CDN not available - use window.print approach
  // Build HTML content and open print window
  const clientBoards=Object.values(boards).filter(b=>b.clientId===u.id);
  const clientMeetings=meetings.filter(m=>m.with===u.id);
  const clientChat=chat.filter(m=>(m.to===u.id||m.from===u.id)&&!m.to===false);

  let html=`<!DOCTYPE html><html><head><meta charset="utf-8">
  <title>Kundendaten – ${u.name}</title>
  <style>
    body{font-family:Georgia,serif;max-width:800px;margin:40px auto;color:#1a2b3c;font-size:14px;line-height:1.6;}
    h1{color:#1E3448;font-size:26px;border-bottom:3px solid #4A7BAF;padding-bottom:10px;}
    h2{color:#4A7BAF;font-size:18px;margin-top:30px;border-bottom:1px solid #D1DCE8;padding-bottom:6px;}
    h3{color:#1E3448;font-size:15px;margin-top:16px;}
    .meta{color:#6B8299;font-size:12px;margin-bottom:20px;}
    .card{background:#f4f7fa;border-radius:6px;padding:12px;margin-bottom:10px;border-left:4px solid #4A7BAF;}
    .card-title{font-weight:700;margin-bottom:4px;}
    .card-desc{color:#6B8299;font-size:13px;}
    .meeting{background:#f0faf8;border-radius:6px;padding:10px;margin-bottom:8px;border-left:4px solid #6AAFAA;}
    .tag{display:inline-block;background:#EAF1FA;color:#4A7BAF;padding:2px 8px;border-radius:99px;font-size:11px;font-weight:700;margin-right:4px;}
    @media print{body{margin:20px;}}
  </style></head><body>`;

  html+=`<h1>Kundendaten: ${u.name}</h1>`;
  if(u.company)html+=`<div class="meta"><b>Firma:</b> ${u.company}</div>`;
  if(u.email)html+=`<div class="meta"><b>E-Mail:</b> ${u.email}</div>`;
  html+=`<div class="meta"><b>Exportiert am:</b> ${new Date().toLocaleDateString("de-AT")}</div>`;

  // Boards
  if(clientBoards.length>0){
    html+=`<h2>Projekte & Boards (${clientBoards.length})</h2>`;
    clientBoards.forEach(b=>{
      const totalCards=b.colOrder.reduce((s,cid)=>s+b.columns[cid].cards.length,0);
      html+=`<h3>${b.icon||"📋"} ${b.name} <span class="tag">${totalCards} Karten</span></h3>`;
      b.colOrder.forEach(cid=>{
        const col=b.columns[cid];
        if(col.cards.length===0)return;
        html+=`<p><b>${col.name}</b></p>`;
        col.cards.forEach(card=>{
          html+=`<div class="card"><div class="card-title">${card.title}</div>`;
          if(card.desc)html+=`<div class="card-desc">${card.desc}</div>`;
          if(card.content)html+=`<div class="card-desc" style="margin-top:6px;white-space:pre-wrap">${card.content}</div>`;
          if(card.due)html+=`<div class="card-desc">📅 Fällig: ${card.due}</div>`;
          if(card.clientApproved)html+=`<div class="card-desc">✅ Freigegeben</div>`;
          if(card.comments&&card.comments.length>0){
            html+=`<div style="margin-top:8px;font-size:12px;color:#6B8299"><b>Kommentare:</b><br>`;
            card.comments.forEach(cm=>{html+=`• ${cm.authorName||"??"}: ${cm.text}<br>`;});
            html+=`</div>`;
          }
          html+=`</div>`;
        });
      });
    });
  }

  // Meetings
  if(clientMeetings.length>0){
    html+=`<h2>Gespräche (${clientMeetings.length})</h2>`;
    clientMeetings.forEach(m=>{
      html+=`<div class="meeting"><b>${m.topic}</b> – ${m.date}`;
      if(m.notes)html+=`<br><span style="color:#6B8299">Notizen: ${m.notes}</span>`;
      if(m.openPoints)html+=`<br><span style="color:#6B8299">Offene Punkte: ${m.openPoints}</span>`;
      html+=`</div>`;
    });
  }

  html+=`</body></html>`;

  const win=window.open("","_blank");
  win.document.write(html);
  win.document.close();
  setTimeout(()=>win.print(),500);
}

function TeamView({profile,profiles,addProfile,updateProfile,loadProfiles,setProfiles,boards,meetings,messages}){
  const [showAdd,setShowAdd]=useState(false);
  const [frm,setFrm]=useState({firstName:"",lastName:"",company:"",role:"employee",color:C.teal2,email:""});
  const [editId,setEditId]=useState(null);const [editD,setEditD]=useState(null);
  const [newUserEmail,setNewUserEmail]=useState("");
  const [creating,setCreating]=useState(false);
  const [msg,setMsg]=useState("");

  async function createUser(){
    if(!newUserEmail||!frm.firstName){setMsg("Bitte Vorname und E-Mail ausfüllen");return;}
    if(frm.role==="client"&&!frm.company){setMsg("Bitte Firmenname ausfüllen");return;}
    setCreating(true);setMsg("");
    const name=frm.role==="client"?(frm.company||(frm.firstName+" "+frm.lastName).trim()):(frm.firstName+" "+frm.lastName).trim();
    try{
      const res=await fetch("https://ujctmfnryuddkaaueehp.supabase.co/functions/v1/invite-user",{
        method:"POST",
        headers:{"Content-Type":"application/json","Authorization":"Bearer "+SKEY},
        body:JSON.stringify({
          email:newUserEmail,
          name,
          role:frm.role,
          color:frm.color,
          company:frm.company||null,
          firstName:frm.firstName,
          lastName:frm.lastName
        })
      });
      const result=await res.json();
      if(result.error){setMsg("Fehler: "+result.error);setCreating(false);return;}
      setMsg("✅ Einladung verschickt! "+name+" bekommt eine E-Mail zum Passwort setzen.");
      setFrm({firstName:"",lastName:"",company:"",role:"employee",color:C.teal2,email:""});
      setNewUserEmail("");
      setShowAdd(false);
      const{data}=await sb.from("profiles").select("*");if(data)setProfiles(data);
    }catch(e){
      setMsg("Fehler: "+e.message);
    }
    setCreating(false);
  }

  return(
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:22}}><H1>Team & Kunden</H1><Btn onClick={()=>setShowAdd(p=>!p)}>+ Person hinzufügen</Btn></div>
      {msg&&<div style={{padding:"10px 16px",borderRadius:8,background:msg.startsWith("✅")?"#f0faf4":"#fdecea",border:"1px solid "+(msg.startsWith("✅")?"#b7dfc4":"#f5c6c6"),marginBottom:16,fontSize:13,color:msg.startsWith("✅")?C.green2:C.red}}>{msg}</div>}
      {showAdd&&<Panel style={{marginBottom:20}}>
        <H2>Neuen Nutzer anlegen</H2>
        <div style={{display:"flex",gap:8,marginBottom:12,flexWrap:"wrap"}}>
          {[["employee","Mitarbeiter"],["client","Kunde"],["admin","Admin"]].map(([r,l])=><button key={r} onClick={()=>setFrm(p=>({...p,role:r}))} style={{padding:"6px 14px",borderRadius:6,border:"1.5px solid "+(frm.role===r?C.blue1:C.border),background:frm.role===r?C.accentLight:"transparent",color:frm.role===r?C.blue1:C.muted,cursor:"pointer",fontWeight:600,fontSize:13}}>{l}</button>)}
        </div>
        <div style={{display:"flex",gap:8,marginBottom:10,flexWrap:"wrap"}}>
          <Inp placeholder="Vorname*" value={frm.firstName} onChange={e=>setFrm(p=>({...p,firstName:e.target.value}))} style={{flex:1,minWidth:140}}/>
          <Inp placeholder="Nachname*" value={frm.lastName} onChange={e=>setFrm(p=>({...p,lastName:e.target.value}))} style={{flex:1,minWidth:140}}/>
        </div>
        {frm.role==="client"&&<Inp placeholder="Firmenname" value={frm.company} onChange={e=>setFrm(p=>({...p,company:e.target.value}))} style={{width:"100%",marginBottom:10}}/>}
        <div style={{display:"flex",gap:8,marginBottom:14,flexWrap:"wrap"}}>
          <Inp placeholder="E-Mail*" value={newUserEmail} onChange={e=>setNewUserEmail(e.target.value)} style={{flex:1,minWidth:180}} type="email"/>
          <input type="color" value={frm.color} onChange={e=>setFrm(p=>({...p,color:e.target.value}))} style={{width:38,height:42,borderRadius:6,border:"1px solid "+C.border,cursor:"pointer",padding:2}}/>
        </div>
        <Btn onClick={createUser} disabled={creating}>{creating?"Erstellen…":"Nutzer erstellen & Einladung senden"}</Btn>
      </Panel>}
      {["admin","employee","client"].map(role=>{
        const group=profiles.filter(p=>p.role===role);if(!group.length)return null;
        return(<div key={role} style={{marginBottom:24}}>
          <div style={{fontSize:11,fontWeight:700,color:C.muted,textTransform:"uppercase",letterSpacing:2,marginBottom:12}}>{ROLE_L[role]}</div>
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(240px,1fr))",gap:10}}>
            {group.map(u=>(<Panel key={u.id} style={{padding:16}}>
              {editId===u.id&&editD?(
                <div>
                  <div style={{display:"flex",gap:8,marginBottom:8,alignItems:"center"}}><input type="color" value={editD.color} onChange={e=>setEditD(p=>({...p,color:e.target.value}))} style={{width:34,height:34,borderRadius:6,border:"1px solid "+C.border,cursor:"pointer",padding:2}}/><Inp value={editD.name} onChange={e=>setEditD(p=>({...p,name:e.target.value}))} style={{flex:1}}/></div>
                  <Inp value={editD.email||""} onChange={e=>setEditD(p=>({...p,email:e.target.value}))} placeholder="E-Mail" style={{width:"100%",marginBottom:10}}/>
                  <div style={{display:"flex",gap:8}}><Btn sm onClick={async()=>{await updateProfile(editId,editD);setEditId(null);}}>Speichern</Btn><Btn sm outline onClick={()=>setEditId(null)}>Abbrechen</Btn></div>
                </div>
              ):(
                <div style={{display:"flex",alignItems:"center",gap:10}}>
                  <Av name={u.name} color={u.color} size={44}/>
                  <div style={{flex:1}}>
                    <div style={{fontFamily:SR,fontSize:14,color:C.text}}>{u.name}</div>
                    {u.company&&<div style={{fontSize:12,color:C.blue1,marginTop:1,fontWeight:600}}>{u.company}</div>}
                    {u.email&&<div style={{fontSize:11,color:C.muted,marginTop:2}}>{u.email}</div>}
                    <div style={{display:"flex",alignItems:"center",gap:6,marginTop:6,flexWrap:"wrap"}}>
                      <Tag color={C.blue1}>{ROLE_L[u.role]}</Tag>
                      <Btn sm outline onClick={()=>{setEditId(u.id);setEditD({name:u.name,email:u.email||"",color:u.color});}} style={{padding:"2px 9px",fontSize:10}}>Bearb.</Btn>
                      {u.role==="client"&&<button onClick={()=>exportClientPDF(u,boards,meetings,messages)} style={{border:"none",background:"none",color:C.blue1,cursor:"pointer",fontSize:11,padding:"2px 6px",borderRadius:4,border:"1px solid "+C.blue1}} title="Daten exportieren">📄 Export</button>}
                      {u.id!==profile.id&&<button onClick={async()=>{if(!window.confirm("Nutzer "+u.name+" wirklich löschen? Dies kann nicht rückgängig gemacht werden."))return;try{const res=await fetch("https://ujctmfnryuddkaaueehp.supabase.co/functions/v1/delete-user",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({userId:u.id})});const result=await res.json();if(result.error){alert("Fehler: "+result.error);return;}setProfiles(prev=>prev.filter(p=>p.id!==u.id));}catch(e){alert("Fehler: "+e.message);}}} style={{border:"none",background:"none",color:C.red,cursor:"pointer",fontSize:13,padding:"2px 4px"}} title="Nutzer löschen">✕</button>}
                    </div>
                  </div>
                </div>
              )}
            </Panel>))}
          </div>
        </div>);
      })}
    </div>
  );
}

// ── Dashboards ──
function ClientDash({profile,boards,onOpen,onNav,notifications,meetings,onApprove}){
  const myBoards=Object.values(boards).filter(b=>!b.internal&&(b.clientId===profile.id||(b.visibleTo||[]).includes(profile.id)));
  const pendingCards=[];
  myBoards.forEach(b=>{b.colOrder.forEach(cid=>{const col=b.columns[cid];const isApprovalCol=col.name.toLowerCase().includes("abnahme")||col.name.toLowerCase().includes("freigabe");if(isApprovalCol){col.cards.filter(card=>!card.clientApproved).forEach(card=>pendingCards.push({card,board:b,colName:col.name}));}});});
  return(
    <div>
      <div style={{marginBottom:32,padding:"28px 32px",background:"linear-gradient(135deg,"+C.blue2+","+C.blue1+")",borderRadius:12,color:"#fff"}}>
        <p style={{fontSize:13,color:"rgba(255,255,255,0.7)",margin:"0 0 4px",letterSpacing:1,textTransform:"uppercase"}}>Hallo, {(profile.first_name||profile.name||"").split(" ")[0]}</p>
        <h1 style={{fontFamily:SR,fontSize:30,fontWeight:400,color:"#fff",margin:"0 0 8px"}}>Willkommen im BRVH Strategieraum</h1>
        <p style={{fontSize:14,color:"rgba(255,255,255,0.7)",margin:0,fontStyle:"italic"}}>"{getDailyQuote()}"</p>
      </div>
      {pendingCards.length>0?(
        <Panel style={{marginBottom:28,borderLeft:"4px solid "+C.blue1}}>
          <H2>Beiträge die deine Freigabe benötigen ({pendingCards.length})</H2>
          {pendingCards.map(({card,board,colName})=>(
            <div key={card.id} style={{display:"flex",alignItems:"center",gap:12,padding:"10px 0",borderBottom:"1px solid "+C.border,flexWrap:"wrap"}}>
              <div style={{flex:1}}><div style={{fontFamily:SR,fontSize:14,color:C.text}}>{card.title}</div><div style={{fontSize:11,color:C.muted,marginTop:2}}>{board.name+" · "+colName}</div></div>
              <div style={{display:"flex",gap:6}}><Btn sm onClick={()=>onApprove(board.id,card.id)} style={{background:C.green2,borderColor:C.green2,color:"#fff"}}>✅ Freigeben</Btn><Btn sm outline onClick={()=>onOpen(board.id)}>Ansehen →</Btn></div>
            </div>
          ))}
        </Panel>
      ):(
        <div style={{background:"#f0faf4",border:"1px solid #b7dfc4",borderRadius:10,padding:"16px 20px",marginBottom:24}}>
          <div style={{fontFamily:SR,fontSize:16,color:C.green2}}>✓ Alles auf dem neuesten Stand</div>
          <div style={{fontSize:13,color:C.muted,marginTop:4}}>Keine ausstehenden Beiträge.</div>
        </div>
      )}
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16,marginBottom:20}}>
        <Panel>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
            <div style={{fontFamily:SR,fontSize:15,color:C.text}}>📅 Meine Gespräche</div>
            <button onClick={()=>onNav("meetings")} style={{border:"none",background:"none",color:C.blue1,cursor:"pointer",fontSize:12,fontWeight:700}}>Alle →</button>
          </div>
          {(()=>{
            const myMeetings=meetings.filter(m=>m.with===profile.id&&!m.done).sort((a,b)=>a.date.localeCompare(b.date));
            if(myMeetings.length===0)return <p style={{color:C.muted,fontSize:13,margin:0}}>Keine anstehenden Gespräche.</p>;
            return myMeetings.slice(0,3).map(m=>(
              <div key={m.id} style={{padding:"8px 0",borderBottom:"1px solid "+C.border}}>
                <div style={{fontFamily:SR,fontSize:14,color:C.text}}>{m.topic}</div>
                <div style={{fontSize:12,color:C.muted,marginTop:2}}>📅 {m.date}</div>
                {m.meetLink&&<a href={m.meetLink} target="_blank" rel="noreferrer" style={{fontSize:12,color:C.blue1,fontWeight:700}}>Meet beitreten →</a>}
              </div>
            ));
          })()}
        </Panel>
        <Panel style={{cursor:"pointer"}} onClick={()=>onNav("chat")}><div style={{fontSize:22,marginBottom:6}}>💬</div><div style={{fontFamily:SR,fontSize:15,color:C.text}}>Direktnachricht</div></Panel>
      </div>
      <h2 style={{fontFamily:SR,fontSize:20,fontWeight:400,color:C.text,marginBottom:14}}>Meine Projekte</h2>
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(250px,1fr))",gap:14}}>
        {myBoards.map(b=>{const cnt=b.colOrder.reduce((s,cid)=>s+b.columns[cid].cards.length,0);return(<div key={b.id} onClick={()=>onOpen(b.id)} style={{background:b.bgColor||C.white,borderRadius:10,padding:20,cursor:"pointer",border:"1.5px solid "+C.border,transition:"all .2s"}} onMouseEnter={e=>{e.currentTarget.style.borderColor=C.blue1;}} onMouseLeave={e=>{e.currentTarget.style.borderColor=C.border;}}><div style={{fontFamily:SR,fontSize:22,marginBottom:8,color:C.blue1}}>{b.icon}</div><div style={{fontFamily:SR,fontSize:15,color:C.text,marginBottom:4}}>{b.name}</div><div style={{fontSize:12,color:C.muted}}>{cnt+" Karten"}</div></div>);})}
      </div>
    </div>
  );
}

function EmpDash({profile,boards,todos,onOpen}){
  const myBoards=Object.values(boards).filter(b=>(b.employeeIds||[]).includes(profile.id));
  const td=today();
  const todayItems=(todos[td]||[]).filter(t=>t.userId===profile.id&&!t.done);
  const week=weekDays(0);
  const openCount=week.reduce((acc,date)=>acc+(todos[date]||[]).filter(t=>t.userId===profile.id&&!t.done).length,0);
  return(
    <div>
      <div style={{marginBottom:28,padding:"28px 32px",background:"linear-gradient(135deg,"+C.blue2+","+C.teal2+")",borderRadius:12,color:"#fff"}}>
        <p style={{fontSize:13,color:"rgba(255,255,255,0.7)",margin:"0 0 4px",letterSpacing:1,textTransform:"uppercase"}}>Hallo, {(profile.first_name||profile.name||"").split(" ")[0]}</p>
        <h1 style={{fontFamily:SR,fontSize:30,fontWeight:400,color:"#fff",margin:"0 0 8px"}}>Schön, dass du da bist!</h1>
        <p style={{fontSize:14,color:"rgba(255,255,255,0.7)",margin:0,fontStyle:"italic"}}>"{getDailyQuote()}"</p>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(260px,1fr))",gap:18,marginBottom:20}}>
        <Panel><H2>Offene To-Dos diese Woche</H2><div style={{fontFamily:SR,fontSize:46,color:openCount>0?C.blue1:C.muted,lineHeight:1,marginBottom:5}}>{openCount}</div><div style={{fontSize:13,color:C.muted,marginBottom:14}}>offene Aufgaben</div>{todayItems.length>0&&<div><div style={{fontSize:11,fontWeight:700,color:C.muted,textTransform:"uppercase",letterSpacing:1,marginBottom:7}}>Heute</div>{todayItems.slice(0,4).map((t,i)=><div key={i} style={{display:"flex",alignItems:"center",gap:8,padding:"6px 0",borderBottom:"1px solid "+C.border}}><span style={{fontSize:12,color:C.blue1}}>○</span><span style={{fontSize:13,color:C.text}}>{t.text}</span></div>)}</div>}</Panel>
        <Panel><H2>Meine Projekte</H2>{myBoards.slice(0,5).map(b=>(<div key={b.id} onClick={()=>onOpen(b.id)} style={{display:"flex",alignItems:"center",gap:9,padding:"8px 10px",borderRadius:6,cursor:"pointer",marginBottom:3,border:"1px solid transparent",transition:"all .15s"}} onMouseEnter={e=>{e.currentTarget.style.borderColor=C.blue1;e.currentTarget.style.background=C.accentLight;}} onMouseLeave={e=>{e.currentTarget.style.borderColor="transparent";e.currentTarget.style.background="transparent";}}><span style={{fontSize:14,color:C.blue1,fontWeight:700}}>{b.icon||"AP"}</span><span style={{fontSize:13,color:C.text,flex:1}}>{b.name}</span>{b.internal&&<Tag color={C.blue2}>INTERN</Tag>}</div>))}</Panel>
      </div>
    </div>
  );
}

function AdminDash({profile,profiles,boards,todos,meetings,prospects,notifications,personalTodos,onOpen,onToggleTodo}){
  const pendingReviews=Object.values(boards).reduce((s,b)=>s+b.colOrder.reduce((s2,cid)=>s2+b.columns[cid].cards.reduce((s3,c)=>s3+(c.reviews||[]).filter(r=>r.status==="pending").length,0),0),0);
  const todayMeetings=[
    ...meetings.filter(m=>m.date===today()&&!m.done),
    ...(prospects||[]).filter(p=>p.date===today()).map(p=>({
      id:p.id,
      topic:p.topic,
      date:p.date,
      with:null,
      meetLink:p.meet_link||p.meetLink||"",
      type:"prospect",
      personName:p.name+(p.company?" ("+p.company+")":""),
    })),
  ];
  const employees=profiles.filter(p=>p.role==="employee");
  const week=weekDays(0);
  function getOpen(uid2){return week.reduce((acc,date)=>acc+(todos[date]||[]).filter(t=>t.userId===uid2&&!t.done).length,0);}
  const myOpen=personalTodos.filter(t=>!t.done).slice(0,6);
  return(
    <div>
      <div style={{marginBottom:28,padding:"28px 32px",background:"linear-gradient(135deg,"+C.navBg+","+C.blue2+")",borderRadius:12,color:"#fff"}}>
        <p style={{fontSize:13,color:"rgba(255,255,255,0.6)",margin:"0 0 4px",letterSpacing:1,textTransform:"uppercase"}}>Hallo, {(profile.first_name||profile.name||"").split(" ")[0]}</p>
        <h1 style={{fontFamily:SR,fontSize:30,fontWeight:400,color:"#fff",margin:"0 0 8px"}}>Willkommen zurück im Strategieraum</h1>
        <p style={{fontSize:14,color:"rgba(255,255,255,0.65)",margin:0,fontStyle:"italic"}}>"{getDailyQuote()}"</p>
      </div>
      {pendingReviews>0&&<div style={{background:"#fffbeb",border:"1.5px solid #f0c040",borderRadius:10,padding:"14px 20px",marginBottom:18,display:"flex",alignItems:"center",gap:12}}><span style={{fontSize:22}}>⚠</span><div><div style={{fontFamily:SR,fontSize:16,color:C.text}}>{pendingReviews} offene Abnahme-Anfragen</div></div></div>}
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(260px,1fr))",gap:18,marginBottom:18}}>
        <Panel>
          <H2>Meine To-Dos</H2>
          {myOpen.length===0&&<p style={{color:C.muted,fontSize:13}}>Keine offenen To-Dos.</p>}
          {myOpen.map(t=>{
            const dashLabels=(()=>{try{const s=localStorage.getItem("ptodo_labels");return s?JSON.parse(s):[];}catch{return [];}})();
            const lbl=dashLabels.find(l=>l.id===(t.label||t.labelId||""));
            const isMeetLink=t.text&&t.text.startsWith("📅");
            return(
              <div key={t.id} style={{display:"flex",alignItems:"flex-start",gap:10,padding:"7px 0",borderBottom:"1px solid "+C.border}}>
                <input type="checkbox" checked={t.done} onChange={()=>onToggleTodo(t.id)} style={{accentColor:C.blue1,cursor:"pointer",flexShrink:0,marginTop:3}}/>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{fontSize:13,color:C.text,textDecoration:t.done?"line-through":"none",wordBreak:"break-word"}}>{t.text}</div>
                  <div style={{display:"flex",gap:6,marginTop:3,flexWrap:"wrap",alignItems:"center"}}>
                    {lbl&&<span style={{fontSize:10,fontWeight:700,padding:"1px 6px",borderRadius:99,background:lbl.color+"22",color:lbl.color,border:"1px solid "+lbl.color+"44"}}>{lbl.name}</span>}
                    {t.date&&<span style={{fontSize:10,color:C.muted}}>📅 {t.date}</span>}
                    {t.due&&<span style={{fontSize:10,color:C.muted}}>Fällig: {t.due}</span>}
                  </div>
                </div>
              </div>
            );
          })}
        </Panel>
        <Panel>
          <H2>Gespräche heute</H2>
          {todayMeetings.length===0&&<p style={{color:C.muted,fontSize:13}}>Keine Gespräche heute.</p>}
          {todayMeetings.map(m=>{
            const person=profiles.find(p=>p.id===m.with);
            const displayName=m.personName||(person?person.name:"");
            const link=m.meetLink||m.meet_link||"";
            const tagColor=m.type==="client"?C.teal1:m.type==="prospect"?"#9B59B6":C.blue2;
            const tagLabel=m.type==="client"?"Kunde":m.type==="prospect"?"Interessent":"Mitarbeiter";
            return(
              <div key={m.id} style={{display:"flex",alignItems:"flex-start",gap:10,padding:"9px 0",borderBottom:"1px solid "+C.border}}>
                {person&&<Av name={person.name} color={person.color} size={32}/>}
                {!person&&m.type==="prospect"&&<div style={{width:32,height:32,borderRadius:"50%",background:"#9B59B6",display:"flex",alignItems:"center",justifyContent:"center",color:"#fff",fontSize:13,fontWeight:700,flexShrink:0}}>{(m.personName||"?")[0]}</div>}
                <div style={{flex:1}}>
                  <div style={{fontFamily:SR,fontSize:14,color:C.text}}>{m.topic}</div>
                  <div style={{fontSize:11,color:C.muted}}>{displayName}</div>
                  {link&&<a href={link} target="_blank" rel="noreferrer" style={{fontSize:12,color:C.blue1,fontWeight:700,display:"inline-flex",alignItems:"center",gap:4,marginTop:4,padding:"3px 10px",background:C.accentLight,borderRadius:4}}>🎥 Meet beitreten</a>}
                </div>
                <Tag color={tagColor}>{tagLabel}</Tag>
              </div>
            );
          })}
        </Panel>
      </div>
      <Panel>
        <H2>Mitarbeiter · Offene To-Dos</H2>
        {employees.map(emp=>{const open=getOpen(emp.id);return(<div key={emp.id} style={{display:"flex",alignItems:"center",gap:10,padding:"9px 0",borderBottom:"1px solid "+C.border}}><Av name={emp.name} color={emp.color} size={34}/><div style={{flex:1}}><div style={{fontFamily:SR,fontSize:14,color:C.text}}>{emp.name}</div></div><div style={{textAlign:"right"}}><div style={{fontFamily:SR,fontSize:24,color:open>0?C.blue1:C.muted,lineHeight:1}}>{open}</div><div style={{fontSize:10,color:C.muted}}>offen</div></div></div>);})}
      </Panel>
    </div>
  );
}
